/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AgentAction_Key: any;
  AgentAction_Parameter: any;
  Date: any;
  License_Parameter: any;
  Long: any;
  Settings_Value: any;
  Timestamp: any;
  UUID: any;
};

export type Action_Agent = {
  agentId?: InputMaybe<Scalars['String']>;
  coordinatorId?: InputMaybe<Scalars['String']>;
};

export enum Action_Type {
  AdvancedSettings = 'AdvancedSettings',
  AgentClearCache = 'AgentClearCache',
  AgentUpdateVersion = 'AgentUpdateVersion',
  AllowEnableAgent = 'AllowEnableAgent',
  EnableAgent = 'EnableAgent',
  ReleaseCloud = 'ReleaseCloud',
  RemoveAgent = 'RemoveAgent',
  ResizeAgentCache = 'ResizeAgentCache',
  SetAgentAssignPriority = 'SetAgentAssignPriority',
  SetAgentLoggingLevel = 'SetAgentLoggingLevel',
  SetAgentPriority = 'SetAgentPriority',
  SetBuildGroup = 'SetBuildGroup',
  SetBuildPriority = 'SetBuildPriority',
  SetHostComment = 'SetHostComment',
}

export type Agent = {
  __typename?: 'Agent';
  agentVersion?: Maybe<Agent_Version>;
  allowEnableDisable?: Maybe<Scalars['Boolean']>;
  assignPriority?: Maybe<Agent_AssignPriority>;
  assignedToInitiator?: Maybe<Scalars['String']>;
  buildCacheSettings?: Maybe<Agent_BuildCacheSettings>;
  buildGroup?: Maybe<Scalars['String']>;
  buildPriority?: Maybe<Scalars['String']>;
  cloud?: Maybe<Agent_Cloud>;
  cluster?: Maybe<Scalars['String']>;
  coordinatorId?: Maybe<Scalars['String']>;
  coresUsed?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['String']>;
  hostComment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  lastConnected?: Maybe<Scalars['String']>;
  lastOnlineChange?: Maybe<Scalars['String']>;
  license?: Maybe<Agent_License>;
  logLevel?: Maybe<Scalars['Int']>;
  loggedUsers?: Maybe<Scalars['String']>;
  macAddress?: Maybe<Scalars['String']>;
  metadata?: Maybe<Agent_Metadata>;
  msvcVersion?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  netFrameworkVersion?: Maybe<Scalars['String']>;
  networkDescription?: Maybe<Scalars['String']>;
  networkInfo?: Maybe<Scalars['String']>;
  osVersion?: Maybe<Scalars['String']>;
  performance?: Maybe<Agent_Performance>;
  port?: Maybe<Scalars['Int']>;
  remoteTaskPriority?: Maybe<Scalars['String']>;
  routingIP?: Maybe<Scalars['String']>;
  runningBuildsTitles?: Maybe<Array<Maybe<Scalars['String']>>>;
  securedPort?: Maybe<Scalars['Int']>;
  status?: Maybe<Agent_Status>;
  type?: Maybe<Agent_Type>;
  upTime?: Maybe<Scalars['Timestamp']>;
  updateStatus?: Maybe<Agent_UpdateStatus>;
  warnings?: Maybe<Scalars['String']>;
  workingFor?: Maybe<Scalars['String']>;
};

export type AgentSettings = {
  __typename?: 'AgentSettings';
  allowEnableDisableAsHelper?: Maybe<Scalars['Boolean']>;
  cacheCleanupInterval?: Maybe<Scalars['Int']>;
  ignoreProcesses?: Maybe<Scalars['String']>;
  maxWorkers?: Maybe<Scalars['Int']>;
  minDiskFree?: Maybe<Scalars['Int']>;
  minIdleLevel?: Maybe<Scalars['Int']>;
  minPhysicalMemory?: Maybe<Scalars['Int']>;
  minVirtualMemory?: Maybe<Scalars['Int']>;
  offlineFloatingAgentsPeriod?: Maybe<Scalars['Int']>;
  reportInterval?: Maybe<Scalars['Int']>;
  runCacheCleanup?: Maybe<Scalars['Boolean']>;
  showOfflineFloatingAgents?: Maybe<Scalars['Boolean']>;
};

export type Agent_ActionInput = {
  action?: InputMaybe<Action_Type>;
  agents?: InputMaybe<Array<InputMaybe<Action_Agent>>>;
  key?: InputMaybe<Scalars['AgentAction_Key']>;
  parameter?: InputMaybe<Scalars['AgentAction_Parameter']>;
};

export type Agent_ActionResult = {
  __typename?: 'Agent_ActionResult';
  agentId?: Maybe<Scalars['String']>;
  agentName?: Maybe<Scalars['String']>;
  errorCode?: Maybe<Agent_ActionResultErrorCodes>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export enum Agent_ActionResultErrorCodes {
  ActionsOnSingleUseAgentAreNotAllowedError = 'ActionsOnSingleUseAgentAreNotAllowedError',
  AgentIsNotHelperError = 'AgentIsNotHelperError',
  AgentIsNotOfflineError = 'AgentIsNotOfflineError',
  AgentIsOfflineError = 'AgentIsOfflineError',
  AgentIsOnlineError = 'AgentIsOnlineError',
  DuplicateLicenseError = 'DuplicateLicenseError',
  NotCloudAgentError = 'NotCloudAgentError',
  NotDuplicateLicenseError = 'NotDuplicateLicenseError',
  UnsubscribeNotSupportedError = 'UnsubscribeNotSupportedError',
  VersionUpdateIsNotRequiredError = 'VersionUpdateIsNotRequiredError',
  VersionUpdateIsRequiredError = 'VersionUpdateIsRequiredError',
}

export type Agent_Action_AsyncResult = {
  __typename?: 'Agent_Action_AsyncResult';
  result?: Maybe<Array<Maybe<Agent_ActionResult>>>;
};

export type Agent_ActiveHelpers = {
  __typename?: 'Agent_ActiveHelpers';
  activeAgents?: Maybe<Scalars['Int']>;
  activeCloudAgents?: Maybe<Scalars['Int']>;
  activeCoresCloud?: Maybe<Scalars['Int']>;
  activeCoresLocal?: Maybe<Scalars['Int']>;
  activeCoresRemote?: Maybe<Scalars['Int']>;
};

export type Agent_ActiveInfo = {
  __typename?: 'Agent_ActiveInfo';
  activeBuilds?: Maybe<Scalars['Int']>;
  activeHelpers?: Maybe<Agent_ActiveHelpers>;
  onlineHelpers?: Maybe<Agent_OnlineHelpers>;
};

export type Agent_AgentsMetadata = {
  __typename?: 'Agent_AgentsMetadata';
  agentCores?: Maybe<Array<Maybe<Scalars['Int']>>>;
  initiatorsCount?: Maybe<Scalars['Int']>;
  maxHelperCacheSize?: Maybe<Scalars['Int']>;
};

export type Agent_AgentsResult = {
  __typename?: 'Agent_AgentsResult';
  agents?: Maybe<Array<Maybe<Agent>>>;
  totalCount?: Maybe<Scalars['Int']>;
  totalFilteredCount?: Maybe<Scalars['Int']>;
};

export enum Agent_AssignPriority {
  AboveNormalAssignPriority = 'AboveNormalAssignPriority',
  BelowNormalAssignPriority = 'BelowNormalAssignPriority',
  HighAssignPriority = 'HighAssignPriority',
  LowAssignPriority = 'LowAssignPriority',
  NormalAssignPriority = 'NormalAssignPriority',
}

export type Agent_BuildCacheSettings = {
  __typename?: 'Agent_BuildCacheSettings';
  cacheFolder?: Maybe<Scalars['String']>;
  cacheSettingsDisplay?: Maybe<Cache_Settings_Display>;
  cacheSizeGB?: Maybe<Scalars['Int']>;
  databaseFolder?: Maybe<Scalars['String']>;
  localBCServicePort?: Maybe<Scalars['Int']>;
  remoteCacheServer?: Maybe<Scalars['String']>;
  useBuildCacheCluster?: Maybe<Scalars['Boolean']>;
  useLocalCache?: Maybe<Scalars['Boolean']>;
};

export type Agent_BuildCacheSettingsInput = {
  agents?: InputMaybe<Array<InputMaybe<Action_Agent>>>;
  cacheFolder?: InputMaybe<Scalars['String']>;
  cacheSizeGB?: InputMaybe<Scalars['Int']>;
  databaseFolder?: InputMaybe<Scalars['String']>;
};

export type Agent_ChangesWhereInput = {
  coordinatorId?: InputMaybe<Scalars['String']>;
};

export type Agent_Cloud = {
  __typename?: 'Agent_Cloud';
  cacheSize?: Maybe<Scalars['Int']>;
  hdType?: Maybe<Scalars['String']>;
  isPool?: Maybe<Scalars['Boolean']>;
  machineStatus?: Maybe<Scalars['String']>;
  numberOfCores?: Maybe<Scalars['Int']>;
  spot?: Maybe<Scalars['Boolean']>;
  vmType?: Maybe<Scalars['String']>;
  volumeSize?: Maybe<Scalars['Int']>;
  zone?: Maybe<Scalars['String']>;
};

export enum Agent_EnabledAsHelper {
  Disabled = 'Disabled',
  Enabled = 'Enabled',
}

export enum Agent_HelperPermissions {
  AllowedToEnableDisable = 'AllowedToEnableDisable',
  NotAllowedToEnableDisable = 'NotAllowedToEnableDisable',
}

export type Agent_License = {
  __typename?: 'Agent_License';
  buildCacheAllowed?: Maybe<Scalars['Boolean']>;
  ciInitiatorType?: Maybe<License_RegistrationType>;
  helperCores?: Maybe<Scalars['Int']>;
  helperType?: Maybe<License_RegistrationType>;
  initiatorCores?: Maybe<Scalars['Int']>;
  initiatorQueued?: Maybe<Scalars['Boolean']>;
  initiatorType?: Maybe<License_RegistrationType>;
  registeredCores?: Maybe<Scalars['Int']>;
  registeredInitiator?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export enum Agent_LicenseFilter {
  CloudHelper = 'CloudHelper',
  FixedLicense = 'FixedLicense',
  FloatingLicense = 'FloatingLicense',
  HelperAndCiInitiator = 'HelperAndCIInitiator',
  HelperAndInitiator = 'HelperAndInitiator',
  NoLicense = 'NoLicense',
  OnPremHelper = 'OnPremHelper',
  OnlyCiInitiator = 'OnlyCIInitiator',
  OnlyInitiator = 'OnlyInitiator',
  WithBuildCache = 'WithBuildCache',
  WithoutBuildCache = 'WithoutBuildCache',
}

export enum Agent_LogLevel {
  Basic = 'Basic',
  Detailed = 'Detailed',
  Extended = 'Extended',
  Intermediate = 'Intermediate',
  Minimal = 'Minimal',
}

export type Agent_Metadata = {
  __typename?: 'Agent_Metadata';
  agentType?: Maybe<Agent_Type>;
  isBuildAvoidance?: Maybe<Scalars['Boolean']>;
  isCIInitiator?: Maybe<Scalars['Boolean']>;
  isCIInitiatorPending?: Maybe<Scalars['Boolean']>;
  isCloud?: Maybe<Scalars['Boolean']>;
  isDuplicateLicense?: Maybe<Scalars['Boolean']>;
  isHelper?: Maybe<Scalars['Boolean']>;
  isHelperAndInitiator?: Maybe<Scalars['Boolean']>;
  isHelperDisabled?: Maybe<Scalars['Boolean']>;
  isHelperPending?: Maybe<Scalars['Boolean']>;
  isInProcess?: Maybe<Scalars['Boolean']>;
  isInProgress?: Maybe<Scalars['Boolean']>;
  isIncompatibleVersion?: Maybe<Scalars['Boolean']>;
  isInitiator?: Maybe<Scalars['Boolean']>;
  isInitiatorPending?: Maybe<Scalars['Boolean']>;
  isLastDuplicateLicense?: Maybe<Scalars['Boolean']>;
  isLocal?: Maybe<Scalars['Boolean']>;
  isLowerThanTenVersion?: Maybe<Scalars['Boolean']>;
  isOffline?: Maybe<Scalars['Boolean']>;
  isOnPremHelper?: Maybe<Scalars['Boolean']>;
  isOnline?: Maybe<Scalars['Boolean']>;
  isOnlyHelper?: Maybe<Scalars['Boolean']>;
  isOnlyInitiator?: Maybe<Scalars['Boolean']>;
  isOnlyLocal?: Maybe<Scalars['Boolean']>;
  isSCL?: Maybe<Scalars['Boolean']>;
  isUnlicensed?: Maybe<Scalars['Boolean']>;
  isValidForVersionUpdate?: Maybe<Scalars['Boolean']>;
  isWindowsAgent?: Maybe<Scalars['Boolean']>;
  lastConnectedDate?: Maybe<Scalars['String']>;
};

export enum Agent_Os_VersionFilter {
  Linux = 'Linux',
  Windows = 'Windows',
}

export type Agent_OnlineHelpers = {
  __typename?: 'Agent_OnlineHelpers';
  onlineAgents?: Maybe<Scalars['Int']>;
  onlineCloudAgents?: Maybe<Scalars['Int']>;
};

export type Agent_Paging = {
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type Agent_Performance = {
  __typename?: 'Agent_Performance';
  availCPU?: Maybe<Scalars['Int']>;
  availDisk?: Maybe<Scalars['String']>;
  availMemory?: Maybe<Scalars['String']>;
  availVirt?: Maybe<Scalars['String']>;
  cacheSize?: Maybe<Scalars['Int']>;
  cacheUsed?: Maybe<Scalars['Int']>;
  cpuInfo?: Maybe<Scalars['String']>;
  cpuLogical?: Maybe<Scalars['Int']>;
  cpuPhysical?: Maybe<Scalars['Int']>;
  cpuSpeed?: Maybe<Scalars['Int']>;
  totalDisk?: Maybe<Scalars['String']>;
  totalMemory?: Maybe<Scalars['String']>;
  totalVirt?: Maybe<Scalars['String']>;
  usedCPU?: Maybe<Scalars['Int']>;
};

export enum Agent_QuickFilter {
  All = 'All',
  DuplicateLicense = 'DuplicateLicense',
  InProcess = 'InProcess',
  IncompatibleVersion = 'IncompatibleVersion',
  Online = 'Online',
  UnlicensedAgents = 'UnlicensedAgents',
}

export enum Agent_SearchColumns {
  AgentName = 'AgentName',
  BuildGroup = 'BuildGroup',
  BuildTitle = 'BuildTitle',
  HostComment = 'HostComment',
  Ip = 'IP',
  LoggedUsers = 'LoggedUsers',
  MacAddress = 'MacAddress',
  RoutingIp = 'RoutingIP',
  Status = 'Status',
}

export type Agent_Sort = {
  field: Agent_SortField;
  order: Agent_SortOrder;
};

export enum Agent_SortField {
  Alerts = 'Alerts',
  AssignPriority = 'AssignPriority',
  AssignedToInitiator = 'AssignedToInitiator',
  AvailableCpu = 'AvailableCpu',
  AvailableDiskSpace = 'AvailableDiskSpace',
  AvailableMemory = 'AvailableMemory',
  BuildCache = 'BuildCache',
  BuildGroup = 'BuildGroup',
  BuildPriority = 'BuildPriority',
  CacheSettingsDisplay = 'CacheSettingsDisplay',
  CacheSize = 'CacheSize',
  Cluster = 'Cluster',
  CpuInfo = 'CpuInfo',
  CpuSpeed = 'CpuSpeed',
  HdType = 'HdType',
  HelperCores = 'HelperCores',
  HostComment = 'HostComment',
  Ip = 'IP',
  InitiatorCores = 'InitiatorCores',
  LastConnected = 'LastConnected',
  LicenseStatus = 'LicenseStatus',
  LogLevel = 'LogLevel',
  LoggedOnUser = 'LoggedOnUser',
  LogicalCores = 'LogicalCores',
  MacAddress = 'MacAddress',
  Name = 'Name',
  Network = 'Network',
  NumberOfCores = 'NumberOfCores',
  OsVersion = 'OsVersion',
  PhysicalCores = 'PhysicalCores',
  Port = 'Port',
  RegisteredCores = 'RegisteredCores',
  RoutingIp = 'RoutingIP',
  Spot = 'Spot',
  Status = 'Status',
  Uptime = 'Uptime',
  UsedCpu = 'UsedCpu',
  UsedHelperCache = 'UsedHelperCache',
  Version = 'Version',
  VmType = 'VmType',
  VolumeSize = 'VolumeSize',
  Zone = 'Zone',
}

export enum Agent_SortOrder {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export enum Agent_Status {
  Downloading = 'Downloading',
  Expired = 'Expired',
  Helping = 'Helping',
  Initiating = 'Initiating',
  Installing = 'Installing',
  Offline = 'Offline',
  Ready = 'Ready',
  Stopped = 'Stopped',
  Updating = 'Updating',
}

export enum Agent_Type {
  Aws = 'AWS',
  Azure = 'Azure',
  Cloud = 'Cloud',
  ExpiredSingleUse = 'ExpiredSingleUse',
  GoogleCloud = 'GoogleCloud',
  IncrediBuildSaaS = 'IncrediBuildSaaS',
  Owned = 'Owned',
  SingleUse = 'SingleUse',
}

export type Agent_UpdateStatus = {
  __typename?: 'Agent_UpdateStatus';
  downloadComplete?: Maybe<Scalars['Boolean']>;
  downloadInProgress?: Maybe<Scalars['Boolean']>;
  downloadedBytes?: Maybe<Scalars['Int']>;
  installStarted?: Maybe<Scalars['Boolean']>;
  installStatus?: Maybe<Scalars['String']>;
  quickRollback?: Maybe<Scalars['Boolean']>;
  updateID?: Maybe<Scalars['String']>;
  updateSize?: Maybe<Scalars['Int']>;
  updateToCurrentVersion?: Maybe<Scalars['Boolean']>;
};

export type Agent_Value_Range = {
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
};

export type Agent_Version = {
  __typename?: 'Agent_Version';
  buildVersion?: Maybe<Scalars['Int']>;
  maintenanceVersion?: Maybe<Scalars['Int']>;
  majorVersion?: Maybe<Scalars['Int']>;
  minorVersion?: Maybe<Scalars['Int']>;
  versionText?: Maybe<Scalars['String']>;
};

export type Agent_WhereInput = {
  agentsIdFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availableCpuFilter?: InputMaybe<Agent_Value_Range>;
  buildGroupsFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cacheSizeFilter?: InputMaybe<Agent_Value_Range>;
  coordinatorId?: InputMaybe<Scalars['String']>;
  coresFilter?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  enabledAsHelperFilter?: InputMaybe<Array<InputMaybe<Agent_EnabledAsHelper>>>;
  helperPermissionsFilter?: InputMaybe<Array<InputMaybe<Agent_HelperPermissions>>>;
  licenseFilter?: InputMaybe<Array<InputMaybe<Agent_LicenseFilter>>>;
  logLevelFilter?: InputMaybe<Array<InputMaybe<Agent_LogLevel>>>;
  osVersionFilter?: InputMaybe<Array<InputMaybe<Agent_Os_VersionFilter>>>;
  paging?: InputMaybe<Agent_Paging>;
  quickFilter?: InputMaybe<Agent_QuickFilter>;
  searchByColumns?: InputMaybe<Array<InputMaybe<Agent_SearchColumns>>>;
  searchFilter?: InputMaybe<Scalars['String']>;
  secondarySortField?: InputMaybe<Agent_SortField>;
  sort?: InputMaybe<Agent_Sort>;
  statusFilter?: InputMaybe<Array<InputMaybe<Agent_Status>>>;
  usedCpuFilter?: InputMaybe<Agent_Value_Range>;
};

export type Auth_Result = {
  __typename?: 'Auth_Result';
  result?: Maybe<Auth_Result_Content>;
};

export type Auth_Result_Content = {
  __typename?: 'Auth_Result_Content';
  errorCode?: Maybe<Auth_Result_ErrorCode>;
  status: Scalars['String'];
};

export enum Auth_Result_ErrorCode {
  AuthenticationError = 'AuthenticationError',
  CertificateValidationError = 'CertificateValidationError',
  GeneralError = 'GeneralError',
  InvalidInput = 'InvalidInput',
}

export type Authentication_AuthPayload = {
  __typename?: 'Authentication_AuthPayload';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
  userId: Scalars['Int'];
  userStatus?: Maybe<User_Status>;
};

export type Authentication_AzureAdInput = {
  code: Scalars['String'];
  redirectUri: Scalars['String'];
};

export type Authentication_AzureAdRoute = {
  __typename?: 'Authentication_AzureADRoute';
  redirectUri?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type Authentication_AzureAdRouteInput = {
  redirectUri: Scalars['String'];
};

export type Authentication_AzureAdOrganizationGroupsInput = {
  code: Scalars['String'];
};

export type Authentication_ExternalTypeInput = {
  force?: InputMaybe<Scalars['Boolean']>;
  type: External_Authentication_Type;
};

export type Authentication_LoginOption_AzureAd = {
  __typename?: 'Authentication_LoginOption_AzureAD';
  connected?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type Authentication_LoginOption_Ldap = {
  __typename?: 'Authentication_LoginOption_LDAP';
  connected?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type Authentication_LoginOptions = {
  __typename?: 'Authentication_LoginOptions';
  azureAd?: Maybe<Authentication_LoginOption_AzureAd>;
  ldap?: Maybe<Authentication_LoginOption_Ldap>;
  osType?: Maybe<Scalars['String']>;
};

export type Authentication_LoginUserInput = {
  password: Scalars['String'];
  userName: Scalars['String'];
};

export enum Authentication_OrganizationGroupsErrorCode {
  ActiveDirectoryNotConnected = 'ActiveDirectoryNotConnected',
  Forbidden = 'Forbidden',
  GeneralError = 'GeneralError',
  Unauthorized = 'Unauthorized',
}

export type Authentication_OrganizationGroupsResult = {
  __typename?: 'Authentication_OrganizationGroupsResult';
  errorCode?: Maybe<Authentication_OrganizationGroupsErrorCode>;
  groups?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AzureAdAuthentication = {
  __typename?: 'AzureADAuthentication';
  authenticationType: External_Authentication_Type;
  clientId?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  groupRoleMapping?: Maybe<Array<Maybe<ExternalAuthenticationOrganizationGroupMapping>>>;
  tenantId?: Maybe<Scalars['String']>;
};

export type AzureAdAuthenticationInput = {
  clientId: Scalars['String'];
  clientSecret?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['String'];
};

export type BackupCoordinatorSettings = {
  __typename?: 'BackupCoordinatorSettings';
  backupCoordinatorBuildNumbers?: Maybe<Scalars['String']>;
  backupCoordinatorHosts?: Maybe<Scalars['String']>;
  backupCoordinatorNames?: Maybe<Scalars['String']>;
  backupCoordinatorPorts?: Maybe<Scalars['String']>;
  backupCoordinatorSyncFrequency?: Maybe<Scalars['Int']>;
  backupCoordinatorTimeout?: Maybe<Scalars['Int']>;
  isOnline?: Maybe<Scalars['Boolean']>;
  isSameVersion?: Maybe<Scalars['Boolean']>;
  otherCoordinatorBuildNumber?: Maybe<Scalars['Int']>;
  otherCoordinatorHost?: Maybe<Scalars['String']>;
  otherCoordinatorName?: Maybe<Scalars['String']>;
  otherCoordinatorPort?: Maybe<Scalars['Int']>;
};

export type BuildGroup = {
  __typename?: 'BuildGroup';
  agentCount?: Maybe<Scalars['Int']>;
  cloudEnabled?: Maybe<Scalars['Boolean']>;
  hasRunningBuild?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type BuildGroup_AddInput = {
  buildGroup: Scalars['String'];
  coordinatorId: Scalars['String'];
};

export type BuildGroup_AsyncResult = {
  __typename?: 'BuildGroup_AsyncResult';
  result?: Maybe<BuildGroup_Result>;
};

export type BuildGroup_DeleteInput = {
  buildGroupId: Scalars['String'];
  coordinatorId: Scalars['String'];
};

export type BuildGroup_EditInput = {
  buildGroupId: Scalars['String'];
  cloudEnabled?: InputMaybe<Scalars['Boolean']>;
  coordinatorId: Scalars['String'];
  newBuildGroup?: InputMaybe<Scalars['String']>;
};

export type BuildGroup_Result = {
  __typename?: 'BuildGroup_Result';
  applicationErrorCode?: Maybe<Scalars['Int']>;
  buildGroupId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type BuildGroups_Input = {
  checkRunningBuilds?: InputMaybe<Scalars['Boolean']>;
};

export type BuildGroups_WhereInput = {
  coordinatorId?: InputMaybe<Scalars['String']>;
};

export type Build_LongestTask = {
  __typename?: 'Build_LongestTask';
  duration?: Maybe<Scalars['Long']>;
  durationPercentage?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  machineName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Build_Performance = {
  __typename?: 'Build_Performance';
  avgHelperCores?: Maybe<Scalars['Float']>;
  avgHelperMachines?: Maybe<Scalars['Float']>;
  cacheTaskHits?: Maybe<Scalars['Int']>;
  cacheTaskHitsPercentage?: Maybe<Scalars['Float']>;
  cacheTaskMiss?: Maybe<Scalars['Int']>;
  cacheTaskMissPercentage?: Maybe<Scalars['Float']>;
  cacheableTasks?: Maybe<Scalars['Int']>;
  cacheableTasksPercentage?: Maybe<Scalars['Float']>;
  distributableTasks?: Maybe<Scalars['Int']>;
  distributedCpuTime?: Maybe<Scalars['Long']>;
  distributedCpuTimePercentage?: Maybe<Scalars['Float']>;
  isBuildCache?: Maybe<Scalars['Boolean']>;
  localTasks?: Maybe<Scalars['Int']>;
  localTasksPercentage?: Maybe<Scalars['Float']>;
  longestTasks?: Maybe<Array<Maybe<Build_LongestTask>>>;
  maxHelperCores?: Maybe<Scalars['Int']>;
  maxHelperMachines?: Maybe<Scalars['Int']>;
  nonDistributableTasks?: Maybe<Scalars['Int']>;
  readyOverActiveRatio?: Maybe<Scalars['Float']>;
  remoteTasks?: Maybe<Scalars['Int']>;
  remoteTasksPercentage?: Maybe<Scalars['Float']>;
  tasksDistribution?: Maybe<Build_TasksDistribution>;
  totalCpuTime?: Maybe<Scalars['Long']>;
  totalTasks?: Maybe<Scalars['Int']>;
  uncacheableTasks?: Maybe<Scalars['Int']>;
  uncacheableTasksPercentage?: Maybe<Scalars['Float']>;
};

export type Build_Summary = {
  __typename?: 'Build_Summary';
  buildGroup?: Maybe<Scalars['String']>;
  buildTarget?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Long']>;
  endTime?: Maybe<Scalars['Date']>;
  errorsNumber?: Maybe<Scalars['Int']>;
  failReason?: Maybe<Builds_BuildFailReason>;
  ibVersion?: Maybe<Scalars['String']>;
  initiatorDescription?: Maybe<Scalars['String']>;
  initiatorLogLevel?: Maybe<Scalars['Int']>;
  isBuildCache?: Maybe<Scalars['Boolean']>;
  isCloudHelpers?: Maybe<Scalars['Boolean']>;
  isPredictiveExecution?: Maybe<Scalars['Boolean']>;
  startTime?: Maybe<Scalars['Date']>;
  sysErrorsNumber?: Maybe<Scalars['Int']>;
  sysWarningsNumber?: Maybe<Scalars['Int']>;
  totalTasks?: Maybe<Scalars['Int']>;
  warningsNumber?: Maybe<Scalars['Int']>;
  workingDir?: Maybe<Scalars['String']>;
};

export type Build_TasksDistribution = {
  __typename?: 'Build_TasksDistribution';
  localTasks?: Maybe<Build_TasksStatusCount>;
  remoteTasks?: Maybe<Build_TasksStatusCount>;
};

export type Build_TasksStatusCount = {
  __typename?: 'Build_TasksStatusCount';
  failed?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Int']>;
  warning?: Maybe<Scalars['Int']>;
};

export type Builds_Build = {
  __typename?: 'Builds_Build';
  agentDescription?: Maybe<Scalars['String']>;
  avgBusyHelpersCores?: Maybe<Scalars['Float']>;
  buildGroup?: Maybe<Scalars['String']>;
  buildId?: Maybe<Scalars['String']>;
  buildResult?: Maybe<Builds_BuildResult>;
  buildType?: Maybe<Builds_BuildType>;
  cacheTaskHits?: Maybe<Scalars['Int']>;
  cacheTaskMiss?: Maybe<Scalars['Int']>;
  cloudTasks?: Maybe<Scalars['Int']>;
  commandLine?: Maybe<Scalars['String']>;
  distributableTasks?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Long']>;
  endTime?: Maybe<Scalars['Date']>;
  failReason?: Maybe<Builds_BuildFailReason>;
  failedTasks?: Maybe<Scalars['Int']>;
  hasExtendedData?: Maybe<Scalars['Boolean']>;
  initiatorName?: Maybe<Scalars['String']>;
  initiatorType?: Maybe<Scalars['String']>;
  localTasks?: Maybe<Scalars['Int']>;
  loggedOnUsers?: Maybe<Scalars['String']>;
  loggingLevel?: Maybe<Scalars['Int']>;
  maxBusyHelpersCores?: Maybe<Scalars['Int']>;
  maxNeededHelpersCores?: Maybe<Scalars['Int']>;
  readyOverActiveRatio?: Maybe<Scalars['Float']>;
  remoteTasks?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  totalTasks?: Maybe<Scalars['Int']>;
  uncacheableTasks?: Maybe<Scalars['Int']>;
};

export type Builds_BuildDetails = {
  __typename?: 'Builds_BuildDetails';
  buildPerformance?: Maybe<Build_Performance>;
  buildSummary?: Maybe<Build_Summary>;
};

export type Builds_BuildDetailsWhereInput = {
  buildId?: InputMaybe<Scalars['String']>;
  coordinatorId?: InputMaybe<Scalars['String']>;
};

export enum Builds_BuildFailReason {
  CancelledByUser = 'CancelledByUser',
  Failure = 'Failure',
  ForcedStop = 'ForcedStop',
  MaxConcurrentBuilds = 'MaxConcurrentBuilds',
  NotEnoughCores = 'NotEnoughCores',
  Pending = 'Pending',
  SystemError = 'SystemError',
}

export enum Builds_BuildResult {
  Canceled = 'Canceled',
  Failed = 'Failed',
  Success = 'Success',
}

export enum Builds_BuildType {
  Build = 'Build',
  Clean = 'Clean',
  Rebuild = 'Rebuild',
  Unknown = 'Unknown',
}

export type Builds_BuildsMetadataWhereInput = {
  coordinatorId?: InputMaybe<Scalars['String']>;
  overlappingTimeframes: Scalars['Boolean'];
  timeframes: Array<Builds_TimeFrame>;
};

export type Builds_BuildsWhereInput = {
  buildGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buildId?: InputMaybe<Scalars['String']>;
  buildResult?: InputMaybe<Array<InputMaybe<Builds_BuildResult>>>;
  buildType?: InputMaybe<Array<InputMaybe<Builds_BuildType>>>;
  coordinatorId?: InputMaybe<Scalars['String']>;
  durationFrom?: InputMaybe<Scalars['Int']>;
  durationTo?: InputMaybe<Scalars['Int']>;
  initiatorType?: InputMaybe<Array<InputMaybe<Builds_InitiatorType>>>;
  overlappingTimeframes?: InputMaybe<Scalars['Boolean']>;
  paging: Builds_Paging;
  searchFilter?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Builds_Sort>;
  timeZone?: InputMaybe<Scalars['String']>;
  timeframes?: InputMaybe<Array<Builds_TimeFrame>>;
};

export enum Builds_InitiatorType {
  Ci = 'CI',
  Developer = 'Developer',
  MissingLicense = 'MissingLicense',
}

export type Builds_Metadata = {
  __typename?: 'Builds_Metadata';
  buildGroups?: Maybe<Array<Maybe<Scalars['String']>>>;
  hasBuildCache?: Maybe<Scalars['Boolean']>;
  initiatorTypes?: Maybe<Array<Maybe<Builds_InitiatorType>>>;
  maxDuration?: Maybe<Scalars['Int']>;
  oldestBuildStartTime?: Maybe<Scalars['Date']>;
};

export type Builds_Paging = {
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type Builds_Result = {
  __typename?: 'Builds_Result';
  builds?: Maybe<Array<Maybe<Builds_Build>>>;
  totalCount?: Maybe<Scalars['Int']>;
  totalFilteredCount?: Maybe<Scalars['Int']>;
};

export type Builds_Sort = {
  field: Builds_SortField;
  order: Builds_SortOrder;
};

export enum Builds_SortField {
  AgentDescription = 'AgentDescription',
  AvgBusyHelpersCores = 'AvgBusyHelpersCores',
  BuildGroup = 'BuildGroup',
  BuildResult = 'BuildResult',
  BuildTitle = 'BuildTitle',
  BuiltType = 'BuiltType',
  CacheTaskHits = 'CacheTaskHits',
  CacheTaskMiss = 'CacheTaskMiss',
  CloudTasks = 'CloudTasks',
  CommandLine = 'CommandLine',
  DistributableTasks = 'DistributableTasks',
  Duration = 'Duration',
  FailReason = 'FailReason',
  FailedTasks = 'FailedTasks',
  InitiatorName = 'InitiatorName',
  InitiatorType = 'InitiatorType',
  LocalTasks = 'LocalTasks',
  LoggedOnUsers = 'LoggedOnUsers',
  LoggingLevel = 'LoggingLevel',
  MaxBusyHelpersCores = 'MaxBusyHelpersCores',
  MaxNeededHelpersCores = 'MaxNeededHelpersCores',
  ReadyOverActiveRatio = 'ReadyOverActiveRatio',
  RemoteTasks = 'RemoteTasks',
  StartTime = 'StartTime',
  TotalTasks = 'TotalTasks',
  UncacheableTasks = 'UncacheableTasks',
}

export enum Builds_SortOrder {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export type Builds_Summary = {
  __typename?: 'Builds_Summary';
  percentile50?: Maybe<Scalars['Int']>;
  percentile90?: Maybe<Scalars['Int']>;
  successfulBuilds?: Maybe<Scalars['Int']>;
  totalBuilds?: Maybe<Scalars['Int']>;
  uniqueInitiators?: Maybe<Scalars['Int']>;
};

export type Builds_SummaryWhereInput = {
  coordinatorId?: InputMaybe<Scalars['String']>;
  overlappingTimeframes: Scalars['Boolean'];
  timeframes: Array<Builds_TimeFrame>;
};

export type Builds_TimeFrame = {
  endTime: Scalars['Date'];
  startTime: Scalars['Date'];
};

export type Cache_Settings_Display = {
  __typename?: 'Cache_Settings_Display';
  cacheRemoteValue?: Maybe<Scalars['String']>;
  cacheType?: Maybe<Scalars['String']>;
};

export type CloudLicense = {
  __typename?: 'CloudLicense';
  activationDate?: Maybe<Scalars['Timestamp']>;
  coordSpecificCacheConsumption?: Maybe<Scalars['Long']>;
  coordSpecificConsumption?: Maybe<Scalars['Long']>;
  coordinatorId: Scalars['String'];
  expirationDate?: Maybe<Scalars['Timestamp']>;
  hasBuildCache?: Maybe<Scalars['Boolean']>;
  licenseDetails?: Maybe<Cloud_LicenseDetails>;
  licenseId?: Maybe<Scalars['String']>;
  licenseStatus?: Maybe<Scalars['String']>;
  licenseType?: Maybe<Scalars['String']>;
  nextLicense?: Maybe<NextCloudLicense>;
  totalCacheConsumption?: Maybe<Scalars['Long']>;
  totalLicenseConsumption?: Maybe<Scalars['Long']>;
};

export type CloudSettings = {
  __typename?: 'CloudSettings';
  cloudCoordinatorId?: Maybe<Scalars['String']>;
  cloudStatus?: Maybe<Scalars['String']>;
};

export type Cloud_ActionInput = {
  action?: InputMaybe<Cloud_Action_Type>;
  coordinatorId?: InputMaybe<Scalars['String']>;
};

export type Cloud_Action_AsyncResult = {
  __typename?: 'Cloud_Action_AsyncResult';
  result?: Maybe<Cloud_Response>;
};

export enum Cloud_Action_Type {
  Deactivate = 'Deactivate',
  Pause = 'Pause',
  PauseAndDelete = 'PauseAndDelete',
  Resume = 'Resume',
}

export type Cloud_Data = {
  __typename?: 'Cloud_Data';
  coordinatorId?: Maybe<Scalars['String']>;
  pool?: Maybe<Cloud_Data_Pool>;
};

export type Cloud_Data_Pool = {
  __typename?: 'Cloud_Data_Pool';
  alive?: Maybe<Scalars['Int']>;
  deallocated?: Maybe<Scalars['Int']>;
  delivered?: Maybe<Scalars['Int']>;
  initializing?: Maybe<Scalars['Int']>;
  poolSum?: Maybe<Scalars['Int']>;
  ready?: Maybe<Scalars['Int']>;
  wakeingup?: Maybe<Scalars['Int']>;
};

export type Cloud_Data_Pool_Deallocated = {
  __typename?: 'Cloud_Data_Pool_Deallocated';
  deallocated?: Maybe<Scalars['Int']>;
};

export type Cloud_LicenseDetails = {
  __typename?: 'Cloud_LicenseDetails';
  quantity?: Maybe<Scalars['Int']>;
};

export type Cloud_Response = {
  __typename?: 'Cloud_Response';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type Cloud_SetSecretInput = {
  coordinatorId?: InputMaybe<Scalars['String']>;
  secret?: InputMaybe<Scalars['String']>;
};

export type Cloud_UrlResult = {
  __typename?: 'Cloud_UrlResult';
  cloudUrl?: Maybe<Scalars['String']>;
  redirectPath?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type Cloud_Wakeup_ActionInput = {
  coordinatorId: Scalars['String'];
  coreCount?: InputMaybe<Scalars['Int']>;
};

export type Cloud_Wakeup_Machine_ActionInput = {
  coordinatorId: Scalars['String'];
  machineId?: InputMaybe<Scalars['String']>;
};

export type Cluster = {
  __typename?: 'Cluster';
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  nodes?: Maybe<Array<Maybe<Cluster_Nodes>>>;
};

export type Cluster_Add_Node_Result = {
  __typename?: 'Cluster_Add_Node_Result';
  agentId?: Maybe<Scalars['String']>;
  agentName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type Cluster_Add_Nodes_Result = {
  __typename?: 'Cluster_Add_Nodes_Result';
  result?: Maybe<Array<Maybe<Cluster_Add_Node_Result>>>;
};

export type Cluster_Nodes = {
  __typename?: 'Cluster_Nodes';
  agentId: Scalars['String'];
  port?: Maybe<Scalars['Int']>;
};

export type Cluster_Nodes_AddInput = {
  agents?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clusterId: Scalars['Int'];
};

export type Cluster_Nodes_RemoveInput = {
  agents?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Cluster_Nodes_WhereInput = {
  clusterId?: InputMaybe<Scalars['Int']>;
  hasNodes?: InputMaybe<Scalars['Boolean']>;
};

export type Cluster_Remove_Nodes_Result = {
  __typename?: 'Cluster_Remove_Nodes_Result';
  status?: Maybe<Scalars['String']>;
};

export type CommonSettings = {
  __typename?: 'CommonSettings';
  auth?: Maybe<Settings_ExternalAuth>;
  backup: BackupCoordinatorSettings;
  cloud?: Maybe<CloudSettings>;
  ibManager?: Maybe<IbManagerSettings>;
};

export type CoordinatorSettings = {
  __typename?: 'CoordinatorSettings';
  agentCommunicationPort?: Maybe<Scalars['Int']>;
  agentCommunicationSSLPort?: Maybe<Scalars['Int']>;
  agentsUseSecureCommunication?: Maybe<Scalars['Boolean']>;
  restServicePort?: Maybe<Scalars['Int']>;
  sslCNValidationPattern?: Maybe<Scalars['String']>;
};

export type Coordinator_Info = {
  __typename?: 'Coordinator_Info';
  buildVersion?: Maybe<Scalars['Int']>;
  coordinatorId?: Maybe<Scalars['String']>;
  maintenanceVersion?: Maybe<Scalars['Int']>;
  majorVersion?: Maybe<Scalars['Int']>;
  minorVersion?: Maybe<Scalars['Int']>;
  runningSince?: Maybe<Scalars['Date']>;
  versionText?: Maybe<Scalars['String']>;
};

export type Coordinator_Result = {
  __typename?: 'Coordinator_Result';
  coordinatorId?: Maybe<Scalars['String']>;
};

export type Dashboard_ActiveHelperMachines = {
  __typename?: 'Dashboard_ActiveHelperMachines';
  cloud?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
  onPrem?: Maybe<Scalars['Int']>;
};

export type Dashboard_ActiveInitiatorMachines = {
  __typename?: 'Dashboard_ActiveInitiatorMachines';
  date?: Maybe<Scalars['Date']>;
  withInitiatorLicense?: Maybe<Scalars['Int']>;
  withoutInitiatorLicense?: Maybe<Scalars['Int']>;
};

export type Dashboard_CacheCoresUsage = {
  __typename?: 'Dashboard_CacheCoresUsage';
  cacheCores?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['Date']>;
};

export type Dashboard_CacheHoursConsumption = {
  __typename?: 'Dashboard_CacheHoursConsumption';
  cloud?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
  onPrem?: Maybe<Scalars['Int']>;
};

export type Dashboard_Filter = {
  buildGroup?: InputMaybe<Scalars['String']>;
  from: Scalars['Date'];
  initiatorType?: InputMaybe<Dashboard_InitiatorType>;
  timeZone: Scalars['String'];
  to: Scalars['Date'];
  workloadType?: InputMaybe<Dashboard_WorkloadType>;
};

export type Dashboard_HelperNeededRate = {
  __typename?: 'Dashboard_HelperNeededRate';
  availability?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
  demand?: Maybe<Scalars['Int']>;
  maxCores?: Maybe<Scalars['Int']>;
};

export enum Dashboard_InitiatorType {
  Ci = 'CI',
  Developer = 'Developer',
  MissingLicense = 'MissingLicense',
}

export type Dashboard_Metadata = {
  __typename?: 'Dashboard_Metadata';
  buildGroups?: Maybe<Array<Maybe<Scalars['String']>>>;
  hasWorkloads?: Maybe<Scalars['Boolean']>;
  initiatorTypes?: Maybe<Array<Maybe<Dashboard_InitiatorType>>>;
  oldestWorkloadDate?: Maybe<Scalars['Date']>;
  workloadTypes?: Maybe<Array<Maybe<Dashboard_WorkloadType>>>;
};

export type Dashboard_Metadata_Filter = {
  from: Scalars['Date'];
  to: Scalars['Date'];
};

export type Dashboard_Overview = {
  __typename?: 'Dashboard_Overview';
  avgWorkloadsDuration?: Maybe<Scalars['Float']>;
  avgWorkloadsWithBuildCacheDuration?: Maybe<Scalars['Float']>;
  avgWorkloadsWithoutBuildCacheDuration?: Maybe<Scalars['Float']>;
  totalWorkloads?: Maybe<Scalars['Int']>;
  totalWorkloadsDuration?: Maybe<Scalars['Long']>;
  totalWorkloadsWithBuildCache?: Maybe<Scalars['Int']>;
  totalWorkloadsWithoutBuildCache?: Maybe<Scalars['Int']>;
};

export type Dashboard_SystemUtilization = {
  __typename?: 'Dashboard_SystemUtilization';
  activeHelperMachines?: Maybe<Array<Maybe<Dashboard_ActiveHelperMachines>>>;
  activeInitiatorMachines?: Maybe<Array<Maybe<Dashboard_ActiveInitiatorMachines>>>;
  cacheCoresUsage?: Maybe<Array<Maybe<Dashboard_CacheCoresUsage>>>;
  cacheHoursConsumption?: Maybe<Array<Maybe<Dashboard_CacheHoursConsumption>>>;
  helperNeededRate?: Maybe<Array<Maybe<Dashboard_HelperNeededRate>>>;
  overview?: Maybe<Dashboard_Overview>;
  timeSavedByCache?: Maybe<Array<Maybe<Dashboard_TimeSavedByCache>>>;
};

export type Dashboard_TimeSavedByCache = {
  __typename?: 'Dashboard_TimeSavedByCache';
  date?: Maybe<Scalars['Date']>;
  totalCpuTime?: Maybe<Scalars['Long']>;
  totalSavedTime?: Maybe<Scalars['Long']>;
};

export type Dashboard_TotalWorkloads = {
  __typename?: 'Dashboard_TotalWorkloads';
  canceled?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
  failed?: Maybe<Scalars['Int']>;
  successful?: Maybe<Scalars['Int']>;
};

export type Dashboard_WorkloadDuration = {
  __typename?: 'Dashboard_WorkloadDuration';
  avgWorkloadDuration?: Maybe<Scalars['Long']>;
  date?: Maybe<Scalars['Date']>;
  maxWorkloadDuration?: Maybe<Scalars['Long']>;
};

export type Dashboard_WorkloadHour = {
  __typename?: 'Dashboard_WorkloadHour';
  duration?: Maybe<Scalars['Int']>;
  totalWorkloads?: Maybe<Scalars['Int']>;
};

export enum Dashboard_WorkloadType {
  Build = 'Build',
  Clean = 'Clean',
  Rebuild = 'Rebuild',
  Unknown = 'Unknown',
}

export type Dashboard_Workloads = {
  __typename?: 'Dashboard_Workloads';
  overview?: Maybe<Dashboard_Overview>;
  totalWorkloads?: Maybe<Array<Maybe<Dashboard_TotalWorkloads>>>;
  workloadsDuration?: Maybe<Array<Maybe<Dashboard_WorkloadDuration>>>;
  workloadsDurationPercentile?: Maybe<Dashboard_WorkloadsDurationPercentile>;
  workloadsHoursDuration?: Maybe<Dashboard_WorkloadsHoursDuration>;
};

export type Dashboard_WorkloadsDurationPercentile = {
  __typename?: 'Dashboard_WorkloadsDurationPercentile';
  p25?: Maybe<Scalars['Long']>;
  p50?: Maybe<Scalars['Long']>;
  p75?: Maybe<Scalars['Long']>;
  p100?: Maybe<Scalars['Long']>;
};

export type Dashboard_WorkloadsHoursDuration = {
  __typename?: 'Dashboard_WorkloadsHoursDuration';
  Friday?: Maybe<Array<Maybe<Dashboard_WorkloadHour>>>;
  Monday?: Maybe<Array<Maybe<Dashboard_WorkloadHour>>>;
  Saturday?: Maybe<Array<Maybe<Dashboard_WorkloadHour>>>;
  Sunday?: Maybe<Array<Maybe<Dashboard_WorkloadHour>>>;
  Thursday?: Maybe<Array<Maybe<Dashboard_WorkloadHour>>>;
  Tuesday?: Maybe<Array<Maybe<Dashboard_WorkloadHour>>>;
  Wednesday?: Maybe<Array<Maybe<Dashboard_WorkloadHour>>>;
};

export type ExportCsv_FieldsMapping = {
  field: Scalars['String'];
  label: Scalars['String'];
};

export type ExportCsv_Result = {
  __typename?: 'ExportCsv_Result';
  fileId?: Maybe<Scalars['String']>;
  status?: Maybe<ExportCsv_Status>;
};

export enum ExportCsv_Status {
  Failure = 'Failure',
  Success = 'Success',
}

export type ExternalAuthentication = {
  __typename?: 'ExternalAuthentication';
  azureADAuth?: Maybe<AzureAdAuthentication>;
  ldapAuth?: Maybe<LdapAuthentication>;
};

export type ExternalAuthenticationDeleteInput = {
  authenticationType: External_Authentication_Type;
};

export type ExternalAuthenticationEnableInput = {
  authenticationType: External_Authentication_Type;
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type ExternalAuthenticationGroupRolesUpdateResult = {
  __typename?: 'ExternalAuthenticationGroupRolesUpdateResult';
  status: Scalars['String'];
};

export type ExternalAuthenticationInput = {
  azureADAuth?: InputMaybe<AzureAdAuthenticationInput>;
  ldapAuth?: InputMaybe<LdapAuthenticationInput>;
};

export type ExternalAuthenticationOrganizationGroupMapping = {
  __typename?: 'ExternalAuthenticationOrganizationGroupMapping';
  group?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type ExternalAuthenticationOrganizationGroupMappingInput = {
  group?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
};

export type ExternalAuthenticationUpdateGroupRolesInput = {
  authenticationType: External_Authentication_Type;
  groupRoleMapping?: InputMaybe<Array<InputMaybe<ExternalAuthenticationOrganizationGroupMappingInput>>>;
};

export enum External_Authentication_Type {
  AzureAd = 'AzureAD',
  Ldap = 'LDAP',
}

export type IbManagerEntity = {
  __typename?: 'IBManagerEntity';
  agents?: Maybe<Agent_AgentsResult>;
  agentsActiveInfo?: Maybe<Agent_ActiveInfo>;
  agentsMetadata?: Maybe<Agent_AgentsMetadata>;
  buildGroups?: Maybe<Array<Maybe<BuildGroup>>>;
  builds?: Maybe<Builds_Result>;
  buildsMetadata?: Maybe<Builds_Metadata>;
  buildsSummary?: Maybe<Builds_Summary>;
  cloudData?: Maybe<Cloud_Data>;
  cloudLicense?: Maybe<CloudLicense>;
  coordinatorInfo?: Maybe<Coordinator_Info>;
  featureFlags?: Maybe<Scalars['String']>;
  license?: Maybe<License>;
  licenseMetadata?: Maybe<License_LicenseMetadata>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  notificationsCount?: Maybe<Notification_NotificationsCount>;
  settings?: Maybe<Settings>;
  settingsMetadata?: Maybe<Settings_SettingsMetadata>;
  systemInfo?: Maybe<System_Info>;
};

export type IbManagerEntityAgentsArgs = {
  filter?: InputMaybe<Agent_WhereInput>;
};

export type IbManagerEntityBuildsArgs = {
  filter?: InputMaybe<Builds_BuildsWhereInput>;
};

export type IbManagerEntityBuildsMetadataArgs = {
  filter?: InputMaybe<Builds_BuildsMetadataWhereInput>;
};

export type IbManagerEntityBuildsSummaryArgs = {
  filter?: InputMaybe<Builds_SummaryWhereInput>;
};

export type IbManagerEntityNotificationsArgs = {
  where?: InputMaybe<Notification_WhereInput>;
};

export type IbManagerSettings = {
  __typename?: 'IBManagerSettings';
  coordinatorHostname?: Maybe<Scalars['String']>;
  ibManagerPort?: Maybe<Scalars['Int']>;
  rabbitMqPort?: Maybe<Scalars['Int']>;
};

export type Key_Action_Base_Response = {
  __typename?: 'Key_Action_Base_Response';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type Key_Action_Response = {
  __typename?: 'Key_Action_Response';
  apiKey?: Maybe<Key_Object>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type Key_CreateInput = {
  description?: InputMaybe<Scalars['String']>;
  expirationInDays?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Key_Role>;
};

export type Key_Object = {
  __typename?: 'Key_Object';
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['String']>;
  createdByUserId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['Date']>;
  key: Scalars['String'];
  lastUsed?: Maybe<Scalars['Date']>;
  role?: Maybe<Key_Role>;
  status?: Maybe<Key_StatusType>;
};

export type Key_Query_Response = {
  __typename?: 'Key_Query_Response';
  apiKey?: Maybe<Key_Object>;
};

export enum Key_Role {
  GridAdmin = 'GridAdmin',
  GroupManager = 'GroupManager',
  Viewer = 'Viewer',
}

export enum Key_StatusType {
  Active = 'Active',
  Deleted = 'Deleted',
  Disabled = 'Disabled',
  Expired = 'Expired',
}

export type Key_WhereInput = {
  roleFilter?: InputMaybe<Key_Role>;
  statusFilter?: InputMaybe<Key_StatusType>;
};

export type LdapAuthentication = {
  __typename?: 'LDAPAuthentication';
  authenticationType: External_Authentication_Type;
  bindDN?: Maybe<Scalars['String']>;
  certificateAuthority?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  groupRoleMapping?: Maybe<Array<Maybe<ExternalAuthenticationOrganizationGroupMapping>>>;
  groupSearchBase?: Maybe<Scalars['String']>;
  searchBase?: Maybe<Scalars['String']>;
  url?: Maybe<Array<Maybe<Scalars['String']>>>;
  usernameAttribute?: Maybe<Scalars['String']>;
};

export type LdapAuthenticationInput = {
  bindCredentials?: InputMaybe<Scalars['String']>;
  bindDN: Scalars['String'];
  certificateAuthority?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  groupSearchBase?: InputMaybe<Scalars['String']>;
  searchBase?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** usernameAttribute defaults to sAMAccountName if left empty */
  usernameAttribute?: InputMaybe<Scalars['String']>;
};

export type License = {
  __typename?: 'License';
  coordinatorId: Scalars['String'];
  expirationInfo?: Maybe<License_ExpirationInfo>;
  key?: Maybe<Scalars['String']>;
  linux?: Maybe<LinuxLicense>;
  state?: Maybe<Scalars['Int']>;
  windows?: Maybe<WindowsLicense>;
};

export type LicenseAction_Input = {
  action: LicenseAction_Type;
  licenseKey?: InputMaybe<Scalars['String']>;
  parameter?: InputMaybe<Scalars['License_Parameter']>;
};

export enum LicenseAction_Type {
  Change = 'Change',
  Refresh = 'Refresh',
}

export type LicenseSettings = {
  __typename?: 'LicenseSettings';
  automaticBuildCacheLicense?: Maybe<Scalars['Boolean']>;
  defaultCIInitiatorType?: Maybe<License_RegistrationType>;
  defaultHelperType?: Maybe<License_RegistrationType>;
  defaultInitiatorType?: Maybe<License_RegistrationType>;
  floatingReleaseTime?: Maybe<Scalars['Int']>;
  helperCoresAssignmentPercentage?: Maybe<Scalars['Int']>;
  licenseServerPort?: Maybe<Scalars['Int']>;
};

export type License_ExpirationInfo = {
  __typename?: 'License_ExpirationInfo';
  contractEndDate?: Maybe<Scalars['Timestamp']>;
  daysLeft?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['Timestamp']>;
};

export type License_Features = {
  __typename?: 'License_Features';
  addonFeatures?: Maybe<Scalars['String']>;
  productFeatures?: Maybe<Scalars['String']>;
};

export type License_GenerateKey = {
  __typename?: 'License_GenerateKey';
  key?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type License_GenerateKey_AsyncResult = {
  __typename?: 'License_GenerateKey_AsyncResult';
  result?: Maybe<License_GenerateKey>;
};

export type License_HelperCores_Status = {
  __typename?: 'License_HelperCores_Status';
  fixed?: Maybe<License_RegistrationType_Totals>;
  floating?: Maybe<Scalars['Int']>;
};

export type License_LicenseMetadata = {
  __typename?: 'License_LicenseMetadata';
  hasBuildCache?: Maybe<Scalars['Boolean']>;
  hasCiInitiator?: Maybe<Scalars['Boolean']>;
  hasFixedFloating?: Maybe<Scalars['Boolean']>;
  hasInitiator?: Maybe<Scalars['Boolean']>;
};

export enum License_RegisterAgentAction {
  LicenseConfig = 'licenseConfig',
  Resolve = 'resolve',
  UnsubscribeAgent = 'unsubscribeAgent',
}

export type License_RegisterAgentRequest = {
  action: License_RegisterAgentAction;
  agentId: Scalars['String'];
  ciInitiatorLicense: License_RegistrationType;
  coordinatorId: Scalars['String'];
  helperLicense: License_RegistrationType;
  initiatorLicense: License_RegistrationType;
  requestedCores: Scalars['Int'];
};

export type License_RegisterBuildCacheRequest = {
  agentId: Scalars['String'];
  coordinatorId: Scalars['String'];
  enable?: InputMaybe<Scalars['Boolean']>;
  remoteCacheServer?: InputMaybe<Scalars['String']>;
  useBuildCacheCluster?: InputMaybe<Scalars['Boolean']>;
  useLocalCache?: InputMaybe<Scalars['Boolean']>;
};

export type License_RegisterBuildCacheRequestAgent = {
  agentId: Scalars['String'];
  coordinatorId: Scalars['String'];
};

export enum License_RegistrationType {
  Fixed = 'Fixed',
  Floating = 'Floating',
  None = 'None',
}

export type License_RegistrationType_Status = {
  __typename?: 'License_RegistrationType_Status';
  all?: Maybe<License_RegistrationType_Totals>;
  fixed?: Maybe<License_RegistrationType_Totals>;
  floating?: Maybe<License_RegistrationType_Totals>;
};

export type License_RegistrationType_Totals = {
  __typename?: 'License_RegistrationType_Totals';
  assigned?: Maybe<Scalars['Int']>;
  available?: Maybe<Scalars['Int']>;
  cooldown?: Maybe<Scalars['Int']>;
  cooldownNextRelease?: Maybe<Scalars['Timestamp']>;
  total?: Maybe<Scalars['Int']>;
};

export type License_StateInfo = {
  __typename?: 'License_StateInfo';
  errorCode: Scalars['Int'];
  state: Scalars['Int'];
};

export type License_StateInfo_AsyncResult = {
  __typename?: 'License_StateInfo_AsyncResult';
  result?: Maybe<License_StateInfo>;
};

export type License_Status = {
  __typename?: 'License_Status';
  buildCacheNextResetTime?: Maybe<Scalars['Timestamp']>;
  buildCacheResetMinutes?: Maybe<Scalars['Int']>;
  ciInitiator?: Maybe<License_RegistrationType_Status>;
  helperCores?: Maybe<License_HelperCores_Status>;
  initiator?: Maybe<License_RegistrationType_Status>;
  remainingBuildCacheCores?: Maybe<Scalars['Float']>;
  totalBuildCacheCores?: Maybe<Scalars['Int']>;
};

export type License_Summary = {
  __typename?: 'License_Summary';
  totalBuildCacheCores?: Maybe<Scalars['Int']>;
  totalFixedCIInitiators?: Maybe<Scalars['Int']>;
  totalFixedCores?: Maybe<Scalars['Int']>;
  totalFixedInitiators?: Maybe<Scalars['Int']>;
  totalFloatingCIInitiators?: Maybe<Scalars['Int']>;
  totalFloatingCores?: Maybe<Scalars['Int']>;
  totalFloatingInitiators?: Maybe<Scalars['Int']>;
  totalRegisteredFloatingCores?: Maybe<Scalars['Int']>;
  unlimitedCacheCores?: Maybe<Scalars['Boolean']>;
  unlimitedHelperCores?: Maybe<Scalars['Boolean']>;
};

export type LinuxCoordinatorSettings = {
  __typename?: 'LinuxCoordinatorSettings';
  agentControlPort?: Maybe<Scalars['Int']>;
  agentMaxCpuLoad?: Maybe<Scalars['Int']>;
  agentMinFreeMemory?: Maybe<Scalars['Int']>;
  agentReloadTimeout?: Maybe<Scalars['Int']>;
  autoSubscribeNewAgents?: Maybe<Scalars['Boolean']>;
  buildMaxCores?: Maybe<Scalars['Int']>;
  sessionPort?: Maybe<Scalars['Int']>;
  utilityPort?: Maybe<Scalars['Int']>;
};

export type LinuxLicense = {
  __typename?: 'LinuxLicense';
  coordinatorId?: Maybe<Scalars['String']>;
  licenseDetails?: Maybe<Array<Maybe<LinuxLicenseDetails>>>;
  licenseName?: Maybe<Scalars['String']>;
  maintenanceExpirationDate?: Maybe<Scalars['Timestamp']>;
};

export type LinuxLicenseDetails = {
  __typename?: 'LinuxLicenseDetails';
  availablePackages?: Maybe<Scalars['Int']>;
  coresInUse?: Maybe<Scalars['Int']>;
  packageBuildServer?: Maybe<Scalars['Int']>;
  packageNumCores?: Maybe<Scalars['Int']>;
  packageType?: Maybe<Scalars['Int']>;
  totalPackages?: Maybe<Scalars['Int']>;
};

export type LinuxNetworkSettings = {
  __typename?: 'LinuxNetworkSettings';
  coordinatorPort?: Maybe<Scalars['Int']>;
  coordinatorSSLPort?: Maybe<Scalars['Int']>;
  ipv6?: Maybe<Scalars['Boolean']>;
  ssl?: Maybe<Scalars['Boolean']>;
  useCoordinatorAgentTunnel?: Maybe<Scalars['Boolean']>;
};

export type LinuxSettings = {
  __typename?: 'LinuxSettings';
  coordinator: LinuxCoordinatorSettings;
  network: LinuxNetworkSettings;
  system: LinuxSystemSettings;
};

export type LinuxSystemSettings = {
  __typename?: 'LinuxSystemSettings';
  telemetryEnabled?: Maybe<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  agents_action_async?: Maybe<Scalars['UUID']>;
  agents_buildCache_update_async?: Maybe<Scalars['UUID']>;
  authentication_login: Authentication_AuthPayload;
  authentication_login_azuread: Authentication_AuthPayload;
  authentication_logout?: Maybe<Scalars['Boolean']>;
  authentication_refresh: Authentication_AuthPayload;
  authentication_save_azuread_code?: Maybe<Scalars['Boolean']>;
  buildGroup_add_async?: Maybe<Scalars['UUID']>;
  buildGroup_delete_async?: Maybe<Scalars['UUID']>;
  buildGroup_edit_async?: Maybe<Scalars['UUID']>;
  cloud_action_async?: Maybe<Scalars['UUID']>;
  cloud_action_wakeup_async?: Maybe<Scalars['UUID']>;
  cloud_action_wakeup_machine_async?: Maybe<Scalars['UUID']>;
  cloud_set_cloud_secret?: Maybe<Cloud_Response>;
  cluster_add_nodes?: Maybe<Cluster_Add_Nodes_Result>;
  cluster_create?: Maybe<Cluster>;
  cluster_delete?: Maybe<Scalars['Boolean']>;
  cluster_edit?: Maybe<Scalars['Boolean']>;
  cluster_remove_nodes?: Maybe<Cluster_Remove_Nodes_Result>;
  key_create?: Maybe<Key_Action_Response>;
  key_deactivate?: Maybe<Key_Action_Response>;
  key_update_description?: Maybe<Key_Action_Base_Response>;
  key_update_role?: Maybe<Key_Action_Base_Response>;
  license_action_activate_async?: Maybe<Scalars['UUID']>;
  license_action_deactivate_async?: Maybe<Scalars['UUID']>;
  license_action_generate_key_async?: Maybe<Scalars['UUID']>;
  license_action_refresh_async?: Maybe<Scalars['UUID']>;
  license_registerAgents_async?: Maybe<Scalars['UUID']>;
  license_registerBuildCache_async?: Maybe<Scalars['UUID']>;
  persistentData_delete?: Maybe<Scalars['Boolean']>;
  persistentData_set?: Maybe<Scalars['Boolean']>;
  settings_changeCoordinatorPort_async?: Maybe<Scalars['UUID']>;
  settings_changeManagerPort?: Maybe<Settings_PortCheckResult>;
  settings_checkPort_async?: Maybe<Scalars['UUID']>;
  settings_externalAuth_azure_update?: Maybe<Auth_Result>;
  settings_externalAuth_delete?: Maybe<Auth_Result>;
  settings_externalAuth_ldap_update?: Maybe<Auth_Result>;
  settings_externalAuth_setState?: Maybe<Auth_Result>;
  settings_externalAuth_updateGroupRoles?: Maybe<ExternalAuthenticationGroupRolesUpdateResult>;
  settings_update_async?: Maybe<Scalars['UUID']>;
  user_create?: Maybe<User>;
  user_update?: Maybe<User>;
  user_updatePassword?: Maybe<Scalars['Boolean']>;
  user_updatePersonalInfo?: Maybe<User_AdditionalInfo>;
};

export type MutationAgents_Action_AsyncArgs = {
  data: Agent_ActionInput;
};

export type MutationAgents_BuildCache_Update_AsyncArgs = {
  data: Agent_BuildCacheSettingsInput;
};

export type MutationAuthentication_LoginArgs = {
  user: Authentication_LoginUserInput;
};

export type MutationAuthentication_Login_AzureadArgs = {
  data: Authentication_AzureAdInput;
};

export type MutationAuthentication_Save_Azuread_CodeArgs = {
  data: Authentication_AzureAdInput;
};

export type MutationBuildGroup_Add_AsyncArgs = {
  data: BuildGroup_AddInput;
};

export type MutationBuildGroup_Delete_AsyncArgs = {
  data: BuildGroup_DeleteInput;
};

export type MutationBuildGroup_Edit_AsyncArgs = {
  data: BuildGroup_EditInput;
};

export type MutationCloud_Action_AsyncArgs = {
  data: Cloud_ActionInput;
};

export type MutationCloud_Action_Wakeup_AsyncArgs = {
  data: Cloud_Wakeup_ActionInput;
};

export type MutationCloud_Action_Wakeup_Machine_AsyncArgs = {
  data: Cloud_Wakeup_Machine_ActionInput;
};

export type MutationCloud_Set_Cloud_SecretArgs = {
  coordinatorId: Scalars['String'];
  secret: Scalars['String'];
};

export type MutationCluster_Add_NodesArgs = {
  data?: InputMaybe<Cluster_Nodes_AddInput>;
};

export type MutationCluster_CreateArgs = {
  name: Scalars['String'];
};

export type MutationCluster_DeleteArgs = {
  id: Scalars['Int'];
};

export type MutationCluster_EditArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type MutationCluster_Remove_NodesArgs = {
  data?: InputMaybe<Cluster_Nodes_RemoveInput>;
};

export type MutationKey_CreateArgs = {
  data?: InputMaybe<Key_CreateInput>;
};

export type MutationKey_DeactivateArgs = {
  apiKey: Scalars['String'];
};

export type MutationKey_Update_DescriptionArgs = {
  apiKey: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
};

export type MutationKey_Update_RoleArgs = {
  apiKey: Scalars['String'];
  role?: InputMaybe<Key_Role>;
};

export type MutationLicense_Action_Activate_AsyncArgs = {
  licenseKey: Scalars['String'];
};

export type MutationLicense_Action_Deactivate_AsyncArgs = {
  licenseKey: Scalars['String'];
};

export type MutationLicense_RegisterAgents_AsyncArgs = {
  data: Array<License_RegisterAgentRequest>;
};

export type MutationLicense_RegisterBuildCache_AsyncArgs = {
  data?: InputMaybe<Array<License_RegisterBuildCacheRequest>>;
};

export type MutationPersistentData_DeleteArgs = {
  where: PersistentData_WhereInput;
};

export type MutationPersistentData_SetArgs = {
  data: PersistentData_SetInput;
};

export type MutationSettings_ChangeCoordinatorPort_AsyncArgs = {
  port: Scalars['Int'];
};

export type MutationSettings_ChangeManagerPortArgs = {
  port: Scalars['Int'];
};

export type MutationSettings_CheckPort_AsyncArgs = {
  data: Settings_CheckPortInput;
};

export type MutationSettings_ExternalAuth_Azure_UpdateArgs = {
  input: AzureAdAuthenticationInput;
};

export type MutationSettings_ExternalAuth_DeleteArgs = {
  input: ExternalAuthenticationDeleteInput;
};

export type MutationSettings_ExternalAuth_Ldap_UpdateArgs = {
  input: LdapAuthenticationInput;
};

export type MutationSettings_ExternalAuth_SetStateArgs = {
  input: ExternalAuthenticationEnableInput;
};

export type MutationSettings_ExternalAuth_UpdateGroupRolesArgs = {
  input: ExternalAuthenticationUpdateGroupRolesInput;
};

export type MutationSettings_Update_AsyncArgs = {
  configurations: Settings_UpdateUserInput;
};

export type MutationUser_CreateArgs = {
  data?: InputMaybe<User_CreateInput>;
};

export type MutationUser_UpdateArgs = {
  data: User_UpdateInput;
  id: Scalars['Int'];
};

export type MutationUser_UpdatePasswordArgs = {
  data: User_PasswordUpdateInput;
};

export type MutationUser_UpdatePersonalInfoArgs = {
  data: User_AdditionalInfoInput;
};

export type NextCloudLicense = {
  __typename?: 'NextCloudLicense';
  activationDate?: Maybe<Scalars['Timestamp']>;
  coordSpecificCacheConsumption?: Maybe<Scalars['Long']>;
  coordSpecificConsumption?: Maybe<Scalars['Long']>;
  coordinatorId: Scalars['String'];
  expirationDate?: Maybe<Scalars['Timestamp']>;
  hasBuildCache?: Maybe<Scalars['Boolean']>;
  licenseDetails?: Maybe<Cloud_LicenseDetails>;
  licenseId?: Maybe<Scalars['String']>;
  licenseStatus?: Maybe<Scalars['String']>;
  licenseType?: Maybe<Scalars['String']>;
  totalCacheConsumption?: Maybe<Scalars['Long']>;
  totalLicenseConsumption?: Maybe<Scalars['Long']>;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['Date'];
  data?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  notificationTimestamp: Scalars['Timestamp'];
  notificationType: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type Notification_NotificationsCount = {
  __typename?: 'Notification_NotificationsCount';
  totalCount: Scalars['Int'];
};

export type Notification_WhereInput = {
  fromId?: InputMaybe<Scalars['Int']>;
  toId?: InputMaybe<Scalars['Int']>;
};

export type PersistentData = {
  __typename?: 'PersistentData';
  createdAt: Scalars['Date'];
  key: Scalars['String'];
  updatedAt: Scalars['Date'];
  value: Scalars['String'];
};

export type PersistentData_SetInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type PersistentData_WhereInput = {
  key: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  agents?: Maybe<Agent_AgentsResult>;
  agentsActiveInfo?: Maybe<Agent_ActiveInfo>;
  agentsChanges?: Maybe<Array<Maybe<Agent>>>;
  agents_action_asyncResult?: Maybe<Agent_Action_AsyncResult>;
  agents_buildCache_update_asyncResult?: Maybe<Agent_Action_AsyncResult>;
  authentication_get_azuread_route: Authentication_AzureAdRoute;
  authentication_get_login_options: Authentication_LoginOptions;
  authentication_get_organization_groups: Authentication_OrganizationGroupsResult;
  authentication_has_azuread_code?: Maybe<Scalars['Boolean']>;
  buildDetails?: Maybe<Builds_BuildDetails>;
  buildGroup_add_asyncResult?: Maybe<BuildGroup_AsyncResult>;
  buildGroup_delete_asyncResult?: Maybe<BuildGroup_AsyncResult>;
  buildGroup_edit_asyncResult?: Maybe<BuildGroup_AsyncResult>;
  buildGroups?: Maybe<Array<Maybe<BuildGroup>>>;
  builds?: Maybe<Builds_Result>;
  buildsExportCSV?: Maybe<ExportCsv_Result>;
  buildsMetadata?: Maybe<Builds_Metadata>;
  buildsSummary?: Maybe<Builds_Summary>;
  cloud_action_asyncResult?: Maybe<Cloud_Action_AsyncResult>;
  cloud_action_wakeup_asyncResult?: Maybe<Cloud_Action_AsyncResult>;
  cloud_data?: Maybe<Cloud_Data>;
  cloud_data_pool?: Maybe<Cloud_Data_Pool>;
  cloud_data_pool_deallocated?: Maybe<Cloud_Data_Pool_Deallocated>;
  cloud_url?: Maybe<Cloud_UrlResult>;
  clusters?: Maybe<Array<Maybe<Cluster>>>;
  coordinators?: Maybe<Array<Maybe<Coordinator_Result>>>;
  dashboardMetadata?: Maybe<Dashboard_Metadata>;
  ibManagerEntities?: Maybe<IbManagerEntity>;
  key?: Maybe<Key_Object>;
  keys?: Maybe<Array<Maybe<Key_Object>>>;
  license?: Maybe<License>;
  license_action_asyncResult?: Maybe<License_StateInfo_AsyncResult>;
  license_action_generate_asyncResult?: Maybe<License_GenerateKey_AsyncResult>;
  license_cloud?: Maybe<CloudLicense>;
  license_licenseKey?: Maybe<Scalars['String']>;
  license_registerAgents_asyncResult?: Maybe<Agent_Action_AsyncResult>;
  license_registerBuildCache_asyncResult?: Maybe<Agent_Action_AsyncResult>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  persistentData?: Maybe<Scalars['String']>;
  settings?: Maybe<Settings>;
  settings_changeCoordinatorPort_asyncResult?: Maybe<Settings_PortCheck_AsyncResult>;
  settings_checkPort_asyncResult?: Maybe<Settings_PortCheck_AsyncResult>;
  settings_externalAuths?: Maybe<ExternalAuthentication>;
  settings_telemetry_enabled?: Maybe<Scalars['String']>;
  settings_update_asyncResult?: Maybe<Settings_Update_AsyncResult>;
  systemInfo?: Maybe<System_Info>;
  systemUtilization?: Maybe<Dashboard_SystemUtilization>;
  user?: Maybe<User>;
  users?: Maybe<Array<Maybe<User>>>;
  workloads?: Maybe<Dashboard_Workloads>;
};

export type QueryAgentsArgs = {
  filter?: InputMaybe<Agent_WhereInput>;
};

export type QueryAgentsChangesArgs = {
  filter?: InputMaybe<Agent_ChangesWhereInput>;
};

export type QueryAgents_Action_AsyncResultArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type QueryAgents_BuildCache_Update_AsyncResultArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type QueryAuthentication_Get_Azuread_RouteArgs = {
  data: Authentication_AzureAdRouteInput;
};

export type QueryAuthentication_Get_Organization_GroupsArgs = {
  data: Authentication_ExternalTypeInput;
};

export type QueryBuildDetailsArgs = {
  filter?: InputMaybe<Builds_BuildDetailsWhereInput>;
};

export type QueryBuildGroup_Add_AsyncResultArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type QueryBuildGroup_Delete_AsyncResultArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type QueryBuildGroup_Edit_AsyncResultArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type QueryBuildGroupsArgs = {
  data?: InputMaybe<BuildGroups_Input>;
  filter?: InputMaybe<BuildGroups_WhereInput>;
};

export type QueryBuildsArgs = {
  filter?: InputMaybe<Builds_BuildsWhereInput>;
};

export type QueryBuildsExportCsvArgs = {
  fieldsMapping?: InputMaybe<Array<InputMaybe<ExportCsv_FieldsMapping>>>;
  filter?: InputMaybe<Builds_BuildsWhereInput>;
};

export type QueryBuildsMetadataArgs = {
  filter?: InputMaybe<Builds_BuildsMetadataWhereInput>;
};

export type QueryBuildsSummaryArgs = {
  filter?: InputMaybe<Builds_SummaryWhereInput>;
};

export type QueryCloud_Action_AsyncResultArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type QueryCloud_Action_Wakeup_AsyncResultArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type QueryCloud_DataArgs = {
  coordinatorId: Scalars['String'];
};

export type QueryCloud_Data_PoolArgs = {
  coordinatorId: Scalars['String'];
};

export type QueryCloud_Data_Pool_DeallocatedArgs = {
  coordinatorId: Scalars['String'];
};

export type QueryCloud_UrlArgs = {
  coordinatorId: Scalars['String'];
};

export type QueryClustersArgs = {
  filter?: InputMaybe<Cluster_Nodes_WhereInput>;
};

export type QueryDashboardMetadataArgs = {
  filter?: InputMaybe<Dashboard_Metadata_Filter>;
};

export type QueryIbManagerEntitiesArgs = {
  coordinatorId?: InputMaybe<Scalars['String']>;
};

export type QueryKeyArgs = {
  apiKey: Scalars['String'];
};

export type QueryKeysArgs = {
  filter?: InputMaybe<Key_WhereInput>;
};

export type QueryLicenseArgs = {
  coordinatorId: Scalars['String'];
};

export type QueryLicense_Action_AsyncResultArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type QueryLicense_Action_Generate_AsyncResultArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type QueryLicense_CloudArgs = {
  coordinatorId: Scalars['String'];
};

export type QueryLicense_RegisterAgents_AsyncResultArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type QueryLicense_RegisterBuildCache_AsyncResultArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type QueryNotificationsArgs = {
  where?: InputMaybe<Notification_WhereInput>;
};

export type QueryPersistentDataArgs = {
  where: PersistentData_WhereInput;
};

export type QuerySettingsArgs = {
  coordinatorId: Scalars['String'];
};

export type QuerySettings_ChangeCoordinatorPort_AsyncResultArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type QuerySettings_CheckPort_AsyncResultArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type QuerySettings_Update_AsyncResultArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type QuerySystemUtilizationArgs = {
  filter?: InputMaybe<Dashboard_Filter>;
};

export type QueryUsersArgs = {
  filter?: InputMaybe<User_WhereInput>;
};

export type QueryWorkloadsArgs = {
  filter?: InputMaybe<Dashboard_Filter>;
};

export type Settings = {
  __typename?: 'Settings';
  common: CommonSettings;
  linux?: Maybe<LinuxSettings>;
  windows?: Maybe<WindowsSettings>;
};

export type Settings_CheckPortInput = {
  port: Scalars['Int'];
  portType: Settings_Port_Type;
};

export type Settings_ExternalAuth = {
  __typename?: 'Settings_ExternalAuth';
  authenticationType?: Maybe<External_Authentication_Type>;
  enabled?: Maybe<Scalars['Boolean']>;
  externalAuths?: Maybe<ExternalAuthentication>;
};

export type Settings_PortCheckResult = {
  __typename?: 'Settings_PortCheckResult';
  message?: Maybe<Scalars['String']>;
  port: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
};

export type Settings_PortCheck_AsyncResult = {
  __typename?: 'Settings_PortCheck_AsyncResult';
  result?: Maybe<Settings_PortCheckResult>;
};

export enum Settings_Port_Type {
  AgentPort = 'AgentPort',
  CoordinatorPort = 'CoordinatorPort',
  LicensePort = 'LicensePort',
  ManagerPort = 'ManagerPort',
}

export type Settings_SetRequest = {
  key: Scalars['String'];
  value: Scalars['Settings_Value'];
};

export type Settings_SettingsMetadata = {
  __typename?: 'Settings_SettingsMetadata';
  isCloudActivated?: Maybe<Scalars['Boolean']>;
};

export type Settings_UpdateUserInput = {
  coordinatorId: Scalars['String'];
  settings: Array<Settings_SetRequest>;
};

export type Settings_Update_AsyncResult = {
  __typename?: 'Settings_Update_AsyncResult';
  result?: Maybe<Array<Maybe<SystemConfiguration_SettingsResult>>>;
};

export type SystemConfiguration_SettingsResult = {
  __typename?: 'SystemConfiguration_SettingsResult';
  key: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type SystemSettings = {
  __typename?: 'SystemSettings';
  allowCustomDistributionProfiles?: Maybe<Scalars['Boolean']>;
  allowSystemStandby?: Maybe<Scalars['Boolean']>;
  ignoreFirewall?: Maybe<Scalars['Boolean']>;
  prometheusEnabled?: Maybe<Scalars['Boolean']>;
  prometheusPort?: Maybe<Scalars['Int']>;
  telemetryEnabled?: Maybe<Scalars['Boolean']>;
};

export type System_Info = {
  __typename?: 'System_Info';
  fqdn?: Maybe<Scalars['String']>;
  hostname?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  additionalInfo?: Maybe<User_AdditionalInfo>;
  authType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastLogin?: Maybe<Scalars['Date']>;
  local?: Maybe<Scalars['Boolean']>;
  role: User_Role;
  status?: Maybe<User_Status>;
  userName: Scalars['String'];
};

export type User_AdditionalInfo = {
  __typename?: 'User_AdditionalInfo';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type User_AdditionalInfoInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export enum User_AuthType {
  All = 'All',
  AzureAd = 'AzureAD',
  Ldap = 'LDAP',
  Local = 'Local',
}

export type User_CreateInput = {
  additionalInfo?: InputMaybe<User_AdditionalInfoInput>;
  password: Scalars['String'];
  role: User_Role;
  status: User_Status;
  userName: Scalars['String'];
};

export type User_PasswordUpdateInput = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export enum User_Role {
  GridAdmin = 'GridAdmin',
  GroupManager = 'GroupManager',
  Viewer = 'Viewer',
}

export type User_Sort = {
  field: User_SortField;
  order: User_SortOrder;
};

export enum User_SortField {
  Email = 'email',
  FullName = 'fullName',
  Id = 'id',
  LastLogin = 'lastLogin',
  Role = 'role',
  Status = 'status',
  UserName = 'userName',
}

export enum User_SortOrder {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export enum User_Status {
  Active = 'Active',
  Inactive = 'Inactive',
  Locked = 'Locked',
}

export type User_UpdateInput = {
  additionalInfo?: InputMaybe<User_AdditionalInfoInput>;
  password?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<User_Role>;
  status?: InputMaybe<User_Status>;
  userName?: InputMaybe<Scalars['String']>;
};

export type User_WhereInput = {
  authType?: InputMaybe<User_AuthType>;
  sort?: InputMaybe<User_Sort>;
  statusFilter?: InputMaybe<User_Status>;
};

export type WindowsLicense = {
  __typename?: 'WindowsLicense';
  coordinatorId?: Maybe<Scalars['String']>;
  features?: Maybe<License_Features>;
  isFreeDev?: Maybe<Scalars['Boolean']>;
  isFreeTrial?: Maybe<Scalars['Boolean']>;
  lastUpdateTime?: Maybe<Scalars['Timestamp']>;
  lockNotificationTimeout?: Maybe<Scalars['Int']>;
  status?: Maybe<License_Status>;
  summary?: Maybe<License_Summary>;
  tierName?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
};

export type WindowsSettings = {
  __typename?: 'WindowsSettings';
  agent: AgentSettings;
  coordinator: CoordinatorSettings;
  license: LicenseSettings;
  system: SystemSettings;
};

export type CommonDataQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type CommonDataQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    featureFlags?: string | null;
    settings?: {
      __typename?: 'Settings';
      common: { __typename?: 'CommonSettings'; cloud?: { __typename?: 'CloudSettings'; cloudStatus?: string | null } | null };
      windows?: { __typename?: 'WindowsSettings'; system: { __typename?: 'SystemSettings'; telemetryEnabled?: boolean | null } } | null;
    } | null;
    notificationsCount?: { __typename?: 'Notification_NotificationsCount'; totalCount: number } | null;
    settingsMetadata?: { __typename?: 'Settings_SettingsMetadata'; isCloudActivated?: boolean | null } | null;
    license?: {
      __typename?: 'License';
      key?: string | null;
      state?: number | null;
      windows?: {
        __typename?: 'WindowsLicense';
        lastUpdateTime?: any | null;
        lockNotificationTimeout?: number | null;
        type?: number | null;
        isFreeDev?: boolean | null;
        isFreeTrial?: boolean | null;
        features?: { __typename?: 'License_Features'; productFeatures?: string | null } | null;
      } | null;
      linux?: {
        __typename?: 'LinuxLicense';
        coordinatorId?: string | null;
        licenseName?: string | null;
        maintenanceExpirationDate?: any | null;
        licenseDetails?: Array<{
          __typename?: 'LinuxLicenseDetails';
          packageType?: number | null;
          availablePackages?: number | null;
          totalPackages?: number | null;
          packageBuildServer?: number | null;
          packageNumCores?: number | null;
          coresInUse?: number | null;
        } | null> | null;
      } | null;
      expirationInfo?: { __typename?: 'License_ExpirationInfo'; daysLeft?: number | null; expirationDate?: any | null } | null;
    } | null;
  } | null;
};

export type AgentsLicenseConfigurationQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type AgentsLicenseConfigurationQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    settings?: { __typename?: 'Settings'; windows?: { __typename?: 'WindowsSettings'; license: { __typename?: 'LicenseSettings'; helperCoresAssignmentPercentage?: number | null } } | null } | null;
    license?: {
      __typename?: 'License';
      windows?: {
        __typename?: 'WindowsLicense';
        summary?: {
          __typename?: 'License_Summary';
          totalFixedCores?: number | null;
          totalFloatingCores?: number | null;
          totalFixedCIInitiators?: number | null;
          totalFloatingCIInitiators?: number | null;
          totalFloatingInitiators?: number | null;
          totalFixedInitiators?: number | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type AgentsFiltersMetadataQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type AgentsFiltersMetadataQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    buildGroups?: Array<{
      __typename?: 'BuildGroup';
      id?: string | null;
      name?: string | null;
      cloudEnabled?: boolean | null;
      agentCount?: number | null;
      hasRunningBuild?: boolean | null;
    } | null> | null;
    licenseMetadata?: {
      __typename?: 'License_LicenseMetadata';
      hasBuildCache?: boolean | null;
      hasCiInitiator?: boolean | null;
      hasFixedFloating?: boolean | null;
      hasInitiator?: boolean | null;
    } | null;
    agentsMetadata?: { __typename?: 'Agent_AgentsMetadata'; agentCores?: Array<number | null> | null; maxHelperCacheSize?: number | null; initiatorsCount?: number | null } | null;
    settingsMetadata?: { __typename?: 'Settings_SettingsMetadata'; isCloudActivated?: boolean | null } | null;
  } | null;
};

export type AppBackupStatusQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type AppBackupStatusQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    settings?: {
      __typename?: 'Settings';
      common: {
        __typename?: 'CommonSettings';
        backup: {
          __typename?: 'BackupCoordinatorSettings';
          isOnline?: boolean | null;
          isSameVersion?: boolean | null;
          otherCoordinatorPort?: number | null;
          otherCoordinatorHost?: string | null;
          otherCoordinatorName?: string | null;
          backupCoordinatorNames?: string | null;
          backupCoordinatorHosts?: string | null;
        };
      };
    } | null;
  } | null;
};

export type MessageNotificationsQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
  where?: InputMaybe<Notification_WhereInput>;
}>;

export type MessageNotificationsQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    notifications?: Array<{ __typename?: 'Notification'; id: number; notificationType: number; data?: string | null; createdAt: any } | null> | null;
  } | null;
};

export type Agents_Action_AsyncMutationVariables = Exact<{
  data: Agent_ActionInput;
}>;

export type Agents_Action_AsyncMutation = { __typename?: 'Mutation'; agents_action_async?: any | null };

export type Agents_BuildCache_Update_AsyncMutationVariables = Exact<{
  data: Agent_BuildCacheSettingsInput;
}>;

export type Agents_BuildCache_Update_AsyncMutation = { __typename?: 'Mutation'; agents_buildCache_update_async?: any | null };

export type Authentication_LoginMutationVariables = Exact<{
  user: Authentication_LoginUserInput;
}>;

export type Authentication_LoginMutation = {
  __typename?: 'Mutation';
  authentication_login: { __typename?: 'Authentication_AuthPayload'; accessToken: string; refreshToken: string; userId: number; userStatus?: User_Status | null };
};

export type Authentication_Login_AzureadMutationVariables = Exact<{
  data: Authentication_AzureAdInput;
}>;

export type Authentication_Login_AzureadMutation = {
  __typename?: 'Mutation';
  authentication_login_azuread: { __typename?: 'Authentication_AuthPayload'; accessToken: string; refreshToken: string; userId: number; userStatus?: User_Status | null };
};

export type Authentication_LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type Authentication_LogoutMutation = { __typename?: 'Mutation'; authentication_logout?: boolean | null };

export type Authentication_RefreshMutationVariables = Exact<{ [key: string]: never }>;

export type Authentication_RefreshMutation = {
  __typename?: 'Mutation';
  authentication_refresh: { __typename?: 'Authentication_AuthPayload'; accessToken: string; refreshToken: string; userId: number; userStatus?: User_Status | null };
};

export type Authentication_Save_Azuread_CodeMutationVariables = Exact<{
  data: Authentication_AzureAdInput;
}>;

export type Authentication_Save_Azuread_CodeMutation = { __typename?: 'Mutation'; authentication_save_azuread_code?: boolean | null };

export type BuildGroup_Add_AsyncMutationVariables = Exact<{
  data: BuildGroup_AddInput;
}>;

export type BuildGroup_Add_AsyncMutation = { __typename?: 'Mutation'; buildGroup_add_async?: any | null };

export type BuildGroup_Delete_AsyncMutationVariables = Exact<{
  data: BuildGroup_DeleteInput;
}>;

export type BuildGroup_Delete_AsyncMutation = { __typename?: 'Mutation'; buildGroup_delete_async?: any | null };

export type BuildGroup_Edit_AsyncMutationVariables = Exact<{
  data: BuildGroup_EditInput;
}>;

export type BuildGroup_Edit_AsyncMutation = { __typename?: 'Mutation'; buildGroup_edit_async?: any | null };

export type Cloud_Action_AsyncMutationVariables = Exact<{
  data: Cloud_ActionInput;
}>;

export type Cloud_Action_AsyncMutation = { __typename?: 'Mutation'; cloud_action_async?: any | null };

export type Cloud_Action_Wakeup_AsyncMutationVariables = Exact<{
  data: Cloud_Wakeup_ActionInput;
}>;

export type Cloud_Action_Wakeup_AsyncMutation = { __typename?: 'Mutation'; cloud_action_wakeup_async?: any | null };

export type Cloud_Action_Wakeup_Machine_AsyncMutationVariables = Exact<{
  data: Cloud_Wakeup_Machine_ActionInput;
}>;

export type Cloud_Action_Wakeup_Machine_AsyncMutation = { __typename?: 'Mutation'; cloud_action_wakeup_machine_async?: any | null };

export type Cloud_Set_Cloud_SecretMutationVariables = Exact<{
  coordinatorId: Scalars['String'];
  secret: Scalars['String'];
}>;

export type Cloud_Set_Cloud_SecretMutation = { __typename?: 'Mutation'; cloud_set_cloud_secret?: { __typename?: 'Cloud_Response'; status?: string | null; message?: string | null } | null };

export type Cluster_Add_NodesMutationVariables = Exact<{
  data?: InputMaybe<Cluster_Nodes_AddInput>;
}>;

export type Cluster_Add_NodesMutation = {
  __typename?: 'Mutation';
  cluster_add_nodes?: {
    __typename?: 'Cluster_Add_Nodes_Result';
    result?: Array<{ __typename?: 'Cluster_Add_Node_Result'; agentId?: string | null; agentName?: string | null; status?: string | null } | null> | null;
  } | null;
};

export type Cluster_CreateMutationVariables = Exact<{
  name: Scalars['String'];
}>;

export type Cluster_CreateMutation = {
  __typename?: 'Mutation';
  cluster_create?: {
    __typename?: 'Cluster';
    id: number;
    name: string;
    createdAt?: any | null;
    nodes?: Array<{ __typename?: 'Cluster_Nodes'; agentId: string; port?: number | null } | null> | null;
  } | null;
};

export type Cluster_DeleteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type Cluster_DeleteMutation = { __typename?: 'Mutation'; cluster_delete?: boolean | null };

export type Cluster_EditMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
}>;

export type Cluster_EditMutation = { __typename?: 'Mutation'; cluster_edit?: boolean | null };

export type Cluster_Remove_NodesMutationVariables = Exact<{
  data?: InputMaybe<Cluster_Nodes_RemoveInput>;
}>;

export type Cluster_Remove_NodesMutation = { __typename?: 'Mutation'; cluster_remove_nodes?: { __typename?: 'Cluster_Remove_Nodes_Result'; status?: string | null } | null };

export type Key_CreateMutationVariables = Exact<{
  data?: InputMaybe<Key_CreateInput>;
}>;

export type Key_CreateMutation = {
  __typename?: 'Mutation';
  key_create?: {
    __typename?: 'Key_Action_Response';
    status?: string | null;
    message?: string | null;
    apiKey?: {
      __typename?: 'Key_Object';
      key: string;
      status?: Key_StatusType | null;
      description?: string | null;
      createdAt?: any | null;
      lastUsed?: any | null;
      expirationDate?: any | null;
      createdByUserId?: string | null;
      createdBy?: string | null;
      role?: Key_Role | null;
    } | null;
  } | null;
};

export type Key_DeactivateMutationVariables = Exact<{
  apiKey: Scalars['String'];
}>;

export type Key_DeactivateMutation = {
  __typename?: 'Mutation';
  key_deactivate?: {
    __typename?: 'Key_Action_Response';
    status?: string | null;
    message?: string | null;
    apiKey?: {
      __typename?: 'Key_Object';
      key: string;
      status?: Key_StatusType | null;
      description?: string | null;
      createdAt?: any | null;
      lastUsed?: any | null;
      expirationDate?: any | null;
      createdByUserId?: string | null;
      createdBy?: string | null;
      role?: Key_Role | null;
    } | null;
  } | null;
};

export type Key_Update_DescriptionMutationVariables = Exact<{
  apiKey: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
}>;

export type Key_Update_DescriptionMutation = { __typename?: 'Mutation'; key_update_description?: { __typename?: 'Key_Action_Base_Response'; status?: string | null; message?: string | null } | null };

export type Key_Update_RoleMutationVariables = Exact<{
  apiKey: Scalars['String'];
  role?: InputMaybe<Key_Role>;
}>;

export type Key_Update_RoleMutation = { __typename?: 'Mutation'; key_update_role?: { __typename?: 'Key_Action_Base_Response'; status?: string | null; message?: string | null } | null };

export type License_Action_Activate_AsyncMutationVariables = Exact<{
  licenseKey: Scalars['String'];
}>;

export type License_Action_Activate_AsyncMutation = { __typename?: 'Mutation'; license_action_activate_async?: any | null };

export type License_Action_Deactivate_AsyncMutationVariables = Exact<{
  licenseKey: Scalars['String'];
}>;

export type License_Action_Deactivate_AsyncMutation = { __typename?: 'Mutation'; license_action_deactivate_async?: any | null };

export type License_Action_Generate_Key_AsyncMutationVariables = Exact<{ [key: string]: never }>;

export type License_Action_Generate_Key_AsyncMutation = { __typename?: 'Mutation'; license_action_generate_key_async?: any | null };

export type License_Action_Refresh_AsyncMutationVariables = Exact<{ [key: string]: never }>;

export type License_Action_Refresh_AsyncMutation = { __typename?: 'Mutation'; license_action_refresh_async?: any | null };

export type License_RegisterAgents_AsyncMutationVariables = Exact<{
  data: Array<License_RegisterAgentRequest> | License_RegisterAgentRequest;
}>;

export type License_RegisterAgents_AsyncMutation = { __typename?: 'Mutation'; license_registerAgents_async?: any | null };

export type License_RegisterBuildCache_AsyncMutationVariables = Exact<{
  data?: InputMaybe<Array<License_RegisterBuildCacheRequest> | License_RegisterBuildCacheRequest>;
}>;

export type License_RegisterBuildCache_AsyncMutation = { __typename?: 'Mutation'; license_registerBuildCache_async?: any | null };

export type PersistentData_DeleteMutationVariables = Exact<{
  where: PersistentData_WhereInput;
}>;

export type PersistentData_DeleteMutation = { __typename?: 'Mutation'; persistentData_delete?: boolean | null };

export type PersistentData_SetMutationVariables = Exact<{
  data: PersistentData_SetInput;
}>;

export type PersistentData_SetMutation = { __typename?: 'Mutation'; persistentData_set?: boolean | null };

export type Settings_ChangeCoordinatorPort_AsyncMutationVariables = Exact<{
  port: Scalars['Int'];
}>;

export type Settings_ChangeCoordinatorPort_AsyncMutation = { __typename?: 'Mutation'; settings_changeCoordinatorPort_async?: any | null };

export type Settings_ChangeManagerPortMutationVariables = Exact<{
  port: Scalars['Int'];
}>;

export type Settings_ChangeManagerPortMutation = {
  __typename?: 'Mutation';
  settings_changeManagerPort?: { __typename?: 'Settings_PortCheckResult'; port: number; status?: string | null; message?: string | null } | null;
};

export type Settings_CheckPort_AsyncMutationVariables = Exact<{
  data: Settings_CheckPortInput;
}>;

export type Settings_CheckPort_AsyncMutation = { __typename?: 'Mutation'; settings_checkPort_async?: any | null };

export type Settings_ExternalAuth_Azure_UpdateMutationVariables = Exact<{
  input: AzureAdAuthenticationInput;
}>;

export type Settings_ExternalAuth_Azure_UpdateMutation = {
  __typename?: 'Mutation';
  settings_externalAuth_azure_update?: { __typename?: 'Auth_Result'; result?: { __typename?: 'Auth_Result_Content'; status: string; errorCode?: Auth_Result_ErrorCode | null } | null } | null;
};

export type Settings_ExternalAuth_DeleteMutationVariables = Exact<{
  input: ExternalAuthenticationDeleteInput;
}>;

export type Settings_ExternalAuth_DeleteMutation = {
  __typename?: 'Mutation';
  settings_externalAuth_delete?: { __typename?: 'Auth_Result'; result?: { __typename?: 'Auth_Result_Content'; status: string; errorCode?: Auth_Result_ErrorCode | null } | null } | null;
};

export type Settings_ExternalAuth_Ldap_UpdateMutationVariables = Exact<{
  input: LdapAuthenticationInput;
}>;

export type Settings_ExternalAuth_Ldap_UpdateMutation = {
  __typename?: 'Mutation';
  settings_externalAuth_ldap_update?: { __typename?: 'Auth_Result'; result?: { __typename?: 'Auth_Result_Content'; status: string; errorCode?: Auth_Result_ErrorCode | null } | null } | null;
};

export type Settings_ExternalAuth_SetStateMutationVariables = Exact<{
  input: ExternalAuthenticationEnableInput;
}>;

export type Settings_ExternalAuth_SetStateMutation = {
  __typename?: 'Mutation';
  settings_externalAuth_setState?: { __typename?: 'Auth_Result'; result?: { __typename?: 'Auth_Result_Content'; status: string; errorCode?: Auth_Result_ErrorCode | null } | null } | null;
};

export type Settings_ExternalAuth_UpdateGroupRolesMutationVariables = Exact<{
  input: ExternalAuthenticationUpdateGroupRolesInput;
}>;

export type Settings_ExternalAuth_UpdateGroupRolesMutation = {
  __typename?: 'Mutation';
  settings_externalAuth_updateGroupRoles?: { __typename?: 'ExternalAuthenticationGroupRolesUpdateResult'; status: string } | null;
};

export type Settings_Update_AsyncMutationVariables = Exact<{
  configurations: Settings_UpdateUserInput;
}>;

export type Settings_Update_AsyncMutation = { __typename?: 'Mutation'; settings_update_async?: any | null };

export type User_CreateMutationVariables = Exact<{
  data?: InputMaybe<User_CreateInput>;
}>;

export type User_CreateMutation = {
  __typename?: 'Mutation';
  user_create?: {
    __typename?: 'User';
    id: number;
    userName: string;
    role: User_Role;
    status?: User_Status | null;
    authType?: string | null;
    local?: boolean | null;
    lastLogin?: any | null;
    additionalInfo?: { __typename?: 'User_AdditionalInfo'; firstName?: string | null; lastName?: string | null; email?: string | null } | null;
  } | null;
};

export type User_UpdateMutationVariables = Exact<{
  id: Scalars['Int'];
  data: User_UpdateInput;
}>;

export type User_UpdateMutation = {
  __typename?: 'Mutation';
  user_update?: {
    __typename?: 'User';
    id: number;
    userName: string;
    role: User_Role;
    status?: User_Status | null;
    authType?: string | null;
    local?: boolean | null;
    lastLogin?: any | null;
    additionalInfo?: { __typename?: 'User_AdditionalInfo'; firstName?: string | null; lastName?: string | null; email?: string | null } | null;
  } | null;
};

export type User_UpdatePasswordMutationVariables = Exact<{
  data: User_PasswordUpdateInput;
}>;

export type User_UpdatePasswordMutation = { __typename?: 'Mutation'; user_updatePassword?: boolean | null };

export type User_UpdatePersonalInfoMutationVariables = Exact<{
  data: User_AdditionalInfoInput;
}>;

export type User_UpdatePersonalInfoMutation = {
  __typename?: 'Mutation';
  user_updatePersonalInfo?: { __typename?: 'User_AdditionalInfo'; firstName?: string | null; lastName?: string | null; email?: string | null } | null;
};

export type AgentsQueryVariables = Exact<{
  filter?: InputMaybe<Agent_WhereInput>;
}>;

export type AgentsQuery = {
  __typename?: 'Query';
  agents?: {
    __typename?: 'Agent_AgentsResult';
    totalCount?: number | null;
    totalFilteredCount?: number | null;
    agents?: Array<{
      __typename?: 'Agent';
      coordinatorId?: string | null;
      id?: string | null;
      name?: string | null;
      ip?: string | null;
      port?: number | null;
      securedPort?: number | null;
      routingIP?: string | null;
      hostComment?: string | null;
      networkInfo?: string | null;
      macAddress?: string | null;
      buildGroup?: string | null;
      type?: Agent_Type | null;
      status?: Agent_Status | null;
      logLevel?: number | null;
      msvcVersion?: string | null;
      netFrameworkVersion?: string | null;
      networkDescription?: string | null;
      loggedUsers?: string | null;
      osVersion?: string | null;
      remoteTaskPriority?: string | null;
      upTime?: any | null;
      lastConnected?: string | null;
      lastOnlineChange?: string | null;
      coresUsed?: number | null;
      runningBuildsTitles?: Array<string | null> | null;
      workingFor?: string | null;
      assignPriority?: Agent_AssignPriority | null;
      buildPriority?: string | null;
      enabled?: boolean | null;
      allowEnableDisable?: boolean | null;
      errors?: string | null;
      warnings?: string | null;
      assignedToInitiator?: string | null;
      cluster?: string | null;
      agentVersion?: {
        __typename?: 'Agent_Version';
        versionText?: string | null;
        majorVersion?: number | null;
        minorVersion?: number | null;
        maintenanceVersion?: number | null;
        buildVersion?: number | null;
      } | null;
      performance?: {
        __typename?: 'Agent_Performance';
        availCPU?: number | null;
        usedCPU?: number | null;
        availDisk?: string | null;
        availMemory?: string | null;
        availVirt?: string | null;
        cpuInfo?: string | null;
        cpuLogical?: number | null;
        cpuPhysical?: number | null;
        cpuSpeed?: number | null;
        cacheSize?: number | null;
        cacheUsed?: number | null;
        totalDisk?: string | null;
        totalMemory?: string | null;
        totalVirt?: string | null;
      } | null;
      updateStatus?: {
        __typename?: 'Agent_UpdateStatus';
        downloadComplete?: boolean | null;
        downloadInProgress?: boolean | null;
        downloadedBytes?: number | null;
        installStarted?: boolean | null;
        installStatus?: string | null;
        quickRollback?: boolean | null;
        updateID?: string | null;
        updateSize?: number | null;
        updateToCurrentVersion?: boolean | null;
      } | null;
      license?: {
        __typename?: 'Agent_License';
        buildCacheAllowed?: boolean | null;
        ciInitiatorType?: License_RegistrationType | null;
        initiatorType?: License_RegistrationType | null;
        helperType?: License_RegistrationType | null;
        helperCores?: number | null;
        initiatorCores?: number | null;
        registeredCores?: number | null;
        initiatorQueued?: boolean | null;
        registeredInitiator?: boolean | null;
        status?: number | null;
      } | null;
      buildCacheSettings?: {
        __typename?: 'Agent_BuildCacheSettings';
        cacheSizeGB?: number | null;
        cacheFolder?: string | null;
        databaseFolder?: string | null;
        useLocalCache?: boolean | null;
        remoteCacheServer?: string | null;
        localBCServicePort?: number | null;
        useBuildCacheCluster?: boolean | null;
        cacheSettingsDisplay?: { __typename?: 'Cache_Settings_Display'; cacheType?: string | null; cacheRemoteValue?: string | null } | null;
      } | null;
      metadata?: {
        __typename?: 'Agent_Metadata';
        isInProgress?: boolean | null;
        isLocal?: boolean | null;
        isSCL?: boolean | null;
        isWindowsAgent?: boolean | null;
        isInitiatorPending?: boolean | null;
        isHelperPending?: boolean | null;
        isHelperDisabled?: boolean | null;
        isBuildAvoidance?: boolean | null;
        isIncompatibleVersion?: boolean | null;
        isDuplicateLicense?: boolean | null;
        isLastDuplicateLicense?: boolean | null;
        isCloud?: boolean | null;
        isHelper?: boolean | null;
        isOnPremHelper?: boolean | null;
        isInitiator?: boolean | null;
        isOffline?: boolean | null;
        isOnline?: boolean | null;
        isLowerThanTenVersion?: boolean | null;
        lastConnectedDate?: string | null;
        isOnlyLocal?: boolean | null;
        isOnlyInitiator?: boolean | null;
        isOnlyHelper?: boolean | null;
        isHelperAndInitiator?: boolean | null;
        isInProcess?: boolean | null;
        isUnlicensed?: boolean | null;
        isCIInitiator?: boolean | null;
        isCIInitiatorPending?: boolean | null;
        isValidForVersionUpdate?: boolean | null;
        agentType?: Agent_Type | null;
      } | null;
      cloud?: {
        __typename?: 'Agent_Cloud';
        machineStatus?: string | null;
        vmType?: string | null;
        spot?: boolean | null;
        numberOfCores?: number | null;
        hdType?: string | null;
        volumeSize?: number | null;
        cacheSize?: number | null;
        zone?: string | null;
        isPool?: boolean | null;
      } | null;
    } | null> | null;
  } | null;
};

export type AgentsActiveInfoQueryVariables = Exact<{ [key: string]: never }>;

export type AgentsActiveInfoQuery = {
  __typename?: 'Query';
  agentsActiveInfo?: {
    __typename?: 'Agent_ActiveInfo';
    activeBuilds?: number | null;
    activeHelpers?: {
      __typename?: 'Agent_ActiveHelpers';
      activeCoresLocal?: number | null;
      activeCoresCloud?: number | null;
      activeCoresRemote?: number | null;
      activeCloudAgents?: number | null;
      activeAgents?: number | null;
    } | null;
    onlineHelpers?: { __typename?: 'Agent_OnlineHelpers'; onlineCloudAgents?: number | null; onlineAgents?: number | null } | null;
  } | null;
};

export type AgentsChangesQueryVariables = Exact<{
  filter?: InputMaybe<Agent_ChangesWhereInput>;
}>;

export type AgentsChangesQuery = {
  __typename?: 'Query';
  agentsChanges?: Array<{
    __typename?: 'Agent';
    coordinatorId?: string | null;
    id?: string | null;
    name?: string | null;
    ip?: string | null;
    port?: number | null;
    securedPort?: number | null;
    routingIP?: string | null;
    hostComment?: string | null;
    networkInfo?: string | null;
    macAddress?: string | null;
    buildGroup?: string | null;
    type?: Agent_Type | null;
    status?: Agent_Status | null;
    logLevel?: number | null;
    msvcVersion?: string | null;
    netFrameworkVersion?: string | null;
    networkDescription?: string | null;
    loggedUsers?: string | null;
    osVersion?: string | null;
    remoteTaskPriority?: string | null;
    upTime?: any | null;
    lastConnected?: string | null;
    lastOnlineChange?: string | null;
    coresUsed?: number | null;
    runningBuildsTitles?: Array<string | null> | null;
    workingFor?: string | null;
    assignPriority?: Agent_AssignPriority | null;
    buildPriority?: string | null;
    enabled?: boolean | null;
    allowEnableDisable?: boolean | null;
    errors?: string | null;
    warnings?: string | null;
    assignedToInitiator?: string | null;
    cluster?: string | null;
    agentVersion?: {
      __typename?: 'Agent_Version';
      versionText?: string | null;
      majorVersion?: number | null;
      minorVersion?: number | null;
      maintenanceVersion?: number | null;
      buildVersion?: number | null;
    } | null;
    performance?: {
      __typename?: 'Agent_Performance';
      availCPU?: number | null;
      usedCPU?: number | null;
      availDisk?: string | null;
      availMemory?: string | null;
      availVirt?: string | null;
      cpuInfo?: string | null;
      cpuLogical?: number | null;
      cpuPhysical?: number | null;
      cpuSpeed?: number | null;
      cacheSize?: number | null;
      cacheUsed?: number | null;
      totalDisk?: string | null;
      totalMemory?: string | null;
      totalVirt?: string | null;
    } | null;
    updateStatus?: {
      __typename?: 'Agent_UpdateStatus';
      downloadComplete?: boolean | null;
      downloadInProgress?: boolean | null;
      downloadedBytes?: number | null;
      installStarted?: boolean | null;
      installStatus?: string | null;
      quickRollback?: boolean | null;
      updateID?: string | null;
      updateSize?: number | null;
      updateToCurrentVersion?: boolean | null;
    } | null;
    license?: {
      __typename?: 'Agent_License';
      buildCacheAllowed?: boolean | null;
      ciInitiatorType?: License_RegistrationType | null;
      initiatorType?: License_RegistrationType | null;
      helperType?: License_RegistrationType | null;
      helperCores?: number | null;
      initiatorCores?: number | null;
      registeredCores?: number | null;
      initiatorQueued?: boolean | null;
      registeredInitiator?: boolean | null;
      status?: number | null;
    } | null;
    buildCacheSettings?: {
      __typename?: 'Agent_BuildCacheSettings';
      cacheSizeGB?: number | null;
      cacheFolder?: string | null;
      databaseFolder?: string | null;
      useLocalCache?: boolean | null;
      remoteCacheServer?: string | null;
      localBCServicePort?: number | null;
      useBuildCacheCluster?: boolean | null;
      cacheSettingsDisplay?: { __typename?: 'Cache_Settings_Display'; cacheType?: string | null; cacheRemoteValue?: string | null } | null;
    } | null;
    metadata?: {
      __typename?: 'Agent_Metadata';
      isInProgress?: boolean | null;
      isLocal?: boolean | null;
      isSCL?: boolean | null;
      isWindowsAgent?: boolean | null;
      isInitiatorPending?: boolean | null;
      isHelperPending?: boolean | null;
      isHelperDisabled?: boolean | null;
      isBuildAvoidance?: boolean | null;
      isIncompatibleVersion?: boolean | null;
      isDuplicateLicense?: boolean | null;
      isLastDuplicateLicense?: boolean | null;
      isCloud?: boolean | null;
      isHelper?: boolean | null;
      isOnPremHelper?: boolean | null;
      isInitiator?: boolean | null;
      isOffline?: boolean | null;
      isOnline?: boolean | null;
      isLowerThanTenVersion?: boolean | null;
      lastConnectedDate?: string | null;
      isOnlyLocal?: boolean | null;
      isOnlyInitiator?: boolean | null;
      isOnlyHelper?: boolean | null;
      isHelperAndInitiator?: boolean | null;
      isInProcess?: boolean | null;
      isUnlicensed?: boolean | null;
      isCIInitiator?: boolean | null;
      isCIInitiatorPending?: boolean | null;
      isValidForVersionUpdate?: boolean | null;
      agentType?: Agent_Type | null;
    } | null;
    cloud?: {
      __typename?: 'Agent_Cloud';
      machineStatus?: string | null;
      vmType?: string | null;
      spot?: boolean | null;
      numberOfCores?: number | null;
      hdType?: string | null;
      volumeSize?: number | null;
      cacheSize?: number | null;
      zone?: string | null;
      isPool?: boolean | null;
    } | null;
  } | null> | null;
};

export type Agents_Action_AsyncResultQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;

export type Agents_Action_AsyncResultQuery = {
  __typename?: 'Query';
  agents_action_asyncResult?: {
    __typename?: 'Agent_Action_AsyncResult';
    result?: Array<{
      __typename?: 'Agent_ActionResult';
      agentId?: string | null;
      agentName?: string | null;
      status?: string | null;
      message?: string | null;
      errorCode?: Agent_ActionResultErrorCodes | null;
    } | null> | null;
  } | null;
};

export type Agents_BuildCache_Update_AsyncResultQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;

export type Agents_BuildCache_Update_AsyncResultQuery = {
  __typename?: 'Query';
  agents_buildCache_update_asyncResult?: {
    __typename?: 'Agent_Action_AsyncResult';
    result?: Array<{
      __typename?: 'Agent_ActionResult';
      agentId?: string | null;
      agentName?: string | null;
      status?: string | null;
      message?: string | null;
      errorCode?: Agent_ActionResultErrorCodes | null;
    } | null> | null;
  } | null;
};

export type Authentication_Get_Azuread_RouteQueryVariables = Exact<{
  data: Authentication_AzureAdRouteInput;
}>;

export type Authentication_Get_Azuread_RouteQuery = {
  __typename?: 'Query';
  authentication_get_azuread_route: { __typename?: 'Authentication_AzureADRoute'; status: string; redirectUri?: string | null };
};

export type Authentication_Get_Login_OptionsQueryVariables = Exact<{ [key: string]: never }>;

export type Authentication_Get_Login_OptionsQuery = {
  __typename?: 'Query';
  authentication_get_login_options: {
    __typename?: 'Authentication_LoginOptions';
    osType?: string | null;
    ldap?: { __typename?: 'Authentication_LoginOption_LDAP'; enabled?: boolean | null; connected?: boolean | null } | null;
    azureAd?: { __typename?: 'Authentication_LoginOption_AzureAD'; enabled?: boolean | null; connected?: boolean | null } | null;
  };
};

export type Authentication_Get_Organization_GroupsQueryVariables = Exact<{
  data: Authentication_ExternalTypeInput;
}>;

export type Authentication_Get_Organization_GroupsQuery = {
  __typename?: 'Query';
  authentication_get_organization_groups: {
    __typename?: 'Authentication_OrganizationGroupsResult';
    errorCode?: Authentication_OrganizationGroupsErrorCode | null;
    groups?: Array<string | null> | null;
  };
};

export type Authentication_Has_Azuread_CodeQueryVariables = Exact<{ [key: string]: never }>;

export type Authentication_Has_Azuread_CodeQuery = { __typename?: 'Query'; authentication_has_azuread_code?: boolean | null };

export type BuildDetailsQueryVariables = Exact<{
  filter?: InputMaybe<Builds_BuildDetailsWhereInput>;
}>;

export type BuildDetailsQuery = {
  __typename?: 'Query';
  buildDetails?: {
    __typename?: 'Builds_BuildDetails';
    buildSummary?: {
      __typename?: 'Build_Summary';
      buildTarget?: string | null;
      workingDir?: string | null;
      ibVersion?: string | null;
      totalTasks?: number | null;
      buildGroup?: string | null;
      initiatorDescription?: string | null;
      initiatorLogLevel?: number | null;
      startTime?: any | null;
      endTime?: any | null;
      duration?: any | null;
      failReason?: Builds_BuildFailReason | null;
      errorsNumber?: number | null;
      warningsNumber?: number | null;
      sysErrorsNumber?: number | null;
      sysWarningsNumber?: number | null;
      isBuildCache?: boolean | null;
      isCloudHelpers?: boolean | null;
      isPredictiveExecution?: boolean | null;
    } | null;
    buildPerformance?: {
      __typename?: 'Build_Performance';
      totalTasks?: number | null;
      localTasks?: number | null;
      localTasksPercentage?: number | null;
      remoteTasks?: number | null;
      remoteTasksPercentage?: number | null;
      distributableTasks?: number | null;
      nonDistributableTasks?: number | null;
      isBuildCache?: boolean | null;
      cacheableTasks?: number | null;
      cacheableTasksPercentage?: number | null;
      uncacheableTasks?: number | null;
      uncacheableTasksPercentage?: number | null;
      cacheTaskHits?: number | null;
      cacheTaskHitsPercentage?: number | null;
      cacheTaskMiss?: number | null;
      cacheTaskMissPercentage?: number | null;
      avgHelperMachines?: number | null;
      maxHelperMachines?: number | null;
      avgHelperCores?: number | null;
      maxHelperCores?: number | null;
      readyOverActiveRatio?: number | null;
      totalCpuTime?: any | null;
      distributedCpuTime?: any | null;
      distributedCpuTimePercentage?: number | null;
      tasksDistribution?: {
        __typename?: 'Build_TasksDistribution';
        remoteTasks?: { __typename?: 'Build_TasksStatusCount'; success?: number | null; warning?: number | null; failed?: number | null } | null;
        localTasks?: { __typename?: 'Build_TasksStatusCount'; success?: number | null; warning?: number | null; failed?: number | null } | null;
      } | null;
      longestTasks?: Array<{
        __typename?: 'Build_LongestTask';
        id?: number | null;
        name?: string | null;
        machineName?: string | null;
        duration?: any | null;
        durationPercentage?: number | null;
      } | null> | null;
    } | null;
  } | null;
};

export type BuildGroup_Add_AsyncResultQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;

export type BuildGroup_Add_AsyncResultQuery = {
  __typename?: 'Query';
  buildGroup_add_asyncResult?: {
    __typename?: 'BuildGroup_AsyncResult';
    result?: { __typename?: 'BuildGroup_Result'; buildGroupId?: string | null; status?: string | null; message?: string | null; applicationErrorCode?: number | null } | null;
  } | null;
};

export type BuildGroup_Delete_AsyncResultQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;

export type BuildGroup_Delete_AsyncResultQuery = {
  __typename?: 'Query';
  buildGroup_delete_asyncResult?: {
    __typename?: 'BuildGroup_AsyncResult';
    result?: { __typename?: 'BuildGroup_Result'; buildGroupId?: string | null; status?: string | null; message?: string | null; applicationErrorCode?: number | null } | null;
  } | null;
};

export type BuildGroup_Edit_AsyncResultQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;

export type BuildGroup_Edit_AsyncResultQuery = {
  __typename?: 'Query';
  buildGroup_edit_asyncResult?: {
    __typename?: 'BuildGroup_AsyncResult';
    result?: { __typename?: 'BuildGroup_Result'; buildGroupId?: string | null; status?: string | null; message?: string | null; applicationErrorCode?: number | null } | null;
  } | null;
};

export type BuildGroupsQueryVariables = Exact<{
  filter?: InputMaybe<BuildGroups_WhereInput>;
  data?: InputMaybe<BuildGroups_Input>;
}>;

export type BuildGroupsQuery = {
  __typename?: 'Query';
  buildGroups?: Array<{
    __typename?: 'BuildGroup';
    id?: string | null;
    name?: string | null;
    cloudEnabled?: boolean | null;
    agentCount?: number | null;
    hasRunningBuild?: boolean | null;
  } | null> | null;
};

export type BuildsQueryVariables = Exact<{
  filter?: InputMaybe<Builds_BuildsWhereInput>;
}>;

export type BuildsQuery = {
  __typename?: 'Query';
  builds?: {
    __typename?: 'Builds_Result';
    totalCount?: number | null;
    totalFilteredCount?: number | null;
    builds?: Array<{
      __typename?: 'Builds_Build';
      buildId?: string | null;
      title?: string | null;
      commandLine?: string | null;
      initiatorName?: string | null;
      initiatorType?: string | null;
      buildGroup?: string | null;
      buildResult?: Builds_BuildResult | null;
      failReason?: Builds_BuildFailReason | null;
      buildType?: Builds_BuildType | null;
      startTime?: any | null;
      endTime?: any | null;
      duration?: any | null;
      totalTasks?: number | null;
      localTasks?: number | null;
      remoteTasks?: number | null;
      cloudTasks?: number | null;
      failedTasks?: number | null;
      distributableTasks?: number | null;
      readyOverActiveRatio?: number | null;
      cacheTaskHits?: number | null;
      cacheTaskMiss?: number | null;
      uncacheableTasks?: number | null;
      maxBusyHelpersCores?: number | null;
      avgBusyHelpersCores?: number | null;
      maxNeededHelpersCores?: number | null;
      agentDescription?: string | null;
      loggedOnUsers?: string | null;
      loggingLevel?: number | null;
      hasExtendedData?: boolean | null;
    } | null> | null;
  } | null;
};

export type BuildsExportCsvQueryVariables = Exact<{
  filter?: InputMaybe<Builds_BuildsWhereInput>;
  fieldsMapping?: InputMaybe<Array<InputMaybe<ExportCsv_FieldsMapping>> | InputMaybe<ExportCsv_FieldsMapping>>;
}>;

export type BuildsExportCsvQuery = { __typename?: 'Query'; buildsExportCSV?: { __typename?: 'ExportCsv_Result'; status?: ExportCsv_Status | null; fileId?: string | null } | null };

export type BuildsMetadataQueryVariables = Exact<{
  filter?: InputMaybe<Builds_BuildsMetadataWhereInput>;
}>;

export type BuildsMetadataQuery = {
  __typename?: 'Query';
  buildsMetadata?: {
    __typename?: 'Builds_Metadata';
    buildGroups?: Array<string | null> | null;
    maxDuration?: number | null;
    oldestBuildStartTime?: any | null;
    hasBuildCache?: boolean | null;
    initiatorTypes?: Array<Builds_InitiatorType | null> | null;
  } | null;
};

export type BuildsSummaryQueryVariables = Exact<{
  filter?: InputMaybe<Builds_SummaryWhereInput>;
}>;

export type BuildsSummaryQuery = {
  __typename?: 'Query';
  buildsSummary?: {
    __typename?: 'Builds_Summary';
    totalBuilds?: number | null;
    successfulBuilds?: number | null;
    uniqueInitiators?: number | null;
    percentile50?: number | null;
    percentile90?: number | null;
  } | null;
};

export type Cloud_Action_AsyncResultQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;

export type Cloud_Action_AsyncResultQuery = {
  __typename?: 'Query';
  cloud_action_asyncResult?: { __typename?: 'Cloud_Action_AsyncResult'; result?: { __typename?: 'Cloud_Response'; status?: string | null; message?: string | null } | null } | null;
};

export type Cloud_Action_Wakeup_AsyncResultQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;

export type Cloud_Action_Wakeup_AsyncResultQuery = {
  __typename?: 'Query';
  cloud_action_wakeup_asyncResult?: { __typename?: 'Cloud_Action_AsyncResult'; result?: { __typename?: 'Cloud_Response'; status?: string | null; message?: string | null } | null } | null;
};

export type Cloud_DataQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type Cloud_DataQuery = {
  __typename?: 'Query';
  cloud_data?: {
    __typename?: 'Cloud_Data';
    coordinatorId?: string | null;
    pool?: {
      __typename?: 'Cloud_Data_Pool';
      initializing?: number | null;
      alive?: number | null;
      ready?: number | null;
      delivered?: number | null;
      wakeingup?: number | null;
      deallocated?: number | null;
      poolSum?: number | null;
    } | null;
  } | null;
};

export type Cloud_Data_PoolQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type Cloud_Data_PoolQuery = {
  __typename?: 'Query';
  cloud_data_pool?: {
    __typename?: 'Cloud_Data_Pool';
    initializing?: number | null;
    alive?: number | null;
    ready?: number | null;
    delivered?: number | null;
    wakeingup?: number | null;
    deallocated?: number | null;
    poolSum?: number | null;
  } | null;
};

export type Cloud_Data_Pool_DeallocatedQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type Cloud_Data_Pool_DeallocatedQuery = { __typename?: 'Query'; cloud_data_pool_deallocated?: { __typename?: 'Cloud_Data_Pool_Deallocated'; deallocated?: number | null } | null };

export type Cloud_UrlQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type Cloud_UrlQuery = { __typename?: 'Query'; cloud_url?: { __typename?: 'Cloud_UrlResult'; cloudUrl?: string | null; token?: string | null; redirectPath?: string | null } | null };

export type ClustersQueryVariables = Exact<{
  filter?: InputMaybe<Cluster_Nodes_WhereInput>;
}>;

export type ClustersQuery = {
  __typename?: 'Query';
  clusters?: Array<{
    __typename?: 'Cluster';
    id: number;
    name: string;
    createdAt?: any | null;
    nodes?: Array<{ __typename?: 'Cluster_Nodes'; agentId: string; port?: number | null } | null> | null;
  } | null> | null;
};

export type CoordinatorsQueryVariables = Exact<{ [key: string]: never }>;

export type CoordinatorsQuery = { __typename?: 'Query'; coordinators?: Array<{ __typename?: 'Coordinator_Result'; coordinatorId?: string | null } | null> | null };

export type DashboardMetadataQueryVariables = Exact<{
  filter?: InputMaybe<Dashboard_Metadata_Filter>;
}>;

export type DashboardMetadataQuery = {
  __typename?: 'Query';
  dashboardMetadata?: {
    __typename?: 'Dashboard_Metadata';
    buildGroups?: Array<string | null> | null;
    hasWorkloads?: boolean | null;
    oldestWorkloadDate?: any | null;
    workloadTypes?: Array<Dashboard_WorkloadType | null> | null;
    initiatorTypes?: Array<Dashboard_InitiatorType | null> | null;
  } | null;
};

export type IbManagerEntitiesQueryVariables = Exact<{
  filter?: InputMaybe<Agent_WhereInput>;
  where?: InputMaybe<Notification_WhereInput>;
  filter1?: InputMaybe<Builds_BuildsWhereInput>;
  filter2?: InputMaybe<Builds_SummaryWhereInput>;
  filter3?: InputMaybe<Builds_BuildsMetadataWhereInput>;
  coordinatorId?: InputMaybe<Scalars['String']>;
}>;

export type IbManagerEntitiesQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    featureFlags?: string | null;
    agents?: {
      __typename?: 'Agent_AgentsResult';
      totalCount?: number | null;
      totalFilteredCount?: number | null;
      agents?: Array<{
        __typename?: 'Agent';
        coordinatorId?: string | null;
        id?: string | null;
        name?: string | null;
        ip?: string | null;
        port?: number | null;
        securedPort?: number | null;
        routingIP?: string | null;
        hostComment?: string | null;
        networkInfo?: string | null;
        macAddress?: string | null;
        buildGroup?: string | null;
        type?: Agent_Type | null;
        status?: Agent_Status | null;
        logLevel?: number | null;
        msvcVersion?: string | null;
        netFrameworkVersion?: string | null;
        networkDescription?: string | null;
        loggedUsers?: string | null;
        osVersion?: string | null;
        remoteTaskPriority?: string | null;
        upTime?: any | null;
        lastConnected?: string | null;
        lastOnlineChange?: string | null;
        coresUsed?: number | null;
        runningBuildsTitles?: Array<string | null> | null;
        workingFor?: string | null;
        assignPriority?: Agent_AssignPriority | null;
        buildPriority?: string | null;
        enabled?: boolean | null;
        allowEnableDisable?: boolean | null;
        errors?: string | null;
        warnings?: string | null;
        assignedToInitiator?: string | null;
        cluster?: string | null;
        agentVersion?: {
          __typename?: 'Agent_Version';
          versionText?: string | null;
          majorVersion?: number | null;
          minorVersion?: number | null;
          maintenanceVersion?: number | null;
          buildVersion?: number | null;
        } | null;
        performance?: {
          __typename?: 'Agent_Performance';
          availCPU?: number | null;
          usedCPU?: number | null;
          availDisk?: string | null;
          availMemory?: string | null;
          availVirt?: string | null;
          cpuInfo?: string | null;
          cpuLogical?: number | null;
          cpuPhysical?: number | null;
          cpuSpeed?: number | null;
          cacheSize?: number | null;
          cacheUsed?: number | null;
          totalDisk?: string | null;
          totalMemory?: string | null;
          totalVirt?: string | null;
        } | null;
        updateStatus?: {
          __typename?: 'Agent_UpdateStatus';
          downloadComplete?: boolean | null;
          downloadInProgress?: boolean | null;
          downloadedBytes?: number | null;
          installStarted?: boolean | null;
          installStatus?: string | null;
          quickRollback?: boolean | null;
          updateID?: string | null;
          updateSize?: number | null;
          updateToCurrentVersion?: boolean | null;
        } | null;
        license?: {
          __typename?: 'Agent_License';
          buildCacheAllowed?: boolean | null;
          ciInitiatorType?: License_RegistrationType | null;
          initiatorType?: License_RegistrationType | null;
          helperType?: License_RegistrationType | null;
          helperCores?: number | null;
          initiatorCores?: number | null;
          registeredCores?: number | null;
          initiatorQueued?: boolean | null;
          registeredInitiator?: boolean | null;
          status?: number | null;
        } | null;
        buildCacheSettings?: {
          __typename?: 'Agent_BuildCacheSettings';
          cacheSizeGB?: number | null;
          cacheFolder?: string | null;
          databaseFolder?: string | null;
          useLocalCache?: boolean | null;
          remoteCacheServer?: string | null;
          localBCServicePort?: number | null;
          useBuildCacheCluster?: boolean | null;
          cacheSettingsDisplay?: { __typename?: 'Cache_Settings_Display'; cacheType?: string | null; cacheRemoteValue?: string | null } | null;
        } | null;
        metadata?: {
          __typename?: 'Agent_Metadata';
          isInProgress?: boolean | null;
          isLocal?: boolean | null;
          isSCL?: boolean | null;
          isWindowsAgent?: boolean | null;
          isInitiatorPending?: boolean | null;
          isHelperPending?: boolean | null;
          isHelperDisabled?: boolean | null;
          isBuildAvoidance?: boolean | null;
          isIncompatibleVersion?: boolean | null;
          isDuplicateLicense?: boolean | null;
          isLastDuplicateLicense?: boolean | null;
          isCloud?: boolean | null;
          isHelper?: boolean | null;
          isOnPremHelper?: boolean | null;
          isInitiator?: boolean | null;
          isOffline?: boolean | null;
          isOnline?: boolean | null;
          isLowerThanTenVersion?: boolean | null;
          lastConnectedDate?: string | null;
          isOnlyLocal?: boolean | null;
          isOnlyInitiator?: boolean | null;
          isOnlyHelper?: boolean | null;
          isHelperAndInitiator?: boolean | null;
          isInProcess?: boolean | null;
          isUnlicensed?: boolean | null;
          isCIInitiator?: boolean | null;
          isCIInitiatorPending?: boolean | null;
          isValidForVersionUpdate?: boolean | null;
          agentType?: Agent_Type | null;
        } | null;
        cloud?: {
          __typename?: 'Agent_Cloud';
          machineStatus?: string | null;
          vmType?: string | null;
          spot?: boolean | null;
          numberOfCores?: number | null;
          hdType?: string | null;
          volumeSize?: number | null;
          cacheSize?: number | null;
          zone?: string | null;
          isPool?: boolean | null;
        } | null;
      } | null> | null;
    } | null;
    agentsMetadata?: { __typename?: 'Agent_AgentsMetadata'; agentCores?: Array<number | null> | null; maxHelperCacheSize?: number | null; initiatorsCount?: number | null } | null;
    licenseMetadata?: {
      __typename?: 'License_LicenseMetadata';
      hasCiInitiator?: boolean | null;
      hasInitiator?: boolean | null;
      hasBuildCache?: boolean | null;
      hasFixedFloating?: boolean | null;
    } | null;
    settingsMetadata?: { __typename?: 'Settings_SettingsMetadata'; isCloudActivated?: boolean | null } | null;
    agentsActiveInfo?: {
      __typename?: 'Agent_ActiveInfo';
      activeBuilds?: number | null;
      activeHelpers?: {
        __typename?: 'Agent_ActiveHelpers';
        activeCoresLocal?: number | null;
        activeCoresCloud?: number | null;
        activeCoresRemote?: number | null;
        activeCloudAgents?: number | null;
        activeAgents?: number | null;
      } | null;
      onlineHelpers?: { __typename?: 'Agent_OnlineHelpers'; onlineCloudAgents?: number | null; onlineAgents?: number | null } | null;
    } | null;
    buildGroups?: Array<{
      __typename?: 'BuildGroup';
      id?: string | null;
      name?: string | null;
      cloudEnabled?: boolean | null;
      agentCount?: number | null;
      hasRunningBuild?: boolean | null;
    } | null> | null;
    license?: {
      __typename?: 'License';
      coordinatorId: string;
      key?: string | null;
      state?: number | null;
      expirationInfo?: { __typename?: 'License_ExpirationInfo'; daysLeft?: number | null; expirationDate?: any | null; contractEndDate?: any | null } | null;
      windows?: {
        __typename?: 'WindowsLicense';
        coordinatorId?: string | null;
        type?: number | null;
        tierName?: string | null;
        lastUpdateTime?: any | null;
        lockNotificationTimeout?: number | null;
        isFreeTrial?: boolean | null;
        isFreeDev?: boolean | null;
        features?: { __typename?: 'License_Features'; addonFeatures?: string | null; productFeatures?: string | null } | null;
        summary?: {
          __typename?: 'License_Summary';
          totalBuildCacheCores?: number | null;
          totalFixedCIInitiators?: number | null;
          totalFixedCores?: number | null;
          totalFixedInitiators?: number | null;
          totalFloatingCIInitiators?: number | null;
          totalFloatingCores?: number | null;
          totalFloatingInitiators?: number | null;
          totalRegisteredFloatingCores?: number | null;
          unlimitedCacheCores?: boolean | null;
          unlimitedHelperCores?: boolean | null;
        } | null;
        status?: {
          __typename?: 'License_Status';
          totalBuildCacheCores?: number | null;
          remainingBuildCacheCores?: number | null;
          buildCacheNextResetTime?: any | null;
          buildCacheResetMinutes?: number | null;
          helperCores?: { __typename?: 'License_HelperCores_Status'; floating?: number | null } | null;
        } | null;
      } | null;
      linux?: {
        __typename?: 'LinuxLicense';
        coordinatorId?: string | null;
        licenseName?: string | null;
        maintenanceExpirationDate?: any | null;
        licenseDetails?: Array<{
          __typename?: 'LinuxLicenseDetails';
          packageType?: number | null;
          availablePackages?: number | null;
          totalPackages?: number | null;
          packageNumCores?: number | null;
          packageBuildServer?: number | null;
          coresInUse?: number | null;
        } | null> | null;
      } | null;
    } | null;
    cloudLicense?: {
      __typename?: 'CloudLicense';
      coordinatorId: string;
      licenseId?: string | null;
      licenseStatus?: string | null;
      licenseType?: string | null;
      activationDate?: any | null;
      expirationDate?: any | null;
      coordSpecificConsumption?: any | null;
      totalLicenseConsumption?: any | null;
      totalCacheConsumption?: any | null;
      coordSpecificCacheConsumption?: any | null;
      hasBuildCache?: boolean | null;
      licenseDetails?: { __typename?: 'Cloud_LicenseDetails'; quantity?: number | null } | null;
      nextLicense?: {
        __typename?: 'NextCloudLicense';
        coordinatorId: string;
        licenseId?: string | null;
        licenseStatus?: string | null;
        licenseType?: string | null;
        activationDate?: any | null;
        expirationDate?: any | null;
        coordSpecificConsumption?: any | null;
        totalLicenseConsumption?: any | null;
        totalCacheConsumption?: any | null;
        coordSpecificCacheConsumption?: any | null;
        hasBuildCache?: boolean | null;
        licenseDetails?: { __typename?: 'Cloud_LicenseDetails'; quantity?: number | null } | null;
      } | null;
    } | null;
    cloudData?: {
      __typename?: 'Cloud_Data';
      coordinatorId?: string | null;
      pool?: {
        __typename?: 'Cloud_Data_Pool';
        initializing?: number | null;
        alive?: number | null;
        ready?: number | null;
        delivered?: number | null;
        wakeingup?: number | null;
        deallocated?: number | null;
        poolSum?: number | null;
      } | null;
    } | null;
    notifications?: Array<{ __typename?: 'Notification'; id: number; notificationType: number; notificationTimestamp: any; data?: string | null; createdAt: any; updatedAt: any } | null> | null;
    notificationsCount?: { __typename?: 'Notification_NotificationsCount'; totalCount: number } | null;
    settings?: {
      __typename?: 'Settings';
      windows?: {
        __typename?: 'WindowsSettings';
        coordinator: {
          __typename?: 'CoordinatorSettings';
          agentCommunicationPort?: number | null;
          agentsUseSecureCommunication?: boolean | null;
          agentCommunicationSSLPort?: number | null;
          sslCNValidationPattern?: string | null;
          restServicePort?: number | null;
        };
        agent: {
          __typename?: 'AgentSettings';
          minPhysicalMemory?: number | null;
          minDiskFree?: number | null;
          minVirtualMemory?: number | null;
          maxWorkers?: number | null;
          runCacheCleanup?: boolean | null;
          cacheCleanupInterval?: number | null;
          ignoreProcesses?: string | null;
          reportInterval?: number | null;
          minIdleLevel?: number | null;
          allowEnableDisableAsHelper?: boolean | null;
          showOfflineFloatingAgents?: boolean | null;
          offlineFloatingAgentsPeriod?: number | null;
        };
        license: {
          __typename?: 'LicenseSettings';
          licenseServerPort?: number | null;
          floatingReleaseTime?: number | null;
          helperCoresAssignmentPercentage?: number | null;
          automaticBuildCacheLicense?: boolean | null;
          defaultCIInitiatorType?: License_RegistrationType | null;
          defaultInitiatorType?: License_RegistrationType | null;
          defaultHelperType?: License_RegistrationType | null;
        };
        system: {
          __typename?: 'SystemSettings';
          ignoreFirewall?: boolean | null;
          allowSystemStandby?: boolean | null;
          telemetryEnabled?: boolean | null;
          prometheusPort?: number | null;
          prometheusEnabled?: boolean | null;
          allowCustomDistributionProfiles?: boolean | null;
        };
      } | null;
      linux?: {
        __typename?: 'LinuxSettings';
        coordinator: {
          __typename?: 'LinuxCoordinatorSettings';
          agentControlPort?: number | null;
          sessionPort?: number | null;
          utilityPort?: number | null;
          buildMaxCores?: number | null;
          agentMaxCpuLoad?: number | null;
          agentMinFreeMemory?: number | null;
          agentReloadTimeout?: number | null;
          autoSubscribeNewAgents?: boolean | null;
        };
        network: {
          __typename?: 'LinuxNetworkSettings';
          ipv6?: boolean | null;
          ssl?: boolean | null;
          useCoordinatorAgentTunnel?: boolean | null;
          coordinatorPort?: number | null;
          coordinatorSSLPort?: number | null;
        };
        system: { __typename?: 'LinuxSystemSettings'; telemetryEnabled?: boolean | null };
      } | null;
      common: {
        __typename?: 'CommonSettings';
        cloud?: { __typename?: 'CloudSettings'; cloudStatus?: string | null; cloudCoordinatorId?: string | null } | null;
        ibManager?: { __typename?: 'IBManagerSettings'; ibManagerPort?: number | null; rabbitMqPort?: number | null; coordinatorHostname?: string | null } | null;
        backup: {
          __typename?: 'BackupCoordinatorSettings';
          backupCoordinatorBuildNumbers?: string | null;
          backupCoordinatorHosts?: string | null;
          backupCoordinatorNames?: string | null;
          backupCoordinatorPorts?: string | null;
          backupCoordinatorTimeout?: number | null;
          backupCoordinatorSyncFrequency?: number | null;
          otherCoordinatorBuildNumber?: number | null;
          otherCoordinatorName?: string | null;
          otherCoordinatorHost?: string | null;
          otherCoordinatorPort?: number | null;
          isOnline?: boolean | null;
          isSameVersion?: boolean | null;
        };
        auth?: { __typename?: 'Settings_ExternalAuth'; enabled?: boolean | null; authenticationType?: External_Authentication_Type | null } | null;
      };
    } | null;
    coordinatorInfo?: {
      __typename?: 'Coordinator_Info';
      coordinatorId?: string | null;
      runningSince?: any | null;
      majorVersion?: number | null;
      minorVersion?: number | null;
      maintenanceVersion?: number | null;
      buildVersion?: number | null;
      versionText?: string | null;
    } | null;
    builds?: {
      __typename?: 'Builds_Result';
      totalCount?: number | null;
      totalFilteredCount?: number | null;
      builds?: Array<{
        __typename?: 'Builds_Build';
        buildId?: string | null;
        title?: string | null;
        commandLine?: string | null;
        initiatorName?: string | null;
        initiatorType?: string | null;
        buildGroup?: string | null;
        buildResult?: Builds_BuildResult | null;
        failReason?: Builds_BuildFailReason | null;
        buildType?: Builds_BuildType | null;
        startTime?: any | null;
        endTime?: any | null;
        duration?: any | null;
        totalTasks?: number | null;
        localTasks?: number | null;
        remoteTasks?: number | null;
        cloudTasks?: number | null;
        failedTasks?: number | null;
        distributableTasks?: number | null;
        readyOverActiveRatio?: number | null;
        cacheTaskHits?: number | null;
        cacheTaskMiss?: number | null;
        uncacheableTasks?: number | null;
        maxBusyHelpersCores?: number | null;
        avgBusyHelpersCores?: number | null;
        maxNeededHelpersCores?: number | null;
        agentDescription?: string | null;
        loggedOnUsers?: string | null;
        loggingLevel?: number | null;
        hasExtendedData?: boolean | null;
      } | null> | null;
    } | null;
    buildsSummary?: {
      __typename?: 'Builds_Summary';
      totalBuilds?: number | null;
      successfulBuilds?: number | null;
      uniqueInitiators?: number | null;
      percentile50?: number | null;
      percentile90?: number | null;
    } | null;
    buildsMetadata?: {
      __typename?: 'Builds_Metadata';
      buildGroups?: Array<string | null> | null;
      maxDuration?: number | null;
      oldestBuildStartTime?: any | null;
      hasBuildCache?: boolean | null;
      initiatorTypes?: Array<Builds_InitiatorType | null> | null;
    } | null;
    systemInfo?: { __typename?: 'System_Info'; fqdn?: string | null; hostname?: string | null; ip?: string | null } | null;
  } | null;
};

export type KeyQueryVariables = Exact<{
  apiKey: Scalars['String'];
}>;

export type KeyQuery = {
  __typename?: 'Query';
  key?: {
    __typename?: 'Key_Object';
    key: string;
    status?: Key_StatusType | null;
    description?: string | null;
    createdAt?: any | null;
    lastUsed?: any | null;
    expirationDate?: any | null;
    createdByUserId?: string | null;
    createdBy?: string | null;
    role?: Key_Role | null;
  } | null;
};

export type KeysQueryVariables = Exact<{
  filter?: InputMaybe<Key_WhereInput>;
}>;

export type KeysQuery = {
  __typename?: 'Query';
  keys?: Array<{
    __typename?: 'Key_Object';
    key: string;
    status?: Key_StatusType | null;
    description?: string | null;
    createdAt?: any | null;
    lastUsed?: any | null;
    expirationDate?: any | null;
    createdByUserId?: string | null;
    createdBy?: string | null;
    role?: Key_Role | null;
  } | null> | null;
};

export type LicenseQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type LicenseQuery = {
  __typename?: 'Query';
  license?: {
    __typename?: 'License';
    coordinatorId: string;
    key?: string | null;
    state?: number | null;
    expirationInfo?: { __typename?: 'License_ExpirationInfo'; daysLeft?: number | null; expirationDate?: any | null; contractEndDate?: any | null } | null;
    windows?: {
      __typename?: 'WindowsLicense';
      coordinatorId?: string | null;
      type?: number | null;
      tierName?: string | null;
      lastUpdateTime?: any | null;
      lockNotificationTimeout?: number | null;
      isFreeTrial?: boolean | null;
      isFreeDev?: boolean | null;
      features?: { __typename?: 'License_Features'; addonFeatures?: string | null; productFeatures?: string | null } | null;
      summary?: {
        __typename?: 'License_Summary';
        totalBuildCacheCores?: number | null;
        totalFixedCIInitiators?: number | null;
        totalFixedCores?: number | null;
        totalFixedInitiators?: number | null;
        totalFloatingCIInitiators?: number | null;
        totalFloatingCores?: number | null;
        totalFloatingInitiators?: number | null;
        totalRegisteredFloatingCores?: number | null;
        unlimitedCacheCores?: boolean | null;
        unlimitedHelperCores?: boolean | null;
      } | null;
      status?: {
        __typename?: 'License_Status';
        totalBuildCacheCores?: number | null;
        remainingBuildCacheCores?: number | null;
        buildCacheNextResetTime?: any | null;
        buildCacheResetMinutes?: number | null;
        initiator?: {
          __typename?: 'License_RegistrationType_Status';
          all?: {
            __typename?: 'License_RegistrationType_Totals';
            assigned?: number | null;
            available?: number | null;
            cooldown?: number | null;
            cooldownNextRelease?: any | null;
            total?: number | null;
          } | null;
          floating?: {
            __typename?: 'License_RegistrationType_Totals';
            assigned?: number | null;
            available?: number | null;
            cooldown?: number | null;
            cooldownNextRelease?: any | null;
            total?: number | null;
          } | null;
          fixed?: {
            __typename?: 'License_RegistrationType_Totals';
            assigned?: number | null;
            available?: number | null;
            cooldown?: number | null;
            cooldownNextRelease?: any | null;
            total?: number | null;
          } | null;
        } | null;
        ciInitiator?: {
          __typename?: 'License_RegistrationType_Status';
          all?: {
            __typename?: 'License_RegistrationType_Totals';
            assigned?: number | null;
            available?: number | null;
            cooldown?: number | null;
            cooldownNextRelease?: any | null;
            total?: number | null;
          } | null;
          floating?: {
            __typename?: 'License_RegistrationType_Totals';
            assigned?: number | null;
            available?: number | null;
            cooldown?: number | null;
            cooldownNextRelease?: any | null;
            total?: number | null;
          } | null;
          fixed?: {
            __typename?: 'License_RegistrationType_Totals';
            assigned?: number | null;
            available?: number | null;
            cooldown?: number | null;
            cooldownNextRelease?: any | null;
            total?: number | null;
          } | null;
        } | null;
        helperCores?: {
          __typename?: 'License_HelperCores_Status';
          floating?: number | null;
          fixed?: {
            __typename?: 'License_RegistrationType_Totals';
            assigned?: number | null;
            available?: number | null;
            cooldown?: number | null;
            cooldownNextRelease?: any | null;
            total?: number | null;
          } | null;
        } | null;
      } | null;
    } | null;
    linux?: {
      __typename?: 'LinuxLicense';
      coordinatorId?: string | null;
      licenseName?: string | null;
      maintenanceExpirationDate?: any | null;
      licenseDetails?: Array<{
        __typename?: 'LinuxLicenseDetails';
        packageType?: number | null;
        availablePackages?: number | null;
        totalPackages?: number | null;
        packageNumCores?: number | null;
        packageBuildServer?: number | null;
        coresInUse?: number | null;
      } | null> | null;
    } | null;
  } | null;
};

export type License_Action_AsyncResultQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;

export type License_Action_AsyncResultQuery = {
  __typename?: 'Query';
  license_action_asyncResult?: { __typename?: 'License_StateInfo_AsyncResult'; result?: { __typename?: 'License_StateInfo'; errorCode: number; state: number } | null } | null;
};

export type License_Action_Generate_AsyncResultQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;

export type License_Action_Generate_AsyncResultQuery = {
  __typename?: 'Query';
  license_action_generate_asyncResult?: {
    __typename?: 'License_GenerateKey_AsyncResult';
    result?: { __typename?: 'License_GenerateKey'; status?: string | null; message?: string | null; key?: string | null } | null;
  } | null;
};

export type License_CloudQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type License_CloudQuery = {
  __typename?: 'Query';
  license_cloud?: {
    __typename?: 'CloudLicense';
    coordinatorId: string;
    licenseId?: string | null;
    licenseStatus?: string | null;
    licenseType?: string | null;
    activationDate?: any | null;
    expirationDate?: any | null;
    coordSpecificConsumption?: any | null;
    totalLicenseConsumption?: any | null;
    totalCacheConsumption?: any | null;
    coordSpecificCacheConsumption?: any | null;
    hasBuildCache?: boolean | null;
    licenseDetails?: { __typename?: 'Cloud_LicenseDetails'; quantity?: number | null } | null;
    nextLicense?: {
      __typename?: 'NextCloudLicense';
      coordinatorId: string;
      licenseId?: string | null;
      licenseStatus?: string | null;
      licenseType?: string | null;
      activationDate?: any | null;
      expirationDate?: any | null;
      coordSpecificConsumption?: any | null;
      totalLicenseConsumption?: any | null;
      totalCacheConsumption?: any | null;
      coordSpecificCacheConsumption?: any | null;
      hasBuildCache?: boolean | null;
      licenseDetails?: { __typename?: 'Cloud_LicenseDetails'; quantity?: number | null } | null;
    } | null;
  } | null;
};

export type License_LicenseKeyQueryVariables = Exact<{ [key: string]: never }>;

export type License_LicenseKeyQuery = { __typename?: 'Query'; license_licenseKey?: string | null };

export type License_RegisterAgents_AsyncResultQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;

export type License_RegisterAgents_AsyncResultQuery = {
  __typename?: 'Query';
  license_registerAgents_asyncResult?: {
    __typename?: 'Agent_Action_AsyncResult';
    result?: Array<{
      __typename?: 'Agent_ActionResult';
      agentId?: string | null;
      agentName?: string | null;
      status?: string | null;
      message?: string | null;
      errorCode?: Agent_ActionResultErrorCodes | null;
    } | null> | null;
  } | null;
};

export type License_RegisterBuildCache_AsyncResultQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;

export type License_RegisterBuildCache_AsyncResultQuery = {
  __typename?: 'Query';
  license_registerBuildCache_asyncResult?: {
    __typename?: 'Agent_Action_AsyncResult';
    result?: Array<{
      __typename?: 'Agent_ActionResult';
      agentId?: string | null;
      agentName?: string | null;
      status?: string | null;
      message?: string | null;
      errorCode?: Agent_ActionResultErrorCodes | null;
    } | null> | null;
  } | null;
};

export type NotificationsQueryVariables = Exact<{
  where?: InputMaybe<Notification_WhereInput>;
}>;

export type NotificationsQuery = {
  __typename?: 'Query';
  notifications?: Array<{ __typename?: 'Notification'; id: number; notificationType: number; notificationTimestamp: any; data?: string | null; createdAt: any; updatedAt: any } | null> | null;
};

export type PersistentDataQueryVariables = Exact<{
  where: PersistentData_WhereInput;
}>;

export type PersistentDataQuery = { __typename?: 'Query'; persistentData?: string | null };

export type SettingsQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type SettingsQuery = {
  __typename?: 'Query';
  settings?: {
    __typename?: 'Settings';
    windows?: {
      __typename?: 'WindowsSettings';
      coordinator: {
        __typename?: 'CoordinatorSettings';
        agentCommunicationPort?: number | null;
        agentsUseSecureCommunication?: boolean | null;
        agentCommunicationSSLPort?: number | null;
        sslCNValidationPattern?: string | null;
        restServicePort?: number | null;
      };
      agent: {
        __typename?: 'AgentSettings';
        minPhysicalMemory?: number | null;
        minDiskFree?: number | null;
        minVirtualMemory?: number | null;
        maxWorkers?: number | null;
        runCacheCleanup?: boolean | null;
        cacheCleanupInterval?: number | null;
        ignoreProcesses?: string | null;
        reportInterval?: number | null;
        minIdleLevel?: number | null;
        allowEnableDisableAsHelper?: boolean | null;
        showOfflineFloatingAgents?: boolean | null;
        offlineFloatingAgentsPeriod?: number | null;
      };
      license: {
        __typename?: 'LicenseSettings';
        licenseServerPort?: number | null;
        floatingReleaseTime?: number | null;
        helperCoresAssignmentPercentage?: number | null;
        automaticBuildCacheLicense?: boolean | null;
        defaultCIInitiatorType?: License_RegistrationType | null;
        defaultInitiatorType?: License_RegistrationType | null;
        defaultHelperType?: License_RegistrationType | null;
      };
      system: {
        __typename?: 'SystemSettings';
        ignoreFirewall?: boolean | null;
        allowSystemStandby?: boolean | null;
        telemetryEnabled?: boolean | null;
        prometheusPort?: number | null;
        prometheusEnabled?: boolean | null;
        allowCustomDistributionProfiles?: boolean | null;
      };
    } | null;
    linux?: {
      __typename?: 'LinuxSettings';
      coordinator: {
        __typename?: 'LinuxCoordinatorSettings';
        agentControlPort?: number | null;
        sessionPort?: number | null;
        utilityPort?: number | null;
        buildMaxCores?: number | null;
        agentMaxCpuLoad?: number | null;
        agentMinFreeMemory?: number | null;
        agentReloadTimeout?: number | null;
        autoSubscribeNewAgents?: boolean | null;
      };
      network: {
        __typename?: 'LinuxNetworkSettings';
        ipv6?: boolean | null;
        ssl?: boolean | null;
        useCoordinatorAgentTunnel?: boolean | null;
        coordinatorPort?: number | null;
        coordinatorSSLPort?: number | null;
      };
      system: { __typename?: 'LinuxSystemSettings'; telemetryEnabled?: boolean | null };
    } | null;
    common: {
      __typename?: 'CommonSettings';
      cloud?: { __typename?: 'CloudSettings'; cloudStatus?: string | null; cloudCoordinatorId?: string | null } | null;
      ibManager?: { __typename?: 'IBManagerSettings'; ibManagerPort?: number | null; rabbitMqPort?: number | null; coordinatorHostname?: string | null } | null;
      backup: {
        __typename?: 'BackupCoordinatorSettings';
        backupCoordinatorBuildNumbers?: string | null;
        backupCoordinatorHosts?: string | null;
        backupCoordinatorNames?: string | null;
        backupCoordinatorPorts?: string | null;
        backupCoordinatorTimeout?: number | null;
        backupCoordinatorSyncFrequency?: number | null;
        otherCoordinatorBuildNumber?: number | null;
        otherCoordinatorName?: string | null;
        otherCoordinatorHost?: string | null;
        otherCoordinatorPort?: number | null;
        isOnline?: boolean | null;
        isSameVersion?: boolean | null;
      };
      auth?: {
        __typename?: 'Settings_ExternalAuth';
        enabled?: boolean | null;
        authenticationType?: External_Authentication_Type | null;
        externalAuths?: {
          __typename?: 'ExternalAuthentication';
          ldapAuth?: {
            __typename?: 'LDAPAuthentication';
            enabled?: boolean | null;
            authenticationType: External_Authentication_Type;
            url?: Array<string | null> | null;
            bindDN?: string | null;
            searchBase?: string | null;
            usernameAttribute?: string | null;
            certificateAuthority?: string | null;
            groupSearchBase?: string | null;
          } | null;
          azureADAuth?: { __typename?: 'AzureADAuthentication'; enabled?: boolean | null; authenticationType: External_Authentication_Type; tenantId?: string | null; clientId?: string | null } | null;
        } | null;
      } | null;
    };
  } | null;
};

export type Settings_ChangeCoordinatorPort_AsyncResultQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;

export type Settings_ChangeCoordinatorPort_AsyncResultQuery = {
  __typename?: 'Query';
  settings_changeCoordinatorPort_asyncResult?: {
    __typename?: 'Settings_PortCheck_AsyncResult';
    result?: { __typename?: 'Settings_PortCheckResult'; port: number; status?: string | null; message?: string | null } | null;
  } | null;
};

export type Settings_CheckPort_AsyncResultQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;

export type Settings_CheckPort_AsyncResultQuery = {
  __typename?: 'Query';
  settings_checkPort_asyncResult?: {
    __typename?: 'Settings_PortCheck_AsyncResult';
    result?: { __typename?: 'Settings_PortCheckResult'; port: number; status?: string | null; message?: string | null } | null;
  } | null;
};

export type Settings_ExternalAuthsQueryVariables = Exact<{ [key: string]: never }>;

export type Settings_ExternalAuthsQuery = {
  __typename?: 'Query';
  settings_externalAuths?: {
    __typename?: 'ExternalAuthentication';
    ldapAuth?: {
      __typename?: 'LDAPAuthentication';
      enabled?: boolean | null;
      authenticationType: External_Authentication_Type;
      url?: Array<string | null> | null;
      bindDN?: string | null;
      searchBase?: string | null;
      usernameAttribute?: string | null;
      certificateAuthority?: string | null;
      groupSearchBase?: string | null;
      groupRoleMapping?: Array<{ __typename?: 'ExternalAuthenticationOrganizationGroupMapping'; group?: string | null; role?: string | null } | null> | null;
    } | null;
    azureADAuth?: {
      __typename?: 'AzureADAuthentication';
      enabled?: boolean | null;
      authenticationType: External_Authentication_Type;
      tenantId?: string | null;
      clientId?: string | null;
      groupRoleMapping?: Array<{ __typename?: 'ExternalAuthenticationOrganizationGroupMapping'; group?: string | null; role?: string | null } | null> | null;
    } | null;
  } | null;
};

export type Settings_Telemetry_EnabledQueryVariables = Exact<{ [key: string]: never }>;

export type Settings_Telemetry_EnabledQuery = { __typename?: 'Query'; settings_telemetry_enabled?: string | null };

export type Settings_Update_AsyncResultQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;

export type Settings_Update_AsyncResultQuery = {
  __typename?: 'Query';
  settings_update_asyncResult?: {
    __typename?: 'Settings_Update_AsyncResult';
    result?: Array<{ __typename?: 'SystemConfiguration_SettingsResult'; key: string; message?: string | null; status?: string | null } | null> | null;
  } | null;
};

export type SystemInfoQueryVariables = Exact<{ [key: string]: never }>;

export type SystemInfoQuery = { __typename?: 'Query'; systemInfo?: { __typename?: 'System_Info'; fqdn?: string | null; hostname?: string | null; ip?: string | null } | null };

export type SystemUtilizationQueryVariables = Exact<{
  filter?: InputMaybe<Dashboard_Filter>;
}>;

export type SystemUtilizationQuery = {
  __typename?: 'Query';
  systemUtilization?: {
    __typename?: 'Dashboard_SystemUtilization';
    overview?: {
      __typename?: 'Dashboard_Overview';
      totalWorkloads?: number | null;
      totalWorkloadsWithBuildCache?: number | null;
      totalWorkloadsWithoutBuildCache?: number | null;
      avgWorkloadsDuration?: number | null;
      avgWorkloadsWithBuildCacheDuration?: number | null;
      avgWorkloadsWithoutBuildCacheDuration?: number | null;
      totalWorkloadsDuration?: any | null;
    } | null;
    helperNeededRate?: Array<{ __typename?: 'Dashboard_HelperNeededRate'; date?: any | null; maxCores?: number | null; demand?: number | null; availability?: number | null } | null> | null;
    cacheCoresUsage?: Array<{ __typename?: 'Dashboard_CacheCoresUsage'; date?: any | null; cacheCores?: number | null } | null> | null;
    cacheHoursConsumption?: Array<{ __typename?: 'Dashboard_CacheHoursConsumption'; date?: any | null; onPrem?: number | null; cloud?: number | null } | null> | null;
    timeSavedByCache?: Array<{ __typename?: 'Dashboard_TimeSavedByCache'; date?: any | null; totalCpuTime?: any | null; totalSavedTime?: any | null } | null> | null;
    activeInitiatorMachines?: Array<{
      __typename?: 'Dashboard_ActiveInitiatorMachines';
      date?: any | null;
      withInitiatorLicense?: number | null;
      withoutInitiatorLicense?: number | null;
    } | null> | null;
    activeHelperMachines?: Array<{ __typename?: 'Dashboard_ActiveHelperMachines'; date?: any | null; onPrem?: number | null; cloud?: number | null } | null> | null;
  } | null;
};

export type UserQueryVariables = Exact<{ [key: string]: never }>;

export type UserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: number;
    userName: string;
    role: User_Role;
    status?: User_Status | null;
    authType?: string | null;
    local?: boolean | null;
    lastLogin?: any | null;
    additionalInfo?: { __typename?: 'User_AdditionalInfo'; firstName?: string | null; lastName?: string | null; email?: string | null } | null;
  } | null;
};

export type UsersQueryVariables = Exact<{
  filter?: InputMaybe<User_WhereInput>;
}>;

export type UsersQuery = {
  __typename?: 'Query';
  users?: Array<{
    __typename?: 'User';
    id: number;
    userName: string;
    role: User_Role;
    status?: User_Status | null;
    authType?: string | null;
    local?: boolean | null;
    lastLogin?: any | null;
    additionalInfo?: { __typename?: 'User_AdditionalInfo'; firstName?: string | null; lastName?: string | null; email?: string | null } | null;
  } | null> | null;
};

export type WorkloadsQueryVariables = Exact<{
  filter?: InputMaybe<Dashboard_Filter>;
}>;

export type WorkloadsQuery = {
  __typename?: 'Query';
  workloads?: {
    __typename?: 'Dashboard_Workloads';
    overview?: {
      __typename?: 'Dashboard_Overview';
      totalWorkloads?: number | null;
      totalWorkloadsWithBuildCache?: number | null;
      totalWorkloadsWithoutBuildCache?: number | null;
      avgWorkloadsDuration?: number | null;
      avgWorkloadsWithBuildCacheDuration?: number | null;
      avgWorkloadsWithoutBuildCacheDuration?: number | null;
      totalWorkloadsDuration?: any | null;
    } | null;
    totalWorkloads?: Array<{ __typename?: 'Dashboard_TotalWorkloads'; date?: any | null; successful?: number | null; failed?: number | null; canceled?: number | null } | null> | null;
    workloadsDuration?: Array<{ __typename?: 'Dashboard_WorkloadDuration'; date?: any | null; maxWorkloadDuration?: any | null; avgWorkloadDuration?: any | null } | null> | null;
    workloadsDurationPercentile?: { __typename?: 'Dashboard_WorkloadsDurationPercentile'; p100?: any | null; p75?: any | null; p50?: any | null; p25?: any | null } | null;
    workloadsHoursDuration?: {
      __typename?: 'Dashboard_WorkloadsHoursDuration';
      Sunday?: Array<{ __typename?: 'Dashboard_WorkloadHour'; duration?: number | null; totalWorkloads?: number | null } | null> | null;
      Monday?: Array<{ __typename?: 'Dashboard_WorkloadHour'; duration?: number | null; totalWorkloads?: number | null } | null> | null;
      Tuesday?: Array<{ __typename?: 'Dashboard_WorkloadHour'; duration?: number | null; totalWorkloads?: number | null } | null> | null;
      Wednesday?: Array<{ __typename?: 'Dashboard_WorkloadHour'; duration?: number | null; totalWorkloads?: number | null } | null> | null;
      Thursday?: Array<{ __typename?: 'Dashboard_WorkloadHour'; duration?: number | null; totalWorkloads?: number | null } | null> | null;
      Friday?: Array<{ __typename?: 'Dashboard_WorkloadHour'; duration?: number | null; totalWorkloads?: number | null } | null> | null;
      Saturday?: Array<{ __typename?: 'Dashboard_WorkloadHour'; duration?: number | null; totalWorkloads?: number | null } | null> | null;
    } | null;
  } | null;
};

export type CoordinatorInfoQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type CoordinatorInfoQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    coordinatorInfo?: {
      __typename?: 'Coordinator_Info';
      majorVersion?: number | null;
      minorVersion?: number | null;
      maintenanceVersion?: number | null;
      coordinatorId?: string | null;
      runningSince?: any | null;
    } | null;
  } | null;
};

export type AgentsPageQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type AgentsPageQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    agentsActiveInfo?: {
      __typename?: 'Agent_ActiveInfo';
      activeBuilds?: number | null;
      onlineHelpers?: { __typename?: 'Agent_OnlineHelpers'; onlineAgents?: number | null } | null;
      activeHelpers?: {
        __typename?: 'Agent_ActiveHelpers';
        activeCoresLocal?: number | null;
        activeCloudAgents?: number | null;
        activeAgents?: number | null;
        activeCoresCloud?: number | null;
        activeCoresRemote?: number | null;
      } | null;
    } | null;
    license?: {
      __typename?: 'License';
      windows?: {
        __typename?: 'WindowsLicense';
        features?: { __typename?: 'License_Features'; productFeatures?: string | null } | null;
        summary?: {
          __typename?: 'License_Summary';
          totalBuildCacheCores?: number | null;
          totalFixedCIInitiators?: number | null;
          totalFixedCores?: number | null;
          totalFixedInitiators?: number | null;
          totalFloatingCIInitiators?: number | null;
          totalFloatingCores?: number | null;
          totalFloatingInitiators?: number | null;
          totalRegisteredFloatingCores?: number | null;
          unlimitedCacheCores?: boolean | null;
          unlimitedHelperCores?: boolean | null;
        } | null;
        status?: {
          __typename?: 'License_Status';
          totalBuildCacheCores?: number | null;
          remainingBuildCacheCores?: number | null;
          buildCacheNextResetTime?: any | null;
          initiator?: {
            __typename?: 'License_RegistrationType_Status';
            all?: {
              __typename?: 'License_RegistrationType_Totals';
              assigned?: number | null;
              available?: number | null;
              cooldown?: number | null;
              cooldownNextRelease?: any | null;
              total?: number | null;
            } | null;
            floating?: { __typename?: 'License_RegistrationType_Totals'; assigned?: number | null; available?: number | null; total?: number | null } | null;
            fixed?: {
              __typename?: 'License_RegistrationType_Totals';
              assigned?: number | null;
              available?: number | null;
              cooldown?: number | null;
              cooldownNextRelease?: any | null;
              total?: number | null;
            } | null;
          } | null;
          ciInitiator?: {
            __typename?: 'License_RegistrationType_Status';
            all?: {
              __typename?: 'License_RegistrationType_Totals';
              assigned?: number | null;
              available?: number | null;
              cooldown?: number | null;
              cooldownNextRelease?: any | null;
              total?: number | null;
            } | null;
            floating?: { __typename?: 'License_RegistrationType_Totals'; assigned?: number | null; available?: number | null; total?: number | null } | null;
            fixed?: {
              __typename?: 'License_RegistrationType_Totals';
              assigned?: number | null;
              available?: number | null;
              cooldown?: number | null;
              cooldownNextRelease?: any | null;
              total?: number | null;
            } | null;
          } | null;
          helperCores?: {
            __typename?: 'License_HelperCores_Status';
            floating?: number | null;
            fixed?: { __typename?: 'License_RegistrationType_Totals'; assigned?: number | null; available?: number | null } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    settings?: {
      __typename?: 'Settings';
      common: {
        __typename?: 'CommonSettings';
        backup: {
          __typename?: 'BackupCoordinatorSettings';
          isOnline?: boolean | null;
          isSameVersion?: boolean | null;
          otherCoordinatorHost?: string | null;
          otherCoordinatorName?: string | null;
          backupCoordinatorNames?: string | null;
          backupCoordinatorHosts?: string | null;
        };
        cloud?: { __typename?: 'CloudSettings'; cloudStatus?: string | null } | null;
      };
    } | null;
    cloudLicense?: {
      __typename?: 'CloudLicense';
      hasBuildCache?: boolean | null;
      licenseId?: string | null;
      licenseType?: string | null;
      licenseStatus?: string | null;
      expirationDate?: any | null;
      totalLicenseConsumption?: any | null;
      totalCacheConsumption?: any | null;
      licenseDetails?: { __typename?: 'Cloud_LicenseDetails'; quantity?: number | null } | null;
    } | null;
    licenseMetadata?: { __typename?: 'License_LicenseMetadata'; hasBuildCache?: boolean | null } | null;
  } | null;
};

export type SelectedAgentsQueryVariables = Exact<{
  filter?: InputMaybe<Agent_WhereInput>;
}>;

export type SelectedAgentsQuery = {
  __typename?: 'Query';
  agents?: {
    __typename?: 'Agent_AgentsResult';
    agents?: Array<{
      __typename?: 'Agent';
      id?: string | null;
      name?: string | null;
      hostComment?: string | null;
      buildGroup?: string | null;
      logLevel?: number | null;
      assignPriority?: Agent_AssignPriority | null;
      buildPriority?: string | null;
      enabled?: boolean | null;
      allowEnableDisable?: boolean | null;
      status?: Agent_Status | null;
      performance?: { __typename?: 'Agent_Performance'; cpuLogical?: number | null; cacheSize?: number | null; cpuPhysical?: number | null } | null;
      license?: {
        __typename?: 'Agent_License';
        buildCacheAllowed?: boolean | null;
        ciInitiatorType?: License_RegistrationType | null;
        initiatorType?: License_RegistrationType | null;
        helperType?: License_RegistrationType | null;
        helperCores?: number | null;
        registeredCores?: number | null;
        status?: number | null;
      } | null;
      buildCacheSettings?: {
        __typename?: 'Agent_BuildCacheSettings';
        cacheSizeGB?: number | null;
        cacheFolder?: string | null;
        databaseFolder?: string | null;
        useLocalCache?: boolean | null;
        remoteCacheServer?: string | null;
        useBuildCacheCluster?: boolean | null;
        cacheSettingsDisplay?: { __typename?: 'Cache_Settings_Display'; cacheRemoteValue?: string | null; cacheType?: string | null } | null;
      } | null;
      metadata?: {
        __typename?: 'Agent_Metadata';
        isLocal?: boolean | null;
        isHelperDisabled?: boolean | null;
        isHelper?: boolean | null;
        isInitiator?: boolean | null;
        isOnline?: boolean | null;
        isLowerThanTenVersion?: boolean | null;
        isCIInitiator?: boolean | null;
        isValidForVersionUpdate?: boolean | null;
        isCloud?: boolean | null;
        isDuplicateLicense?: boolean | null;
        isIncompatibleVersion?: boolean | null;
        isOffline?: boolean | null;
        isSCL?: boolean | null;
      } | null;
    } | null> | null;
  } | null;
};

export type AgentNamesQueryVariables = Exact<{
  filter?: InputMaybe<Agent_WhereInput>;
}>;

export type AgentNamesQuery = {
  __typename?: 'Query';
  agents?: { __typename?: 'Agent_AgentsResult'; agents?: Array<{ __typename?: 'Agent'; name?: string | null; id?: string | null; status?: Agent_Status | null } | null> | null } | null;
};

export type Getting_StartedQueryVariables = Exact<{
  coordinatorId?: InputMaybe<Scalars['String']>;
  endTime: Scalars['Date'];
}>;

export type Getting_StartedQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    buildsSummary?: { __typename?: 'Builds_Summary'; totalBuilds?: number | null } | null;
    agents?: { __typename?: 'Agent_AgentsResult'; totalCount?: number | null } | null;
    systemInfo?: { __typename?: 'System_Info'; fqdn?: string | null; ip?: string | null } | null;
    settings?: { __typename?: 'Settings'; common: { __typename?: 'CommonSettings'; ibManager?: { __typename?: 'IBManagerSettings'; ibManagerPort?: number | null } | null } } | null;
    license?: { __typename?: 'License'; expirationInfo?: { __typename?: 'License_ExpirationInfo'; daysLeft?: number | null } | null } | null;
  } | null;
};

export type System_InfoQueryVariables = Exact<{ [key: string]: never }>;

export type System_InfoQuery = { __typename?: 'Query'; systemInfo?: { __typename?: 'System_Info'; hostname?: string | null } | null };

export type LicensePageQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type LicensePageQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    coordinatorInfo?: { __typename?: 'Coordinator_Info'; buildVersion?: number | null } | null;
    license?: {
      __typename?: 'License';
      key?: string | null;
      state?: number | null;
      windows?: {
        __typename?: 'WindowsLicense';
        lastUpdateTime?: any | null;
        lockNotificationTimeout?: number | null;
        type?: number | null;
        tierName?: string | null;
        features?: { __typename?: 'License_Features'; productFeatures?: string | null; addonFeatures?: string | null } | null;
        summary?: {
          __typename?: 'License_Summary';
          totalFloatingInitiators?: number | null;
          totalFixedInitiators?: number | null;
          totalFixedCIInitiators?: number | null;
          totalFloatingCIInitiators?: number | null;
          totalBuildCacheCores?: number | null;
          totalFloatingCores?: number | null;
          totalFixedCores?: number | null;
          unlimitedCacheCores?: boolean | null;
          unlimitedHelperCores?: boolean | null;
        } | null;
      } | null;
      linux?: {
        __typename?: 'LinuxLicense';
        coordinatorId?: string | null;
        licenseName?: string | null;
        maintenanceExpirationDate?: any | null;
        licenseDetails?: Array<{
          __typename?: 'LinuxLicenseDetails';
          packageType?: number | null;
          availablePackages?: number | null;
          totalPackages?: number | null;
          packageBuildServer?: number | null;
          packageNumCores?: number | null;
          coresInUse?: number | null;
        } | null> | null;
      } | null;
      expirationInfo?: { __typename?: 'License_ExpirationInfo'; daysLeft?: number | null; expirationDate?: any | null; contractEndDate?: any | null } | null;
    } | null;
  } | null;
};

export type LicenseAddonAndProductQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type LicenseAddonAndProductQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    license?: {
      __typename?: 'License';
      windows?: { __typename?: 'WindowsLicense'; features?: { __typename?: 'License_Features'; productFeatures?: string | null; addonFeatures?: string | null } | null } | null;
    } | null;
  } | null;
};

export type LicenseDetailedViewQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type LicenseDetailedViewQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    license?: {
      __typename?: 'License';
      key?: string | null;
      windows?: {
        __typename?: 'WindowsLicense';
        summary?: {
          __typename?: 'License_Summary';
          totalFloatingInitiators?: number | null;
          totalFixedInitiators?: number | null;
          totalFixedCIInitiators?: number | null;
          totalFloatingCIInitiators?: number | null;
          totalBuildCacheCores?: number | null;
          totalFloatingCores?: number | null;
          totalFixedCores?: number | null;
          unlimitedHelperCores?: boolean | null;
          unlimitedCacheCores?: boolean | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type SettingsPageLinuxQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type SettingsPageLinuxQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    coordinatorInfo?: { __typename?: 'Coordinator_Info'; buildVersion?: number | null } | null;
    settings?: {
      __typename?: 'Settings';
      common: {
        __typename?: 'CommonSettings';
        backup: {
          __typename?: 'BackupCoordinatorSettings';
          otherCoordinatorPort?: number | null;
          otherCoordinatorName?: string | null;
          backupCoordinatorTimeout?: number | null;
          backupCoordinatorSyncFrequency?: number | null;
        };
        cloud?: { __typename?: 'CloudSettings'; cloudStatus?: string | null } | null;
        ibManager?: { __typename?: 'IBManagerSettings'; ibManagerPort?: number | null; rabbitMqPort?: number | null; coordinatorHostname?: string | null } | null;
        auth?: { __typename?: 'Settings_ExternalAuth'; enabled?: boolean | null; authenticationType?: External_Authentication_Type | null } | null;
      };
      linux?: {
        __typename?: 'LinuxSettings';
        coordinator: {
          __typename?: 'LinuxCoordinatorSettings';
          agentControlPort?: number | null;
          sessionPort?: number | null;
          utilityPort?: number | null;
          buildMaxCores?: number | null;
          agentMaxCpuLoad?: number | null;
          agentMinFreeMemory?: number | null;
          agentReloadTimeout?: number | null;
          autoSubscribeNewAgents?: boolean | null;
        };
        system: { __typename?: 'LinuxSystemSettings'; telemetryEnabled?: boolean | null };
        network: {
          __typename?: 'LinuxNetworkSettings';
          ipv6?: boolean | null;
          ssl?: boolean | null;
          useCoordinatorAgentTunnel?: boolean | null;
          coordinatorPort?: number | null;
          coordinatorSSLPort?: number | null;
        };
      } | null;
    } | null;
  } | null;
};

export type SettingsPageWindowsQueryVariables = Exact<{
  coordinatorId: Scalars['String'];
}>;

export type SettingsPageWindowsQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    coordinatorInfo?: { __typename?: 'Coordinator_Info'; buildVersion?: number | null } | null;
    license?: {
      __typename?: 'License';
      windows?: {
        __typename?: 'WindowsLicense';
        tierName?: string | null;
        summary?: { __typename?: 'License_Summary'; totalFloatingCIInitiators?: number | null; totalFloatingInitiators?: number | null; totalBuildCacheCores?: number | null } | null;
      } | null;
    } | null;
    settings?: {
      __typename?: 'Settings';
      common: {
        __typename?: 'CommonSettings';
        cloud?: { __typename?: 'CloudSettings'; cloudStatus?: string | null } | null;
        auth?: { __typename?: 'Settings_ExternalAuth'; enabled?: boolean | null; authenticationType?: External_Authentication_Type | null } | null;
        backup: {
          __typename?: 'BackupCoordinatorSettings';
          backupCoordinatorPorts?: string | null;
          backupCoordinatorHosts?: string | null;
          backupCoordinatorNames?: string | null;
          backupCoordinatorBuildNumbers?: string | null;
          otherCoordinatorHost?: string | null;
          otherCoordinatorName?: string | null;
          otherCoordinatorPort?: number | null;
        };
        ibManager?: { __typename?: 'IBManagerSettings'; ibManagerPort?: number | null; rabbitMqPort?: number | null } | null;
      };
      windows?: {
        __typename?: 'WindowsSettings';
        coordinator: {
          __typename?: 'CoordinatorSettings';
          agentCommunicationSSLPort?: number | null;
          agentCommunicationPort?: number | null;
          agentsUseSecureCommunication?: boolean | null;
          sslCNValidationPattern?: string | null;
          restServicePort?: number | null;
        };
        system: {
          __typename?: 'SystemSettings';
          prometheusPort?: number | null;
          prometheusEnabled?: boolean | null;
          allowSystemStandby?: boolean | null;
          telemetryEnabled?: boolean | null;
          ignoreFirewall?: boolean | null;
          allowCustomDistributionProfiles?: boolean | null;
        };
        agent: {
          __typename?: 'AgentSettings';
          minPhysicalMemory?: number | null;
          minVirtualMemory?: number | null;
          minIdleLevel?: number | null;
          ignoreProcesses?: string | null;
          allowEnableDisableAsHelper?: boolean | null;
          runCacheCleanup?: boolean | null;
          cacheCleanupInterval?: number | null;
          reportInterval?: number | null;
          maxWorkers?: number | null;
          minDiskFree?: number | null;
          showOfflineFloatingAgents?: boolean | null;
          offlineFloatingAgentsPeriod?: number | null;
        };
        license: {
          __typename?: 'LicenseSettings';
          automaticBuildCacheLicense?: boolean | null;
          floatingReleaseTime?: number | null;
          helperCoresAssignmentPercentage?: number | null;
          licenseServerPort?: number | null;
          defaultInitiatorType?: License_RegistrationType | null;
          defaultCIInitiatorType?: License_RegistrationType | null;
          defaultHelperType?: License_RegistrationType | null;
        };
      } | null;
    } | null;
  } | null;
};

export type BuildPerformanceQueryVariables = Exact<{
  filter?: InputMaybe<Builds_BuildDetailsWhereInput>;
}>;

export type BuildPerformanceQuery = {
  __typename?: 'Query';
  buildDetails?: {
    __typename?: 'Builds_BuildDetails';
    buildPerformance?: {
      __typename?: 'Build_Performance';
      totalTasks?: number | null;
      localTasks?: number | null;
      localTasksPercentage?: number | null;
      remoteTasks?: number | null;
      remoteTasksPercentage?: number | null;
      distributableTasks?: number | null;
      nonDistributableTasks?: number | null;
      isBuildCache?: boolean | null;
      cacheableTasks?: number | null;
      cacheableTasksPercentage?: number | null;
      uncacheableTasks?: number | null;
      uncacheableTasksPercentage?: number | null;
      cacheTaskHits?: number | null;
      cacheTaskHitsPercentage?: number | null;
      cacheTaskMiss?: number | null;
      cacheTaskMissPercentage?: number | null;
      avgHelperMachines?: number | null;
      maxHelperMachines?: number | null;
      avgHelperCores?: number | null;
      maxHelperCores?: number | null;
      readyOverActiveRatio?: number | null;
      totalCpuTime?: any | null;
      distributedCpuTime?: any | null;
      distributedCpuTimePercentage?: number | null;
      tasksDistribution?: {
        __typename?: 'Build_TasksDistribution';
        remoteTasks?: { __typename?: 'Build_TasksStatusCount'; success?: number | null; warning?: number | null; failed?: number | null } | null;
        localTasks?: { __typename?: 'Build_TasksStatusCount'; success?: number | null; warning?: number | null; failed?: number | null } | null;
      } | null;
      longestTasks?: Array<{
        __typename?: 'Build_LongestTask';
        id?: number | null;
        name?: string | null;
        machineName?: string | null;
        duration?: any | null;
        durationPercentage?: number | null;
      } | null> | null;
    } | null;
  } | null;
};

export type BuildSummaryQueryVariables = Exact<{
  filter?: InputMaybe<Builds_BuildDetailsWhereInput>;
}>;

export type BuildSummaryQuery = {
  __typename?: 'Query';
  buildDetails?: {
    __typename?: 'Builds_BuildDetails';
    buildSummary?: {
      __typename?: 'Build_Summary';
      buildTarget?: string | null;
      workingDir?: string | null;
      ibVersion?: string | null;
      totalTasks?: number | null;
      buildGroup?: string | null;
      initiatorDescription?: string | null;
      initiatorLogLevel?: number | null;
      startTime?: any | null;
      endTime?: any | null;
      duration?: any | null;
      failReason?: Builds_BuildFailReason | null;
      errorsNumber?: number | null;
      warningsNumber?: number | null;
      sysErrorsNumber?: number | null;
      sysWarningsNumber?: number | null;
      isBuildCache?: boolean | null;
      isCloudHelpers?: boolean | null;
      isPredictiveExecution?: boolean | null;
    } | null;
  } | null;
};

export type WorkloadsPageBuildsQueryVariables = Exact<{
  coordinatorId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Builds_BuildsWhereInput>;
}>;

export type WorkloadsPageBuildsQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    licenseMetadata?: { __typename?: 'License_LicenseMetadata'; hasBuildCache?: boolean | null } | null;
    builds?: {
      __typename?: 'Builds_Result';
      totalCount?: number | null;
      totalFilteredCount?: number | null;
      builds?: Array<{
        __typename?: 'Builds_Build';
        buildId?: string | null;
        title?: string | null;
        commandLine?: string | null;
        initiatorName?: string | null;
        initiatorType?: string | null;
        buildGroup?: string | null;
        buildResult?: Builds_BuildResult | null;
        buildType?: Builds_BuildType | null;
        startTime?: any | null;
        endTime?: any | null;
        duration?: any | null;
        failReason?: Builds_BuildFailReason | null;
        totalTasks?: number | null;
        localTasks?: number | null;
        remoteTasks?: number | null;
        cloudTasks?: number | null;
        cacheTaskHits?: number | null;
        cacheTaskMiss?: number | null;
        uncacheableTasks?: number | null;
        maxBusyHelpersCores?: number | null;
        avgBusyHelpersCores?: number | null;
        maxNeededHelpersCores?: number | null;
        distributableTasks?: number | null;
        failedTasks?: number | null;
        readyOverActiveRatio?: number | null;
        loggedOnUsers?: string | null;
        loggingLevel?: number | null;
        agentDescription?: string | null;
        hasExtendedData?: boolean | null;
      } | null> | null;
    } | null;
  } | null;
};

export type WorkloadsPageSummaryQueryVariables = Exact<{
  coordinatorId?: InputMaybe<Scalars['String']>;
  filterSummary?: InputMaybe<Builds_SummaryWhereInput>;
}>;

export type WorkloadsPageSummaryQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    buildsSummary?: {
      __typename?: 'Builds_Summary';
      totalBuilds?: number | null;
      successfulBuilds?: number | null;
      uniqueInitiators?: number | null;
      percentile50?: number | null;
      percentile90?: number | null;
    } | null;
  } | null;
};

export type WorkloadsPageMetadataQueryVariables = Exact<{
  coordinatorId?: InputMaybe<Scalars['String']>;
  filterMetadata?: InputMaybe<Builds_BuildsMetadataWhereInput>;
}>;

export type WorkloadsPageMetadataQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    buildsMetadata?: {
      __typename?: 'Builds_Metadata';
      buildGroups?: Array<string | null> | null;
      maxDuration?: number | null;
      oldestBuildStartTime?: any | null;
      hasBuildCache?: boolean | null;
      initiatorTypes?: Array<Builds_InitiatorType | null> | null;
    } | null;
  } | null;
};

export type WorkloadPageQueryVariables = Exact<{
  coordinatorId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Builds_BuildsWhereInput>;
}>;

export type WorkloadPageQuery = {
  __typename?: 'Query';
  ibManagerEntities?: {
    __typename?: 'IBManagerEntity';
    builds?: {
      __typename?: 'Builds_Result';
      totalCount?: number | null;
      totalFilteredCount?: number | null;
      builds?: Array<{
        __typename?: 'Builds_Build';
        buildId?: string | null;
        title?: string | null;
        commandLine?: string | null;
        initiatorName?: string | null;
        initiatorType?: string | null;
        buildGroup?: string | null;
        buildResult?: Builds_BuildResult | null;
        buildType?: Builds_BuildType | null;
        startTime?: any | null;
        endTime?: any | null;
        duration?: any | null;
        failReason?: Builds_BuildFailReason | null;
        totalTasks?: number | null;
        localTasks?: number | null;
        remoteTasks?: number | null;
        cloudTasks?: number | null;
        cacheTaskHits?: number | null;
        cacheTaskMiss?: number | null;
        uncacheableTasks?: number | null;
        maxBusyHelpersCores?: number | null;
        avgBusyHelpersCores?: number | null;
        maxNeededHelpersCores?: number | null;
        distributableTasks?: number | null;
        failedTasks?: number | null;
        readyOverActiveRatio?: number | null;
        loggedOnUsers?: string | null;
        loggingLevel?: number | null;
        agentDescription?: string | null;
        hasExtendedData?: boolean | null;
      } | null> | null;
    } | null;
  } | null;
};

export const CommonDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'commonData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'featureFlags' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'common' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cloud' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cloudStatus' } }] },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'windows' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'system' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'telemetryEnabled' } }] },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notificationsCount' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settingsMetadata' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isCloudActivated' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'license' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'windows' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'features' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'productFeatures' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastUpdateTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lockNotificationTimeout' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isFreeDev' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isFreeTrial' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linux' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licenseName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maintenanceExpirationDate' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'licenseDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'packageType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'availablePackages' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalPackages' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'packageBuildServer' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'packageNumCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'coresInUse' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expirationInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'daysLeft' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommonDataQuery, CommonDataQueryVariables>;
export const AgentsLicenseConfigurationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AgentsLicenseConfiguration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'windows' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'license' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'helperCoresAssignmentPercentage' } }] },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'license' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'windows' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'summary' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFixedCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFixedCIInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingCIInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFixedInitiators' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgentsLicenseConfigurationQuery, AgentsLicenseConfigurationQueryVariables>;
export const AgentsFiltersMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'agentsFiltersMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildGroups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cloudEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agentCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasRunningBuild' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licenseMetadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasBuildCache' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasCiInitiator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasFixedFloating' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasInitiator' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agentsMetadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'agentCores' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxHelperCacheSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'initiatorsCount' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settingsMetadata' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isCloudActivated' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgentsFiltersMetadataQuery, AgentsFiltersMetadataQueryVariables>;
export const AppBackupStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'appBackupStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'common' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'backup' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isOnline' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isSameVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorHost' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorNames' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorHosts' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AppBackupStatusQuery, AppBackupStatusQueryVariables>;
export const MessageNotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'messageNotifications' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Notification_WhereInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notifications' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'where' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageNotificationsQuery, MessageNotificationsQueryVariables>;
export const Agents_Action_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'agents_action_async' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Agent_ActionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agents_action_async' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Agents_Action_AsyncMutation, Agents_Action_AsyncMutationVariables>;
export const Agents_BuildCache_Update_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'agents_buildCache_update_async' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Agent_BuildCacheSettingsInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agents_buildCache_update_async' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Agents_BuildCache_Update_AsyncMutation, Agents_BuildCache_Update_AsyncMutationVariables>;
export const Authentication_LoginDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'authentication_login' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Authentication_LoginUserInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authentication_login' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'user' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'user' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'refreshToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userStatus' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Authentication_LoginMutation, Authentication_LoginMutationVariables>;
export const Authentication_Login_AzureadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'authentication_login_azuread' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Authentication_AzureADInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authentication_login_azuread' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'refreshToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userStatus' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Authentication_Login_AzureadMutation, Authentication_Login_AzureadMutationVariables>;
export const Authentication_LogoutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'authentication_logout' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'authentication_logout' } }] },
    },
  ],
} as unknown as DocumentNode<Authentication_LogoutMutation, Authentication_LogoutMutationVariables>;
export const Authentication_RefreshDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'authentication_refresh' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authentication_refresh' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'refreshToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userStatus' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Authentication_RefreshMutation, Authentication_RefreshMutationVariables>;
export const Authentication_Save_Azuread_CodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'authentication_save_azuread_code' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Authentication_AzureADInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authentication_save_azuread_code' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Authentication_Save_Azuread_CodeMutation, Authentication_Save_Azuread_CodeMutationVariables>;
export const BuildGroup_Add_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'buildGroup_add_async' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildGroup_AddInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildGroup_add_async' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildGroup_Add_AsyncMutation, BuildGroup_Add_AsyncMutationVariables>;
export const BuildGroup_Delete_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'buildGroup_delete_async' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildGroup_DeleteInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildGroup_delete_async' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildGroup_Delete_AsyncMutation, BuildGroup_Delete_AsyncMutationVariables>;
export const BuildGroup_Edit_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'buildGroup_edit_async' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildGroup_EditInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildGroup_edit_async' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildGroup_Edit_AsyncMutation, BuildGroup_Edit_AsyncMutationVariables>;
export const Cloud_Action_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'cloud_action_async' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Cloud_ActionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cloud_action_async' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Cloud_Action_AsyncMutation, Cloud_Action_AsyncMutationVariables>;
export const Cloud_Action_Wakeup_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'cloud_action_wakeup_async' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Cloud_Wakeup_ActionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cloud_action_wakeup_async' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Cloud_Action_Wakeup_AsyncMutation, Cloud_Action_Wakeup_AsyncMutationVariables>;
export const Cloud_Action_Wakeup_Machine_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'cloud_action_wakeup_machine_async' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Cloud_Wakeup_Machine_ActionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cloud_action_wakeup_machine_async' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Cloud_Action_Wakeup_Machine_AsyncMutation, Cloud_Action_Wakeup_Machine_AsyncMutationVariables>;
export const Cloud_Set_Cloud_SecretDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'cloud_set_cloud_secret' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'secret' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cloud_set_cloud_secret' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'secret' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'secret' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Cloud_Set_Cloud_SecretMutation, Cloud_Set_Cloud_SecretMutationVariables>;
export const Cluster_Add_NodesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'cluster_add_nodes' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Cluster_Nodes_AddInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cluster_add_nodes' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'agentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Cluster_Add_NodesMutation, Cluster_Add_NodesMutationVariables>;
export const Cluster_CreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'cluster_create' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cluster_create' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'agentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'port' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Cluster_CreateMutation, Cluster_CreateMutationVariables>;
export const Cluster_DeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'cluster_delete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cluster_delete' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Cluster_DeleteMutation, Cluster_DeleteMutationVariables>;
export const Cluster_EditDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'cluster_edit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cluster_edit' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Cluster_EditMutation, Cluster_EditMutationVariables>;
export const Cluster_Remove_NodesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'cluster_remove_nodes' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Cluster_Nodes_RemoveInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cluster_remove_nodes' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Cluster_Remove_NodesMutation, Cluster_Remove_NodesMutationVariables>;
export const Key_CreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'key_create' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Key_CreateInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'key_create' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'apiKey' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastUsed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdByUserId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Key_CreateMutation, Key_CreateMutationVariables>;
export const Key_DeactivateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'key_deactivate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'apiKey' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'key_deactivate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'apiKey' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'apiKey' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'apiKey' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastUsed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdByUserId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Key_DeactivateMutation, Key_DeactivateMutationVariables>;
export const Key_Update_DescriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'key_update_description' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'apiKey' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'key_update_description' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'apiKey' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'apiKey' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'description' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Key_Update_DescriptionMutation, Key_Update_DescriptionMutationVariables>;
export const Key_Update_RoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'key_update_role' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'apiKey' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'role' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Key_Role' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'key_update_role' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'apiKey' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'apiKey' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'role' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'role' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Key_Update_RoleMutation, Key_Update_RoleMutationVariables>;
export const License_Action_Activate_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'license_action_activate_async' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'licenseKey' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'license_action_activate_async' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'licenseKey' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'licenseKey' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<License_Action_Activate_AsyncMutation, License_Action_Activate_AsyncMutationVariables>;
export const License_Action_Deactivate_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'license_action_deactivate_async' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'licenseKey' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'license_action_deactivate_async' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'licenseKey' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'licenseKey' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<License_Action_Deactivate_AsyncMutation, License_Action_Deactivate_AsyncMutationVariables>;
export const License_Action_Generate_Key_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'license_action_generate_key_async' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'license_action_generate_key_async' } }] },
    },
  ],
} as unknown as DocumentNode<License_Action_Generate_Key_AsyncMutation, License_Action_Generate_Key_AsyncMutationVariables>;
export const License_Action_Refresh_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'license_action_refresh_async' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'license_action_refresh_async' } }] },
    },
  ],
} as unknown as DocumentNode<License_Action_Refresh_AsyncMutation, License_Action_Refresh_AsyncMutationVariables>;
export const License_RegisterAgents_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'license_registerAgents_async' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'License_RegisterAgentRequest' } } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'license_registerAgents_async' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<License_RegisterAgents_AsyncMutation, License_RegisterAgents_AsyncMutationVariables>;
export const License_RegisterBuildCache_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'license_registerBuildCache_async' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'License_RegisterBuildCacheRequest' } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'license_registerBuildCache_async' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<License_RegisterBuildCache_AsyncMutation, License_RegisterBuildCache_AsyncMutationVariables>;
export const PersistentData_DeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'persistentData_delete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PersistentData_WhereInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'persistentData_delete' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'where' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PersistentData_DeleteMutation, PersistentData_DeleteMutationVariables>;
export const PersistentData_SetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'persistentData_set' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PersistentData_SetInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'persistentData_set' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PersistentData_SetMutation, PersistentData_SetMutationVariables>;
export const Settings_ChangeCoordinatorPort_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'settings_changeCoordinatorPort_async' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'port' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings_changeCoordinatorPort_async' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'port' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'port' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Settings_ChangeCoordinatorPort_AsyncMutation, Settings_ChangeCoordinatorPort_AsyncMutationVariables>;
export const Settings_ChangeManagerPortDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'settings_changeManagerPort' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'port' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings_changeManagerPort' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'port' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'port' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'port' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Settings_ChangeManagerPortMutation, Settings_ChangeManagerPortMutationVariables>;
export const Settings_CheckPort_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'settings_checkPort_async' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Settings_CheckPortInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings_checkPort_async' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Settings_CheckPort_AsyncMutation, Settings_CheckPort_AsyncMutationVariables>;
export const Settings_ExternalAuth_Azure_UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'settings_externalAuth_azure_update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AzureADAuthenticationInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings_externalAuth_azure_update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Settings_ExternalAuth_Azure_UpdateMutation, Settings_ExternalAuth_Azure_UpdateMutationVariables>;
export const Settings_ExternalAuth_DeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'settings_externalAuth_delete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalAuthenticationDeleteInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings_externalAuth_delete' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Settings_ExternalAuth_DeleteMutation, Settings_ExternalAuth_DeleteMutationVariables>;
export const Settings_ExternalAuth_Ldap_UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'settings_externalAuth_ldap_update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'LDAPAuthenticationInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings_externalAuth_ldap_update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Settings_ExternalAuth_Ldap_UpdateMutation, Settings_ExternalAuth_Ldap_UpdateMutationVariables>;
export const Settings_ExternalAuth_SetStateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'settings_externalAuth_setState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalAuthenticationEnableInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings_externalAuth_setState' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Settings_ExternalAuth_SetStateMutation, Settings_ExternalAuth_SetStateMutationVariables>;
export const Settings_ExternalAuth_UpdateGroupRolesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'settings_externalAuth_updateGroupRoles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalAuthenticationUpdateGroupRolesInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings_externalAuth_updateGroupRoles' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Settings_ExternalAuth_UpdateGroupRolesMutation, Settings_ExternalAuth_UpdateGroupRolesMutationVariables>;
export const Settings_Update_AsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'settings_update_async' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'configurations' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Settings_UpdateUserInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings_update_async' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'configurations' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'configurations' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Settings_Update_AsyncMutation, Settings_Update_AsyncMutationVariables>;
export const User_CreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'user_create' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'User_CreateInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_create' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'local' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastLogin' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<User_CreateMutation, User_CreateMutationVariables>;
export const User_UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'user_update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'User_UpdateInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_update' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'local' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastLogin' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<User_UpdateMutation, User_UpdateMutationVariables>;
export const User_UpdatePasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'user_updatePassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'User_PasswordUpdateInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_updatePassword' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<User_UpdatePasswordMutation, User_UpdatePasswordMutationVariables>;
export const User_UpdatePersonalInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'user_updatePersonalInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'User_AdditionalInfoInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_updatePersonalInfo' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<User_UpdatePersonalInfoMutation, User_UpdatePersonalInfoMutationVariables>;
export const AgentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'agents' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Agent_WhereInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agents' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalFilteredCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'port' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'securedPort' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'routingIP' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hostComment' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agentVersion' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'versionText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'majorVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'minorVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maintenanceVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buildVersion' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'networkInfo' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildGroup' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logLevel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'msvcVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'netFrameworkVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'networkDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'loggedUsers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'osVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'remoteTaskPriority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'upTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastConnected' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastOnlineChange' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'coresUsed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'runningBuildsTitles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workingFor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assignPriority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildPriority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowEnableDisable' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'performance' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'availCPU' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'usedCPU' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'availDisk' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'availMemory' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'availVirt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cpuInfo' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cpuLogical' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cpuPhysical' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cpuSpeed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheSize' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheUsed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalDisk' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalMemory' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalVirt' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateStatus' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'downloadComplete' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'downloadInProgress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'downloadedBytes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'installStarted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'installStatus' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quickRollback' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updateID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updateSize' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updateToCurrentVersion' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'license' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'buildCacheAllowed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ciInitiatorType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'initiatorType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'helperType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'helperCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'initiatorCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'registeredCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'initiatorQueued' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'registeredInitiator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'buildCacheSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheSizeGB' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheFolder' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'databaseFolder' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'useLocalCache' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'remoteCacheServer' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cacheSettingsDisplay' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'cacheType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cacheRemoteValue' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'localBCServicePort' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'useBuildCacheCluster' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'assignedToInitiator' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isInProgress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isLocal' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSCL' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isWindowsAgent' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isInitiatorPending' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isHelperPending' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isHelperDisabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isBuildAvoidance' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isIncompatibleVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isDuplicateLicense' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isLastDuplicateLicense' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCloud' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isHelper' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isOnPremHelper' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isInitiator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isOffline' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isOnline' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isLowerThanTenVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastConnectedDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isOnlyLocal' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isOnlyInitiator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isOnlyHelper' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isHelperAndInitiator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isInProcess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isUnlicensed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCIInitiator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCIInitiatorPending' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isValidForVersionUpdate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'agentType' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cloud' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'machineStatus' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vmType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'spot' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'numberOfCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hdType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'volumeSize' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheSize' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPool' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'cluster' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgentsQuery, AgentsQueryVariables>;
export const AgentsActiveInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'agentsActiveInfo' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agentsActiveInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeHelpers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'activeCoresLocal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activeCoresCloud' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activeCoresRemote' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activeCloudAgents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activeAgents' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onlineHelpers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'onlineCloudAgents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onlineAgents' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activeBuilds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgentsActiveInfoQuery, AgentsActiveInfoQueryVariables>;
export const AgentsChangesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'agentsChanges' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Agent_ChangesWhereInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agentsChanges' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'port' } },
                { kind: 'Field', name: { kind: 'Name', value: 'securedPort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'routingIP' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hostComment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agentVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'versionText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'majorVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minorVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maintenanceVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildVersion' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'networkInfo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'buildGroup' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'msvcVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netFrameworkVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'networkDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'loggedUsers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'osVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remoteTaskPriority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'upTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastOnlineChange' } },
                { kind: 'Field', name: { kind: 'Name', value: 'coresUsed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'runningBuildsTitles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workingFor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignPriority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'buildPriority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowEnableDisable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'performance' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'availCPU' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'usedCPU' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'availDisk' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'availMemory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'availVirt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cpuInfo' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cpuLogical' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cpuPhysical' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cpuSpeed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheUsed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalDisk' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalMemory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalVirt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateStatus' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'downloadComplete' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'downloadInProgress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'downloadedBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'installStarted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'installStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quickRollback' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updateID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updateSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updateToCurrentVersion' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'license' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'buildCacheAllowed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ciInitiatorType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'initiatorType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'helperType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'helperCores' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'initiatorCores' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'registeredCores' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'initiatorQueued' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'registeredInitiator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildCacheSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheSizeGB' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheFolder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'databaseFolder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'useLocalCache' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'remoteCacheServer' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cacheSettingsDisplay' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheRemoteValue' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'localBCServicePort' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'useBuildCacheCluster' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedToInitiator' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isInProgress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isLocal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSCL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isWindowsAgent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isInitiatorPending' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isHelperPending' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isHelperDisabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isBuildAvoidance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isIncompatibleVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDuplicateLicense' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isLastDuplicateLicense' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCloud' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isHelper' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isOnPremHelper' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isInitiator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isOffline' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isOnline' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isLowerThanTenVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastConnectedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isOnlyLocal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isOnlyInitiator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isOnlyHelper' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isHelperAndInitiator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isInProcess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isUnlicensed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCIInitiator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCIInitiatorPending' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isValidForVersionUpdate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agentType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cloud' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'machineStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vmType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'spot' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numberOfCores' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hdType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'volumeSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPool' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cluster' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgentsChangesQuery, AgentsChangesQueryVariables>;
export const Agents_Action_AsyncResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'agents_action_asyncResult' },
      variableDefinitions: [{ kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agents_action_asyncResult' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'agentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Agents_Action_AsyncResultQuery, Agents_Action_AsyncResultQueryVariables>;
export const Agents_BuildCache_Update_AsyncResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'agents_buildCache_update_asyncResult' },
      variableDefinitions: [{ kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agents_buildCache_update_asyncResult' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'agentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Agents_BuildCache_Update_AsyncResultQuery, Agents_BuildCache_Update_AsyncResultQueryVariables>;
export const Authentication_Get_Azuread_RouteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'authentication_get_azuread_route' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Authentication_AzureADRouteInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authentication_get_azuread_route' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'redirectUri' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Authentication_Get_Azuread_RouteQuery, Authentication_Get_Azuread_RouteQueryVariables>;
export const Authentication_Get_Login_OptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'authentication_get_login_options' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authentication_get_login_options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ldap' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'connected' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'azureAd' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'connected' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'osType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Authentication_Get_Login_OptionsQuery, Authentication_Get_Login_OptionsQueryVariables>;
export const Authentication_Get_Organization_GroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'authentication_get_organization_groups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Authentication_ExternalTypeInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authentication_get_organization_groups' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'groups' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Authentication_Get_Organization_GroupsQuery, Authentication_Get_Organization_GroupsQueryVariables>;
export const Authentication_Has_Azuread_CodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'authentication_has_azuread_code' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'authentication_has_azuread_code' } }] },
    },
  ],
} as unknown as DocumentNode<Authentication_Has_Azuread_CodeQuery, Authentication_Has_Azuread_CodeQueryVariables>;
export const BuildDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'buildDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Builds_BuildDetailsWhereInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildDetails' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'buildTarget' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workingDir' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ibVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildGroup' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'initiatorDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'initiatorLogLevel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorsNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'warningsNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sysErrorsNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sysWarningsNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isBuildCache' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCloudHelpers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPredictiveExecution' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildPerformance' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'localTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'localTasksPercentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'remoteTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'remoteTasksPercentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'distributableTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nonDistributableTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isBuildCache' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheableTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheableTasksPercentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uncacheableTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uncacheableTasksPercentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheTaskHits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheTaskHitsPercentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheTaskMiss' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheTaskMissPercentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgHelperMachines' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxHelperMachines' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgHelperCores' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxHelperCores' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readyOverActiveRatio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCpuTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'distributedCpuTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'distributedCpuTimePercentage' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tasksDistribution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'remoteTasks' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'warning' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'localTasks' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'warning' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longestTasks' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'machineName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'durationPercentage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildDetailsQuery, BuildDetailsQueryVariables>;
export const BuildGroup_Add_AsyncResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'buildGroup_add_asyncResult' },
      variableDefinitions: [{ kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildGroup_add_asyncResult' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'buildGroupId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'applicationErrorCode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildGroup_Add_AsyncResultQuery, BuildGroup_Add_AsyncResultQueryVariables>;
export const BuildGroup_Delete_AsyncResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'buildGroup_delete_asyncResult' },
      variableDefinitions: [{ kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildGroup_delete_asyncResult' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'buildGroupId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'applicationErrorCode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildGroup_Delete_AsyncResultQuery, BuildGroup_Delete_AsyncResultQueryVariables>;
export const BuildGroup_Edit_AsyncResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'buildGroup_edit_asyncResult' },
      variableDefinitions: [{ kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildGroup_edit_asyncResult' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'buildGroupId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'applicationErrorCode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildGroup_Edit_AsyncResultQuery, BuildGroup_Edit_AsyncResultQueryVariables>;
export const BuildGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'buildGroups' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildGroups_WhereInput' } } },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildGroups_Input' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildGroups' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cloudEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasRunningBuild' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildGroupsQuery, BuildGroupsQueryVariables>;
export const BuildsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'builds' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Builds_BuildsWhereInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'builds' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalFilteredCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'builds' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'buildId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commandLine' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'initiatorName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'initiatorType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildGroup' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildResult' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'localTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'remoteTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cloudTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'distributableTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readyOverActiveRatio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheTaskHits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheTaskMiss' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uncacheableTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxBusyHelpersCores' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgBusyHelpersCores' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxNeededHelpersCores' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agentDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'loggedOnUsers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'loggingLevel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasExtendedData' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildsQuery, BuildsQueryVariables>;
export const BuildsExportCsvDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'buildsExportCSV' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Builds_BuildsWhereInput' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fieldsMapping' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ExportCSV_FieldsMapping' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildsExportCSV' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'fieldsMapping' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fieldsMapping' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildsExportCsvQuery, BuildsExportCsvQueryVariables>;
export const BuildsMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'buildsMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Builds_BuildsMetadataWhereInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildsMetadata' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'buildGroups' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'oldestBuildStartTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasBuildCache' } },
                { kind: 'Field', name: { kind: 'Name', value: 'initiatorTypes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildsMetadataQuery, BuildsMetadataQueryVariables>;
export const BuildsSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'buildsSummary' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Builds_SummaryWhereInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildsSummary' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalBuilds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'successfulBuilds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uniqueInitiators' } },
                { kind: 'Field', name: { kind: 'Name', value: 'percentile50' } },
                { kind: 'Field', name: { kind: 'Name', value: 'percentile90' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildsSummaryQuery, BuildsSummaryQueryVariables>;
export const Cloud_Action_AsyncResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cloud_action_asyncResult' },
      variableDefinitions: [{ kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cloud_action_asyncResult' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Cloud_Action_AsyncResultQuery, Cloud_Action_AsyncResultQueryVariables>;
export const Cloud_Action_Wakeup_AsyncResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cloud_action_wakeup_asyncResult' },
      variableDefinitions: [{ kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cloud_action_wakeup_asyncResult' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Cloud_Action_Wakeup_AsyncResultQuery, Cloud_Action_Wakeup_AsyncResultQueryVariables>;
export const Cloud_DataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cloud_data' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cloud_data' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'initializing' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ready' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'delivered' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'wakeingup' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deallocated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'poolSum' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Cloud_DataQuery, Cloud_DataQueryVariables>;
export const Cloud_Data_PoolDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cloud_data_pool' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cloud_data_pool' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'initializing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ready' } },
                { kind: 'Field', name: { kind: 'Name', value: 'delivered' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wakeingup' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deallocated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'poolSum' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Cloud_Data_PoolQuery, Cloud_Data_PoolQueryVariables>;
export const Cloud_Data_Pool_DeallocatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cloud_data_pool_deallocated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cloud_data_pool_deallocated' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'deallocated' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Cloud_Data_Pool_DeallocatedQuery, Cloud_Data_Pool_DeallocatedQueryVariables>;
export const Cloud_UrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cloud_url' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cloud_url' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cloudUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                { kind: 'Field', name: { kind: 'Name', value: 'redirectPath' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Cloud_UrlQuery, Cloud_UrlQueryVariables>;
export const ClustersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'clusters' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Cluster_Nodes_WhereInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clusters' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'agentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'port' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClustersQuery, ClustersQueryVariables>;
export const CoordinatorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'coordinators' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'coordinators' }, selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } }] } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoordinatorsQuery, CoordinatorsQueryVariables>;
export const DashboardMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'dashboardMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Dashboard_Metadata_Filter' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dashboardMetadata' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'buildGroups' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasWorkloads' } },
                { kind: 'Field', name: { kind: 'Name', value: 'oldestWorkloadDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workloadTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'initiatorTypes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DashboardMetadataQuery, DashboardMetadataQueryVariables>;
export const IbManagerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ibManagerEntities' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Agent_WhereInput' } } },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Notification_WhereInput' } } },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter1' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Builds_BuildsWhereInput' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter2' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Builds_SummaryWhereInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter3' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Builds_BuildsMetadataWhereInput' } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agents' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalFilteredCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ip' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'port' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'securedPort' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'routingIP' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hostComment' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agentVersion' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'versionText' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'majorVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'minorVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maintenanceVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildVersion' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'networkInfo' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'macAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buildGroup' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'logLevel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'msvcVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'netFrameworkVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'networkDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'loggedUsers' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'osVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'remoteTaskPriority' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'upTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastConnected' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastOnlineChange' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'coresUsed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'runningBuildsTitles' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'workingFor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'assignPriority' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buildPriority' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowEnableDisable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'performance' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'availCPU' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'usedCPU' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'availDisk' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'availMemory' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'availVirt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cpuInfo' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cpuLogical' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cpuPhysical' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cpuSpeed' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cacheSize' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cacheUsed' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalDisk' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalMemory' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalVirt' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'updateStatus' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'downloadComplete' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'downloadInProgress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'downloadedBytes' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'installStarted' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'installStatus' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quickRollback' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updateID' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updateSize' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updateToCurrentVersion' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'license' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildCacheAllowed' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'ciInitiatorType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'initiatorType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'helperType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'helperCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'initiatorCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'registeredCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'initiatorQueued' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'registeredInitiator' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'buildCacheSettings' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'cacheSizeGB' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cacheFolder' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'databaseFolder' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'useLocalCache' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'remoteCacheServer' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cacheSettingsDisplay' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'cacheType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'cacheRemoteValue' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'localBCServicePort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'useBuildCacheCluster' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'assignedToInitiator' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'metadata' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isInProgress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isLocal' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isSCL' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isWindowsAgent' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isInitiatorPending' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isHelperPending' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isHelperDisabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isBuildAvoidance' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isIncompatibleVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isDuplicateLicense' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isLastDuplicateLicense' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCloud' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isHelper' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isOnPremHelper' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isInitiator' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isOffline' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isOnline' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isLowerThanTenVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastConnectedDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isOnlyLocal' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isOnlyInitiator' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isOnlyHelper' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isHelperAndInitiator' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isInProcess' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isUnlicensed' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCIInitiator' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCIInitiatorPending' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isValidForVersionUpdate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'agentType' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cloud' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'machineStatus' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'vmType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'spot' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'numberOfCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'hdType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'volumeSize' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cacheSize' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isPool' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'cluster' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agentsMetadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'agentCores' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxHelperCacheSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'initiatorsCount' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licenseMetadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasCiInitiator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasInitiator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasBuildCache' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasFixedFloating' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settingsMetadata' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isCloudActivated' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agentsActiveInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeHelpers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'activeCoresLocal' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'activeCoresCloud' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'activeCoresRemote' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'activeCloudAgents' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'activeAgents' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onlineHelpers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'onlineCloudAgents' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'onlineAgents' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'activeBuilds' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildGroups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cloudEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agentCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasRunningBuild' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'license' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expirationInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'daysLeft' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contractEndDate' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'windows' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tierName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastUpdateTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lockNotificationTimeout' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'features' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'addonFeatures' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'productFeatures' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'summary' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalBuildCacheCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFixedCIInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFixedCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFixedInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingCIInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalRegisteredFloatingCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unlimitedCacheCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unlimitedHelperCores' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'helperCores' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'floating' } }] },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalBuildCacheCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'remainingBuildCacheCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildCacheNextResetTime' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildCacheResetMinutes' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'isFreeTrial' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isFreeDev' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linux' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licenseName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maintenanceExpirationDate' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'licenseDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'packageType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'availablePackages' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalPackages' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'packageNumCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'packageBuildServer' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'coresInUse' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cloudLicense' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licenseId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licenseStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licenseType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activationDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'licenseDetails' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'quantity' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'coordSpecificConsumption' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalLicenseConsumption' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCacheConsumption' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'coordSpecificCacheConsumption' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasBuildCache' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextLicense' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licenseId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licenseStatus' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licenseType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'activationDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'licenseDetails' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'quantity' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'coordSpecificConsumption' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalLicenseConsumption' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalCacheConsumption' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'coordSpecificCacheConsumption' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasBuildCache' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cloudData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pool' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'initializing' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alive' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ready' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'delivered' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'wakeingup' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deallocated' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'poolSum' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notifications' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'where' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notificationTimestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notificationsCount' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'windows' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coordinator' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'agentCommunicationPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'agentsUseSecureCommunication' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'agentCommunicationSSLPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sslCNValidationPattern' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'restServicePort' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'minPhysicalMemory' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'minDiskFree' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'minVirtualMemory' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxWorkers' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'runCacheCleanup' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cacheCleanupInterval' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'ignoreProcesses' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'reportInterval' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'minIdleLevel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'allowEnableDisableAsHelper' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'showOfflineFloatingAgents' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'offlineFloatingAgentsPeriod' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'license' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'licenseServerPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'floatingReleaseTime' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'helperCoresAssignmentPercentage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'automaticBuildCacheLicense' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultCIInitiatorType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultInitiatorType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultHelperType' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'system' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'ignoreFirewall' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'allowSystemStandby' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'telemetryEnabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'prometheusPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'prometheusEnabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'allowCustomDistributionProfiles' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linux' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coordinator' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'agentControlPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sessionPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'utilityPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildMaxCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'agentMaxCpuLoad' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'agentMinFreeMemory' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'agentReloadTimeout' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'autoSubscribeNewAgents' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'network' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'ipv6' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'ssl' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'useCoordinatorAgentTunnel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'coordinatorPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'coordinatorSSLPort' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'system' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'telemetryEnabled' } }] },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'common' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cloud' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'cloudStatus' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cloudCoordinatorId' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ibManager' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'ibManagerPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rabbitMqPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'coordinatorHostname' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'backup' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorBuildNumbers' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorHosts' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorNames' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorPorts' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorTimeout' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorSyncFrequency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorBuildNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorHost' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isOnline' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isSameVersion' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'auth' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'authenticationType' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coordinatorInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'runningSince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'majorVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minorVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maintenanceVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'versionText' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'builds' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter1' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalFilteredCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'builds' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'buildId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'commandLine' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'initiatorName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'initiatorType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buildGroup' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buildResult' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'failReason' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buildType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'localTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'remoteTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cloudTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'distributableTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'readyOverActiveRatio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheTaskHits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheTaskMiss' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uncacheableTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxBusyHelpersCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'avgBusyHelpersCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxNeededHelpersCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'agentDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'loggedOnUsers' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'loggingLevel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasExtendedData' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildsSummary' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter2' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalBuilds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'successfulBuilds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqueInitiators' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'percentile50' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'percentile90' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildsMetadata' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter3' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'buildGroups' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxDuration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'oldestBuildStartTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasBuildCache' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'initiatorTypes' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'featureFlags' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'systemInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fqdn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hostname' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ip' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IbManagerEntitiesQuery, IbManagerEntitiesQueryVariables>;
export const KeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'key' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'apiKey' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'key' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'apiKey' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'apiKey' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUsed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdByUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KeyQuery, KeyQueryVariables>;
export const KeysDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'keys' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Key_WhereInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'keys' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUsed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdByUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KeysQuery, KeysQueryVariables>;
export const LicenseDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'license' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'license' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'daysLeft' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contractEndDate' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'windows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tierName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastUpdateTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lockNotificationTimeout' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'features' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addonFeatures' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'productFeatures' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'totalBuildCacheCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalFixedCIInitiators' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalFixedCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalFixedInitiators' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingCIInitiators' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingInitiators' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalRegisteredFloatingCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unlimitedCacheCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unlimitedHelperCores' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'initiator' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'all' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'cooldown' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'cooldownNextRelease' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'floating' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'cooldown' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'cooldownNextRelease' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fixed' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'cooldown' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'cooldownNextRelease' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ciInitiator' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'all' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'cooldown' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'cooldownNextRelease' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'floating' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'cooldown' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'cooldownNextRelease' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fixed' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'cooldown' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'cooldownNextRelease' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'helperCores' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'floating' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fixed' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'cooldown' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'cooldownNextRelease' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalBuildCacheCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'remainingBuildCacheCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buildCacheNextResetTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buildCacheResetMinutes' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isFreeTrial' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isFreeDev' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linux' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licenseName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maintenanceExpirationDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'licenseDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'packageType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'availablePackages' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPackages' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'packageNumCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'packageBuildServer' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'coresInUse' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LicenseQuery, LicenseQueryVariables>;
export const License_Action_AsyncResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'license_action_asyncResult' },
      variableDefinitions: [{ kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'license_action_asyncResult' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<License_Action_AsyncResultQuery, License_Action_AsyncResultQueryVariables>;
export const License_Action_Generate_AsyncResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'license_action_generate_asyncResult' },
      variableDefinitions: [{ kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'license_action_generate_asyncResult' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<License_Action_Generate_AsyncResultQuery, License_Action_Generate_AsyncResultQueryVariables>;
export const License_CloudDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'license_cloud' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'license_cloud' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseDetails' }, selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'quantity' } }] } },
                { kind: 'Field', name: { kind: 'Name', value: 'coordSpecificConsumption' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalLicenseConsumption' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCacheConsumption' } },
                { kind: 'Field', name: { kind: 'Name', value: 'coordSpecificCacheConsumption' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasBuildCache' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextLicense' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licenseId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licenseStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licenseType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activationDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'licenseDetails' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'quantity' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'coordSpecificConsumption' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalLicenseConsumption' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCacheConsumption' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'coordSpecificCacheConsumption' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasBuildCache' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<License_CloudQuery, License_CloudQueryVariables>;
export const License_LicenseKeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'license_licenseKey' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'license_licenseKey' } }] },
    },
  ],
} as unknown as DocumentNode<License_LicenseKeyQuery, License_LicenseKeyQueryVariables>;
export const License_RegisterAgents_AsyncResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'license_registerAgents_asyncResult' },
      variableDefinitions: [{ kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'license_registerAgents_asyncResult' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'agentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<License_RegisterAgents_AsyncResultQuery, License_RegisterAgents_AsyncResultQueryVariables>;
export const License_RegisterBuildCache_AsyncResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'license_registerBuildCache_asyncResult' },
      variableDefinitions: [{ kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'license_registerBuildCache_asyncResult' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'agentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<License_RegisterBuildCache_AsyncResultQuery, License_RegisterBuildCache_AsyncResultQueryVariables>;
export const NotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'notifications' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Notification_WhereInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notifications' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'where' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notificationTimestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotificationsQuery, NotificationsQueryVariables>;
export const PersistentDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'persistentData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PersistentData_WhereInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'persistentData' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'where' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PersistentDataQuery, PersistentDataQueryVariables>;
export const SettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'settings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'windows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coordinator' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'agentCommunicationPort' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'agentsUseSecureCommunication' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'agentCommunicationSSLPort' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sslCNValidationPattern' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'restServicePort' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agent' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minPhysicalMemory' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'minDiskFree' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'minVirtualMemory' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxWorkers' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'runCacheCleanup' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheCleanupInterval' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ignoreProcesses' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reportInterval' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'minIdleLevel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowEnableDisableAsHelper' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'showOfflineFloatingAgents' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'offlineFloatingAgentsPeriod' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'license' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'licenseServerPort' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'floatingReleaseTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'helperCoresAssignmentPercentage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'automaticBuildCacheLicense' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultCIInitiatorType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultInitiatorType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultHelperType' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'system' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'ignoreFirewall' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowSystemStandby' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'telemetryEnabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'prometheusPort' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'prometheusEnabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowCustomDistributionProfiles' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linux' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coordinator' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'agentControlPort' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sessionPort' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'utilityPort' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buildMaxCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'agentMaxCpuLoad' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'agentMinFreeMemory' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'agentReloadTimeout' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'autoSubscribeNewAgents' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'network' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'ipv6' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ssl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'useCoordinatorAgentTunnel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinatorPort' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinatorSSLPort' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'system' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'telemetryEnabled' } }] },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'common' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cloud' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'cloudStatus' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cloudCoordinatorId' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ibManager' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'ibManagerPort' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'rabbitMqPort' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinatorHostname' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'backup' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorBuildNumbers' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorHosts' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorNames' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorPorts' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorTimeout' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorSyncFrequency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorBuildNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorHost' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorPort' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isOnline' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSameVersion' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'auth' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'authenticationType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalAuths' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ldapAuth' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'authenticationType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bindDN' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'searchBase' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'usernameAttribute' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'certificateAuthority' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'groupSearchBase' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'azureADAuth' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'authenticationType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsQuery, SettingsQueryVariables>;
export const Settings_ChangeCoordinatorPort_AsyncResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'settings_changeCoordinatorPort_asyncResult' },
      variableDefinitions: [{ kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings_changeCoordinatorPort_asyncResult' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'port' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Settings_ChangeCoordinatorPort_AsyncResultQuery, Settings_ChangeCoordinatorPort_AsyncResultQueryVariables>;
export const Settings_CheckPort_AsyncResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'settings_checkPort_asyncResult' },
      variableDefinitions: [{ kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings_checkPort_asyncResult' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'port' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Settings_CheckPort_AsyncResultQuery, Settings_CheckPort_AsyncResultQueryVariables>;
export const Settings_ExternalAuthsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'settings_externalAuths' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings_externalAuths' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ldapAuth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'authenticationType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bindDN' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'searchBase' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'usernameAttribute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificateAuthority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'groupSearchBase' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'groupRoleMapping' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'azureADAuth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'authenticationType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'groupRoleMapping' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Settings_ExternalAuthsQuery, Settings_ExternalAuthsQueryVariables>;
export const Settings_Telemetry_EnabledDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'settings_telemetry_enabled' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'settings_telemetry_enabled' } }] },
    },
  ],
} as unknown as DocumentNode<Settings_Telemetry_EnabledQuery, Settings_Telemetry_EnabledQueryVariables>;
export const Settings_Update_AsyncResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'settings_update_asyncResult' },
      variableDefinitions: [{ kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings_update_asyncResult' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Settings_Update_AsyncResultQuery, Settings_Update_AsyncResultQueryVariables>;
export const SystemInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'systemInfo' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'systemInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fqdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hostname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ip' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SystemInfoQuery, SystemInfoQueryVariables>;
export const SystemUtilizationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'systemUtilization' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Dashboard_Filter' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'systemUtilization' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'overview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalWorkloads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalWorkloadsWithBuildCache' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalWorkloadsWithoutBuildCache' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgWorkloadsDuration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgWorkloadsWithBuildCacheDuration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgWorkloadsWithoutBuildCacheDuration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalWorkloadsDuration' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'helperNeededRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxCores' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'demand' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'availability' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cacheCoresUsage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheCores' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cacheHoursConsumption' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onPrem' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cloud' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timeSavedByCache' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCpuTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalSavedTime' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeInitiatorMachines' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'withInitiatorLicense' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'withoutInitiatorLicense' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeHelperMachines' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onPrem' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cloud' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SystemUtilizationQuery, SystemUtilizationQueryVariables>;
export const UserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'user' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'local' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastLogin' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserQuery, UserQueryVariables>;
export const UsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'users' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'User_WhereInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'local' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastLogin' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const WorkloadsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'workloads' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Dashboard_Filter' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workloads' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'overview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalWorkloads' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalWorkloadsWithBuildCache' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalWorkloadsWithoutBuildCache' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgWorkloadsDuration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgWorkloadsWithBuildCacheDuration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgWorkloadsWithoutBuildCacheDuration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalWorkloadsDuration' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalWorkloads' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'successful' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canceled' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workloadsDuration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxWorkloadDuration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgWorkloadDuration' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workloadsDurationPercentile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'p100' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'p75' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'p50' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'p25' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workloadsHoursDuration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Sunday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalWorkloads' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Monday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalWorkloads' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Tuesday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalWorkloads' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Wednesday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalWorkloads' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Thursday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalWorkloads' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Friday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalWorkloads' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'Saturday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalWorkloads' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkloadsQuery, WorkloadsQueryVariables>;
export const CoordinatorInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'coordinatorInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coordinatorInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'majorVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minorVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maintenanceVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'runningSince' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoordinatorInfoQuery, CoordinatorInfoQueryVariables>;
export const AgentsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'agentsPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agentsActiveInfo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'activeBuilds' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'license' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'windows' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'features' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'productFeatures' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'summary' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalBuildCacheCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFixedCIInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFixedCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFixedInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingCIInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalRegisteredFloatingCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unlimitedCacheCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unlimitedHelperCores' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'initiator' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'all' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'cooldown' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'cooldownNextRelease' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'floating' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'fixed' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'cooldown' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'cooldownNextRelease' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ciInitiator' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'all' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'cooldown' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'cooldownNextRelease' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'floating' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'fixed' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'cooldown' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'cooldownNextRelease' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'helperCores' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'floating' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'fixed' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'assigned' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalBuildCacheCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'remainingBuildCacheCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildCacheNextResetTime' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agentsActiveInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onlineHelpers' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'onlineAgents' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeHelpers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'activeCoresLocal' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'activeCloudAgents' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'activeAgents' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'activeCoresCloud' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'activeCoresRemote' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'common' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'backup' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isOnline' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isSameVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorHost' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorNames' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorHosts' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorHost' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'common' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cloud' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cloudStatus' } }] },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cloudLicense' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasBuildCache' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licenseId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licenseType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licenseStatus' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'licenseDetails' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'quantity' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalLicenseConsumption' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCacheConsumption' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licenseMetadata' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hasBuildCache' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgentsPageQuery, AgentsPageQueryVariables>;
export const SelectedAgentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'selectedAgents' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Agent_WhereInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agents' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hostComment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildGroup' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logLevel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assignPriority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildPriority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowEnableDisable' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'performance' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'cpuLogical' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheSize' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cpuPhysical' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'license' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'buildCacheAllowed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ciInitiatorType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'initiatorType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'helperType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'helperCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'registeredCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'buildCacheSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheSizeGB' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheFolder' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'databaseFolder' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'useLocalCache' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'remoteCacheServer' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cacheSettingsDisplay' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'cacheRemoteValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cacheType' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'useBuildCacheCluster' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isLocal' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isHelperDisabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isHelper' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isInitiator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isOnline' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isLowerThanTenVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCIInitiator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isValidForVersionUpdate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCloud' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isDuplicateLicense' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isIncompatibleVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isOffline' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSCL' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SelectedAgentsQuery, SelectedAgentsQueryVariables>;
export const AgentNamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'agentNames' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Agent_WhereInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agents' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgentNamesQuery, AgentNamesQueryVariables>;
export const Getting_StartedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getting_started' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildsSummary' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'timeframes' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'ObjectValue',
                                  fields: [
                                    { kind: 'ObjectField', name: { kind: 'Name', value: 'startTime' }, value: { kind: 'IntValue', value: '0' } },
                                    { kind: 'ObjectField', name: { kind: 'Name', value: 'endTime' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } } },
                                  ],
                                },
                              ],
                            },
                          },
                          { kind: 'ObjectField', name: { kind: 'Name', value: 'overlappingTimeframes' }, value: { kind: 'BooleanValue', value: false } },
                        ],
                      },
                    },
                  ],
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalBuilds' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'agents' }, selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }] } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'systemInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fqdn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ip' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'common' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ibManager' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'ibManagerPort' } }] },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'license' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expirationInfo' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'daysLeft' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Getting_StartedQuery, Getting_StartedQueryVariables>;
export const System_InfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'system_info' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'systemInfo' }, selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hostname' } }] } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<System_InfoQuery, System_InfoQueryVariables>;
export const LicensePageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'licensePage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coordinatorInfo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'buildVersion' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'license' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'windows' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'features' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'productFeatures' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'addonFeatures' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'summary' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFixedInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFixedCIInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingCIInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalBuildCacheCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFixedCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unlimitedCacheCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unlimitedHelperCores' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastUpdateTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lockNotificationTimeout' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tierName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linux' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'coordinatorId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licenseName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maintenanceExpirationDate' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'licenseDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'packageType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'availablePackages' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalPackages' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'packageBuildServer' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'packageNumCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'coresInUse' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expirationInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'daysLeft' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contractEndDate' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LicensePageQuery, LicensePageQueryVariables>;
export const LicenseAddonAndProductDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'licenseAddonAndProduct' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'license' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'windows' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'features' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'productFeatures' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'addonFeatures' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LicenseAddonAndProductQuery, LicenseAddonAndProductQueryVariables>;
export const LicenseDetailedViewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'licenseDetailedView' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'license' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'windows' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'summary' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFixedInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFixedCIInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingCIInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalBuildCacheCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFixedCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unlimitedHelperCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unlimitedCacheCores' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LicenseDetailedViewQuery, LicenseDetailedViewQueryVariables>;
export const SettingsPageLinuxDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'settingsPageLinux' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coordinatorInfo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'buildVersion' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'common' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'backup' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorTimeout' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorSyncFrequency' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cloud' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cloudStatus' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ibManager' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'ibManagerPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rabbitMqPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'coordinatorHostname' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'auth' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'authenticationType' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linux' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coordinator' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'agentControlPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sessionPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'utilityPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildMaxCores' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'agentMaxCpuLoad' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'agentMinFreeMemory' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'agentReloadTimeout' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'autoSubscribeNewAgents' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'system' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'telemetryEnabled' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'network' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'ipv6' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'ssl' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'useCoordinatorAgentTunnel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'coordinatorPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'coordinatorSSLPort' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsPageLinuxQuery, SettingsPageLinuxQueryVariables>;
export const SettingsPageWindowsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'settingsPageWindows' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coordinatorInfo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'buildVersion' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'license' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'windows' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'tierName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'summary' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingCIInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFloatingInitiators' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalBuildCacheCores' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'common' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cloud' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cloudStatus' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'auth' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'authenticationType' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'backup' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorPorts' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorHosts' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorNames' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'backupCoordinatorBuildNumbers' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorHost' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'otherCoordinatorPort' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ibManager' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'ibManagerPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rabbitMqPort' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'windows' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coordinator' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'agentCommunicationSSLPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'agentCommunicationPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'agentsUseSecureCommunication' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sslCNValidationPattern' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'restServicePort' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'system' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'prometheusPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'prometheusEnabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'allowSystemStandby' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'telemetryEnabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'ignoreFirewall' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'allowCustomDistributionProfiles' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'minPhysicalMemory' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'minVirtualMemory' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'minIdleLevel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'ignoreProcesses' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'allowEnableDisableAsHelper' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'runCacheCleanup' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cacheCleanupInterval' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'reportInterval' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxWorkers' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'minDiskFree' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'showOfflineFloatingAgents' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'offlineFloatingAgentsPeriod' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'license' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'automaticBuildCacheLicense' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'floatingReleaseTime' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'helperCoresAssignmentPercentage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'licenseServerPort' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultInitiatorType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultCIInitiatorType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultHelperType' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsPageWindowsQuery, SettingsPageWindowsQueryVariables>;
export const BuildPerformanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'buildPerformance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Builds_BuildDetailsWhereInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildDetails' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildPerformance' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'localTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'localTasksPercentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'remoteTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'remoteTasksPercentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'distributableTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nonDistributableTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isBuildCache' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheableTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheableTasksPercentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uncacheableTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uncacheableTasksPercentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheTaskHits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheTaskHitsPercentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheTaskMiss' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cacheTaskMissPercentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgHelperMachines' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxHelperMachines' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgHelperCores' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxHelperCores' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readyOverActiveRatio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCpuTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'distributedCpuTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'distributedCpuTimePercentage' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tasksDistribution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'remoteTasks' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'warning' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'localTasks' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'warning' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longestTasks' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'machineName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'durationPercentage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildPerformanceQuery, BuildPerformanceQueryVariables>;
export const BuildSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'buildSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Builds_BuildDetailsWhereInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildDetails' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'buildTarget' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workingDir' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ibVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildGroup' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'initiatorDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'initiatorLogLevel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorsNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'warningsNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sysErrorsNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sysWarningsNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isBuildCache' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCloudHelpers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPredictiveExecution' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildSummaryQuery, BuildSummaryQueryVariables>;
export const WorkloadsPageBuildsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'workloadsPageBuilds' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Builds_BuildsWhereInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licenseMetadata' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hasBuildCache' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'builds' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalFilteredCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'builds' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'buildId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'commandLine' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'initiatorName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'initiatorType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buildGroup' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buildResult' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buildType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'failReason' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'localTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'remoteTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cloudTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheTaskHits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheTaskMiss' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uncacheableTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxBusyHelpersCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'avgBusyHelpersCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxNeededHelpersCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'distributableTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'readyOverActiveRatio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'loggedOnUsers' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'loggingLevel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'agentDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasExtendedData' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkloadsPageBuildsQuery, WorkloadsPageBuildsQueryVariables>;
export const WorkloadsPageSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'workloadsPageSummary' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filterSummary' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Builds_SummaryWhereInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildsSummary' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filterSummary' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalBuilds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'successfulBuilds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqueInitiators' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'percentile50' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'percentile90' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkloadsPageSummaryQuery, WorkloadsPageSummaryQueryVariables>;
export const WorkloadsPageMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'workloadsPageMetadata' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filterMetadata' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Builds_BuildsMetadataWhereInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildsMetadata' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filterMetadata' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'buildGroups' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxDuration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'oldestBuildStartTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasBuildCache' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'initiatorTypes' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkloadsPageMetadataQuery, WorkloadsPageMetadataQueryVariables>;
export const WorkloadPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'workloadPage' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Builds_BuildsWhereInput' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ibManagerEntities' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'coordinatorId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinatorId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'builds' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalFilteredCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'builds' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'buildId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'commandLine' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'initiatorName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'initiatorType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buildGroup' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buildResult' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buildType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'failReason' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'localTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'remoteTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cloudTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheTaskHits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cacheTaskMiss' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uncacheableTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxBusyHelpersCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'avgBusyHelpersCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxNeededHelpersCores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'distributableTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'readyOverActiveRatio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'loggedOnUsers' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'loggingLevel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'agentDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasExtendedData' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkloadPageQuery, WorkloadPageQueryVariables>;
